"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClDesigner = void 0;
const tslib_1 = require("tslib");
const Utilities_1 = require("../../javascript/Utilities");
const ChecklistControls_1 = require("./ChecklistControls");
const Instance_1 = require("../../model/Instance");
class Checklist {
    constructor() {
        this.layout = [];
        this.collections = [];
    }
}
class Item {
    constructor() {
        this.propertiers = {};
        this.id = Utilities_1.synUtil.getGUID(true);
        this.externalid = this.id;
        this.show = true;
        this.visible = true;
    }
}
class CLLayoutItem extends Item {
    constructor() {
        super();
        this.type = "layoutitem";
        this.color = "rgba(0,0,0,1)";
        this.height = 10;
    }
}
class Page extends Item {
    constructor() {
        super();
        this.layout = [];
        this.labels = [];
        this.type = "page";
        this.backgroundcolor = "rgba(255,255,255,1)";
        this.helplabels = [];
    }
}
class Group extends Page {
    constructor() {
        super();
        this.layout = [];
        this.type = "group";
        this.bordercolor = "rgba(0,0,0,1)";
        this.backgroundcolor = "rgba(238,238,238,1)";
    }
}
class Field extends Item {
    constructor(controltype, datatype) {
        super();
        this.type = "field";
        this.multivalue = false;
        this.mandatory = false;
        this.readonly = false;
        this.controltype = controltype;
        this.datatype = datatype;
        this.labels = [];
        this.attachments = [];
        this.maxlength = 4000;
        this.maxwidth = 100;
        this.usebarcode = false;
        this.barcodetypes = [];
        this.variables = [];
        this.barcodecolumn;
        this.condition;
        this.barcoderegex;
        this.telnrcolumn;
        this.helplabels = [];
        if (controltype === "ImageView") {
            if (datatype === "StaticImage") {
                this.max = 1;
                this.min = 1;
            }
            else {
                this.max = 5;
                this.min = 0;
                this.attachmentsource = 1;
                this.aspectratio = "7:9";
                this.imageonly = true;
            }
        }
        if (controltype === "StaticText" || datatype === "StaticImage")
            this.layoutposition = "All";
        if (controltype === "TextArea")
            this.rowcount = 1;
        if (controltype === "ImageView" || controltype === "Radiobutton" || controltype === "Checkbox")
            this.colcount = 1;
        this.labelhorizontaloption = "Right";
        this.labelverticaloption = "Top";
        if (this.datatype === "Integer") {
            this.steps = 0;
        }
        else if (this.datatype === "Float") {
            this.steps = 2;
        }
    }
}
class ClDesigner {
    constructor(clControlFactory, checklist) {
        this.propertyMap = {};
        this.allLangIds = [];
        this.allCultureIds = [];
        this.showRelationsIconPressed = false;
        this.ControlDataTypeMap = {
            "List": ["field|List|MultipleChoice", "field|List|List", "field|List|Combobox"],
            "String": ["field|String|Input", "field|String|TextArea"],
            "Bool": ["field|Bool|Checkbox", "field|Bool|Switch"],
        };
        this.clControlFactory = clControlFactory;
        if ($.isEmptyObject(checklist))
            this.checklist = new Checklist();
        else
            this.checklist = checklist;
        this.clControlFactory.instance = this.checklist;
        this.selectedItems = [];
        this.clipboardItems = [];
    }
    getLabelForTypeDefinition(typedefinition) {
        let label = "";
        if (typedefinition) {
            switch (typedefinition) {
                case "field|String|Input":
                    label = Utilities_1.synUtil.Strings.getValue("clstringinputcontrol");
                    break;
                case "field|String|TextArea":
                    label = Utilities_1.synUtil.Strings.getValue("cltextareacontrol");
                    break;
                case "field|String|StaticText":
                    label = Utilities_1.synUtil.Strings.getValue("clstatictextcontrol");
                    break;
                case "field|Integer|Input":
                    label = Utilities_1.synUtil.Strings.getValue("clintinputcontrol");
                    break;
                case "field|Float|Input":
                    label = Utilities_1.synUtil.Strings.getValue("clfloatinputcontrol");
                    break;
                case "field|Time|Input":
                    label = Utilities_1.synUtil.Strings.getValue("cltimeinputcontrol");
                    break;
                case "field|Date|Input":
                    label = Utilities_1.synUtil.Strings.getValue("cldateinputcontrol");
                    break;
                case "field|Datetime|Input":
                    label = Utilities_1.synUtil.Strings.getValue("cldatetimeinputcontrol");
                    break;
                case "field|Bool|Switch":
                    label = Utilities_1.synUtil.Strings.getValue("clsswitchcontrol");
                    break;
                case "field|Bool|Checkbox":
                    label = Utilities_1.synUtil.Strings.getValue("clcheckboxcontrol");
                    break;
                case "field|List|List":
                    label = Utilities_1.synUtil.Strings.getValue("cllistcontrol");
                    break;
                case "field|List|Combobox":
                    label = Utilities_1.synUtil.Strings.getValue("clcomboboxcontrol");
                    break;
                case "field|StaticImage|ImageView":
                    label = Utilities_1.synUtil.Strings.getValue("clstaticattachmentcontrol");
                    break;
                case "field|EmbeddedImage|ImageView":
                    label = Utilities_1.synUtil.Strings.getValue("clembeddedattachmentcontrol");
                    break;
                case "group||":
                    label = Utilities_1.synUtil.Strings.getValue("clgroupcontrol");
                    break;
                case "page||":
                    label = Utilities_1.synUtil.Strings.getValue("clpagecontrol");
                    break;
                case "layoutitem||":
                    label = Utilities_1.synUtil.Strings.getValue("clhorizontallinecontrol");
                    break;
            }
        }
        return label;
    }
    create(configData, window, calledFromFatCient) {
        let that = this;
        that.clControlFactory.configData = configData;
        that.calledFromFatCient = calledFromFatCient;
        let createCallBack = function () {
            let templateColumn = $("#" + configData.designerTemplateColumn);
            let controlColumn = $("#" + configData.designerControlColumn);
            let fieldPropertiesColumn = $("#" + configData.designerFieldPropertiesColumn);
            let clPropertiesColumn = $("#" + configData.designerChecklistPropertiesColumn);
            let templateListContainer = $("<div style='width: 100%; height: calc(100% - 50px); overflow: auto'/>").appendTo(templateColumn);
            let templateList = $("<ul id='sortable_template_list' class='cltemplatelist'></ul>'").appendTo(templateListContainer);
            if ((that.clControlFactory.Mode & ChecklistControls_1.ChecklistMode.Questionnaire) === ChecklistControls_1.ChecklistMode.Questionnaire) {
                let multipChoice = $("<li class='cl_draggable templateControl' style='width:100%;'> <div id='" + configData.designerControlColumn + "_multiplechoice_dropable' draggable='true' class='_templateControl'>" + Utilities_1.synUtil.Strings.getValue("clmultiplechoicecontrol") + "</div></li>").appendTo(templateList).attr({ "type": "field", "controltype": "MultipleChoice", "datatype": "List", "clcontrolfactory": this, });
            }
            else {
                let stringInput = $("<li id='" + configData.designerControlColumn + "_stringinput_dropable_li' class='cl_draggable templateControl' style=''> <div id='" + configData.designerTemplateColumn + "_stringinput_dropable' draggable='true' class='_templateControl'>" + Utilities_1.synUtil.Strings.getValue("clstringinputcontrol") + "</div>").appendTo(templateList).attr({ "typedefinition": "field|String|Input", "type": "field", "controltype": "Input", "datatype": "String" });
                let textArea = $("<li id='" + configData.designerTemplateColumn + "_textarea_dropable_li' class='cl_draggable templateControl' style=''> <div id='" + configData.designerTemplateColumn + "_textarea_dropable' draggable='true' class='_templateControl'>" + Utilities_1.synUtil.Strings.getValue("cltextareacontrol") + "</div></li>").appendTo(templateList).attr({ "typedefinition": "field|String|TextArea", "type": "field", "controltype": "TextArea", "datatype": "String", "clcontrolfactory": this, });
                let staticText = $("<li id='" + configData.designerTemplateColumn + "_statictext_dropable_li' class='cl_draggable templateControl' style=''> <div id='" + configData.designerTemplateColumn + "_statictext_dropable' draggable='true' class='_templateControl'>" + Utilities_1.synUtil.Strings.getValue("clstatictextcontrol") + "</div></li>").appendTo(templateList).attr({ "typedefinition": "field|String|StaticText", "type": "field", "controltype": "StaticText", "datatype": "String", "clcontrolfactory": this, });
                let intInput = $("<li id='" + configData.designerTemplateColumn + "_intinput_dropable_li' class='cl_draggable templateControl' style=''> <div id='" + configData.designerTemplateColumn + "_intinput_dropable' draggable='true' class='_templateControl'>" + Utilities_1.synUtil.Strings.getValue("clintinputcontrol") + "</div></li>").appendTo(templateList).attr({ "typedefinition": "field|Integer|Input", "type": "field", "controltype": "Input", "datatype": "Integer", "clcontrolfactory": this, });
                let floatInput = $("<li id='" + configData.designerTemplateColumn + "_floatinput_dropable_li'class='cl_draggable templateControl' style=''> <div id='" + configData.designerTemplateColumn + "_floatinput_dropable' draggable='true' class='_templateControl'>" + Utilities_1.synUtil.Strings.getValue("clfloatinputcontrol") + "</div></li>").appendTo(templateList).attr({ "typedefinition": "field|Float|Input", "type": "field", "controltype": "Input", "datatype": "Float", "clcontrolfactory": this, });
                let timeInput = $("<li id='" + configData.designerTemplateColumn + "_timeinput_dropable_li' class='cl_draggable templateControl' style=''> <div id='" + configData.designerTemplateColumn + "_timeinput_dropable' draggable='true' class='_templateControl'>" + Utilities_1.synUtil.Strings.getValue("cltimeinputcontrol") + "</div></li>").appendTo(templateList).attr({ "typedefinition": "field|Time|Input", "type": "field", "controltype": "Input", "datatype": "Time", "clcontrolfactory": this, });
                let dateInput = $("<li id='" + configData.designerTemplateColumn + "_dateinput_dropable_li' class='cl_draggable templateControl' style='margin-bottom:20px !important;'> <div id='" + configData.designerTemplateColumn + "_dateinput_dropable' draggable='true' class='_templateControl'>" + Utilities_1.synUtil.Strings.getValue("cldateinputcontrol") + "</div></li>").appendTo(templateList).attr({ "typedefinition": "field|Date|Input", "type": "field", "controltype": "Input", "datatype": "Date", "clcontrolfactory": this, });
                let dateTimeInput = $("<li id='" + configData.designerTemplateColumn + "_datetimeinput_dropable_li' class='cl_draggable templateControl' style='margin-bottom:20px !important;'> <div id='" + configData.designerTemplateColumn + "_datetimeinput_dropable' draggable='true' class='_templateControl'>" + Utilities_1.synUtil.Strings.getValue("cldatetimeinputcontrol") + "</div></li>").appendTo(templateList).attr({ "typedefinition": "field|Datetime|Input", "type": "field", "controltype": "Input", "datatype": "Datetime", "clcontrolfactory": this, });
                let switchField = $("<li id='" + configData.designerTemplateColumn + "_switch_dropable_li' class='cl_draggable templateControl' style=''> <div id='" + configData.designerTemplateColumn + "_switch_dropable' draggable='true' class='_templateControl'>" + Utilities_1.synUtil.Strings.getValue("clsswitchcontrol") + "</div></li>").appendTo(templateList).attr({ "typedefinition": "field|Bool|Switch", "type": "field", "controltype": "Switch", "datatype": "Bool", "clcontrolfactory": this, });
                let checkList = $("<li id='" + configData.designerTemplateColumn + "_checkbox_dropable_li' class='cl_draggable templateControl' style=''> <div id='" + configData.designerTemplateColumn + "_checkbox_dropable' draggable='true' class='_templateControl'>" + Utilities_1.synUtil.Strings.getValue("clcheckboxcontrol") + "</div></li>").appendTo(templateList).attr({ "typedefinition": "field|Bool|Checkbox", "type": "field", "controltype": "Checkbox", "datatype": "Bool", "clcontrolfactory": this, });
                let radioButton = $("<li id='" + configData.designerTemplateColumn + "_radiobutton_dropable_li' class='cl_draggable templateControl' style='margin-bottom:20px;'> <div id='" + configData.designerTemplateColumn + "_radiobutton_dropable' draggable='true' class='_templateControl'>" + Utilities_1.synUtil.Strings.getValue("cllistcontrol") + "</div></li>").appendTo(templateList).attr({ "typedefinition": "field|List|List", "type": "field", "controltype": "Radiobutton", "datatype": "List", "clcontrolfactory": this, });
                let comboBox = $("<li id='" + configData.designerTemplateColumn + "_combobox_dropable_li' class='cl_draggable templateControl' style='margin-bottom:20px;'> <div id='" + configData.designerTemplateColumn + "_combobox_dropable' draggable='true' class='_templateControl'>" + Utilities_1.synUtil.Strings.getValue("clcomboboxcontrol") + "</div></li>").appendTo(templateList).attr({ "typedefinition": "field|List|Combobox", "type": "field", "controltype": "Combobox", "datatype": "List", "clcontrolfactory": this, });
                let staticAttachment = $("<li id='" + configData.designerTemplateColumn + "_staticattachment_dropable_li' class='cl_draggable templateControl' style='margin-bottom:20px;'> <div id='" + configData.designerTemplateColumn + "_staticattachment_dropable' draggable='true' class='_templateControl'>" + Utilities_1.synUtil.Strings.getValue("clstaticattachmentcontrol") + "</div></li>").appendTo(templateList).attr({ "typedefinition": "field|StaticImage|ImageView", "type": "field", "controltype": "ImageView", "datatype": "StaticImage", "clcontrolfactory": this, });
                let embeddedAttachment = $("<li id='" + configData.designerTemplateColumn + "_embeddedattachment_dropable_li' class='cl_draggable templateControl' style='margin-bottom:20px;'> <div id='" + configData.designerTemplateColumn + "_embeddedattachment_dropable' draggable='true' class='_templateControl'>" + Utilities_1.synUtil.Strings.getValue("clembeddedattachmentcontrol") + "</div></li>").appendTo(templateList).attr({ "typedefinition": "field|EmbeddedImage|ImageView", "type": "field", "controltype": "ImageView", "datatype": "EmbeddedImage", "clcontrolfactory": this, });
                let group = $("<li id='" + configData.designerTemplateColumn + "_group_dropable_li' class='cl_draggable templateControl' style=''> <div id='" + configData.designerTemplateColumn + "_group_dropable' draggable='true' class='_templateControl'>" + Utilities_1.synUtil.Strings.getValue("clgroupcontrol") + "</div></li>").appendTo(templateList).attr({ "typedefinition": "group||", "type": "group", "clcontrolfactory": this, });
                let page = $("<li id='" + configData.designerTemplateColumn + "_page_dropable_li' class='cl_draggable templateControl clPage' style=''> <div id='" + configData.designerTemplateColumn + "_page_dropable' draggable='true' class='_templateControl'>" + Utilities_1.synUtil.Strings.getValue("clpagecontrol") + "</div></li>").appendTo(templateList).attr({ "typedefinition": "page||", "type": "page", "clcontrolfactory": this, });
                let horizontalLine = $("<li id='" + configData.designerTemplateColumn + "_horizontalline_dropable_li' class='cl_draggable templateControl' style=''> <div id='" + configData.designerTemplateColumn + "_horizontalline_dropable' draggable='true' class='_templateControl'>" + Utilities_1.synUtil.Strings.getValue("clhorizontallinecontrol") + "</div></li>").appendTo(templateList).attr({ "typedefinition": "layoutitem||", "type": "layoutitem", "clcontrolfactory": this, "layouttype": "HorizontalLine", });
                let multipChoice = $("<li id='" + configData.designerTemplateColumn + "_multiplechoice_dropable_li' class='cl_draggable templateControl' style='margin-bottom:20px;'> <div id='" + configData.designerTemplateColumn + "_multiplechoice_dropable' draggable='true' class='_templateControl'>" + Utilities_1.synUtil.Strings.getValue("clmultiplechoicecontrol") + "</div></li>").appendTo(templateList).attr({ "typedefinition": "field|List|MultipleChoice", "type": "field", "controltype": "MultipleChoice", "datatype": "List", "clcontrolfactory": this, });
            }
            $("#" + configData.designerlLayout).css("border-style", "solid");
            $("#" + configData.designerlLayout).css("border-color", "#245c86");
            $("#" + configData.designerlLayout).kendoSplitter({
                orientation: "horizontal",
                panes: [{ size: "25%" }, { size: "50%" }, { size: "25%" }],
            });
            $("#" + configData.designerPropertySplitter).kendoSplitter({
                orientation: "vertical",
                panes: [
                    {
                        resizable: true,
                        size: "35%",
                    },
                    {
                        resizable: true,
                    }
                ]
            });
            let previewListContainer = $("<div id='cl_preview_layout_container' class='cl_previewlist' style='display:inline-block; width: 100%;z-index:1001;list-style: none;'/>").appendTo(controlColumn);
            that.menu = $("<ul id='cldesigner_menu' > </ul>").appendTo(previewListContainer);
            $("<li claction='clcopy'><img alt src='assets/checklist/copy_16x16.png'/> </li>").appendTo(that.menu);
            $("<li claction='clpaste'><img alt src='assets/checklist/paste_16x16.png'/> </li>").appendTo(that.menu);
            $("<li claction='clcut'><img alt src='assets/checklist/cut_16x16.png'/> </li>").appendTo(that.menu);
            $("<li claction='clpreview'><img alt src='assets/checklist/preview_16x16.png'/> </li>").appendTo(that.menu);
            $("<li class='k-separator' />").appendTo(that.menu);
            $("<li claction='clshowrelations' clmenutype='button' class='buttonMenu' ><i class='fa fa-link'/> </li>").appendTo(that.menu);
            that.helpToolbarItem = $("<li claction='clhelp' style='float:right;display:none'><img alt src='assets/checklist/help_16x16.png'/> </li>").appendTo(that.menu);
            that.menu.kendoMenu({
                select(e) {
                    let action = e.item.attributes.getNamedItem("claction").value;
                    let type;
                    if (e.item.attributes.getNamedItem("clmenutype"))
                        type = e.item.attributes.getNamedItem("clmenutype").value;
                    if (type === "button")
                        $(e.item).toggleClass("activeMenuEntry");
                    switch (action) {
                        case "clshowrelations":
                            that.showRelationsIconPressed = !that.showRelationsIconPressed;
                            break;
                    }
                    $("#cl_preview_layout").trigger(action);
                },
            });
            that.menu.on("click", function (e) {
                e.stopPropagation();
            });
            let previewList = $("<ul id='cl_preview_layout' class='cl_sortable clLayout' tabindex='-1' />");
            let firstElem = $("<li id='cl_preview_layout_first' class='cl_draggable previewControl disabled cldummyListElement' />").appendTo(previewList);
            $("#sortable_template_list").kendoSortable({
                autoScroll: true,
                hint(element) {
                    let hint = $("<div class='templatehint'>" + that.getTypeDefinitionLabel(element.attr("typedefinition")) + "</div>");
                    hint.css("width", element.width());
                    return hint;
                },
                placeholder(element) {
                    return element.clone().addClass("placeholder").text(Utilities_1.synUtil.Strings.getValue("cllisteditordroplabel"));
                },
                end: (e) => {
                    $("#cl_preview_layout").find(".previewControl").addClass("cl_hoverable");
                    $("#sortable_template_list").children("li").addClass("cl_draggable");
                    if (e.newIndex !== -1 || e.oldIndex !== -1)
                        e.preventDefault();
                },
                start: (e) => {
                    $("#cl_preview_layout").find(".previewControl").removeClass("cl_hoverable");
                    $("#sortable_template_list").children("li").removeClass("cl_draggable");
                    that.selectedDragElements = that.getSelectedItems(e.item);
                    that.limitDropZones(e.draggableEvent, e.item);
                },
                ignore: "li",
                move: (e) => {
                    e.preventDefault();
                    that.limitDropZones(e.draggableEvent, e.item);
                },
                change: (e) => {
                    e.preventDefault();
                },
                cancel: (e) => {
                    $("#cl_preview_layout").find(".previewControl").addClass("cl_hoverable");
                    $("#sortable_template_list").children("li").addClass("cl_draggable");
                },
                filter: ".cl_draggable",
                connectWith: "#cl_preview_layout",
            });
            let cl_preview_layout = previewList.kendoSortable({
                autoScroll: true,
                disabled: ".disabled",
                hint(element) {
                    let selectedItems = that.getSelectedItems(element);
                    let hintLabel = "";
                    let width;
                    $.each(selectedItems, (idx, elem) => {
                        if (!width)
                            width = $(elem).width();
                        let itemId = $(elem).attr("cl_itemid");
                        let item = that.clControlFactory.getItemById(itemId);
                        if (item) {
                            hintLabel += that.getTypeDefinitionLabel(item["typedefinition"]);
                            if (item["labels"]) {
                                let label = that.clControlFactory.getLabelText(item.labels, that.clControlFactory.userUILangId, that.checklist["langid"]);
                                if (label)
                                    hintLabel += ": " + label;
                            }
                            hintLabel += "<br>";
                        }
                    });
                    let hint = $("<div class='templatehint'>" + hintLabel + "</div>");
                    if (width)
                        hint.css("width", width);
                    return hint;
                },
                placeholder(element) {
                    let itemId = element.attr("cl_itemid");
                    let item = that.clControlFactory.getItemById(itemId);
                    if (item && item["type"] === "field" && (item["controltype"] === "Radiobutton" || item["controltype"] === "MultipleChoice")) {
                        $("#" + itemId + " input").attr("name", itemId + "_" + Utilities_1.synUtil.getGUID(true));
                    }
                    return element.clone().addClass("placeholder templateControl").text(Utilities_1.synUtil.Strings.getValue("cllisteditordroplabel"));
                },
                start: (e) => {
                    that.selectedDragElements = that.getSelectedItems(e.item);
                    that.selectedDragElements.hide();
                    e.item.parents("li.previewControl").removeClass("cl_draggable");
                    $("#cl_preview_layout").find(".previewControl").removeClass("cl_hoverable");
                    e.item.removeClass("cl_hoverable");
                    that.limitDropZones(e.draggableEvent, e.item);
                    if (e.sender["placeholder"])
                        e.sender["placeholder"].removeClass("cl_hoverable");
                },
                move: (e) => {
                    that.limitDropZones(e.draggableEvent, e.item);
                    e.target.parents("li.previewControl").removeClass("cl_draggable");
                },
                filter: ".cl_draggable",
                ignore: "input, textarea, .attachmentdragable, .attachmentitem, .cl_lightbox",
                change: (e) => {
                },
                end: (e) => {
                    $("li.previewControl").addClass("cl_draggable");
                    $("#cl_preview_layout").find(".previewControl").addClass("cl_hoverable");
                    if (e.action === "receive" && e.item.hasClass("templateControl")) {
                        e.preventDefault();
                        let item;
                        let groupId;
                        let placeholder = $("#cl_preview_layout").find("li.placeholder");
                        if (!placeholder)
                            placeholder = $("#cl_preview_layout").find("li.placeholder");
                        if (placeholder) {
                            let placeholderparent = placeholder.parent();
                            if (placeholderparent) {
                                groupId = placeholderparent.attr("cl_group");
                            }
                            if (groupId) {
                                let group = that.clControlFactory.getItemById(groupId);
                                let prevElem = placeholder.prev();
                                $.each(e.item, (idx, value) => {
                                    let type = value.getAttribute("type");
                                    let controltype;
                                    let datatype;
                                    let layouttype;
                                    let bInsert = true;
                                    if (type === "field") {
                                        controltype = value.getAttribute("controltype");
                                        datatype = value.getAttribute("datatype");
                                        bInsert = that.fieldCanBeInserted(controltype);
                                    }
                                    else if (type === "layoutitem")
                                        layouttype = value.getAttribute("layouttype");
                                    if (bInsert) {
                                        item = that.addControlToPreview(type, controltype, datatype, layouttype, placeholder, groupId);
                                        if (item) {
                                            if (prevElem && prevElem.length === 1) {
                                                let prevItemId = prevElem.attr("cl_itemid");
                                                if (prevItemId)
                                                    that.clControlFactory.insertItemToLayoutAfter(item, prevItemId, groupId);
                                                else {
                                                    // case prevobject is non visible elem in group
                                                    prevElem = prevElem.prev();
                                                    if (prevElem && prevElem.length === 1)
                                                        that.clControlFactory.insertItemToLayoutAfter(item, prevElem.attr("cl_itemid"), groupId);
                                                    else {
                                                        item.parentid = groupId;
                                                        group.layout.splice(0, 0, item);
                                                    }
                                                }
                                            }
                                            else {
                                                item.parentid = groupId;
                                                group.layout.splice(0, 0, item);
                                            }
                                        }
                                    }
                                });
                                that.setFirstAndLastDummy("cl_preview_layout_" + groupId);
                            }
                            else {
                                let prevElem = placeholder.prev();
                                let controltype;
                                let datatype;
                                let layouttype;
                                let bInsert = true;
                                $.each(e.item, (idx, value) => {
                                    let type = value.getAttribute("type");
                                    item = undefined;
                                    if (type === "field") {
                                        controltype = value.getAttribute("controltype");
                                        datatype = value.getAttribute("datatype");
                                        bInsert = that.fieldCanBeInserted(controltype);
                                    }
                                    else if (type === "layoutitem")
                                        layouttype = value.getAttribute("layouttype");
                                    if (bInsert) {
                                        item = that.addControlToPreview(type, controltype, datatype, layouttype, placeholder, groupId);
                                        if (item) {
                                            if (prevElem && prevElem.length === 1) {
                                                let prevItemId = prevElem.attr("cl_itemid");
                                                if (prevItemId)
                                                    that.clControlFactory.insertItemToLayoutAfter(item, prevItemId, undefined);
                                                else {
                                                    // case prevobject is non visible elem in group
                                                    prevElem = prevElem.prev();
                                                    if (prevElem && prevElem.length === 1)
                                                        that.clControlFactory.insertItemToLayoutAfter(item, prevElem.attr("cl_itemid"), undefined);
                                                    else {
                                                        item.parentid = undefined;
                                                        that.checklist.layout.splice(0, 0, item);
                                                    }
                                                }
                                            }
                                            else {
                                                item.parentid = groupId;
                                                that.checklist.layout.splice(0, 0, item);
                                            }
                                        }
                                    }
                                });
                                that.setFirstAndLastDummy("cl_preview_layout");
                            }
                        }
                        if (item) {
                            that.updateProperties([item]);
                            if (item.type === "page")
                                that.updateItemsInfo(that.checklist.layout, false);
                            else
                                that.updateItemsInfo([item]);
                        }
                    }
                    else if (e.action === "sort") {
                        e.preventDefault();
                        let selItems = that.selectedDragElements;
                        let placeholder = e.sender["placeholder"];
                        selItems.insertAfter(placeholder).show();
                        for (let idx = selItems.length - 1; idx >= 0; --idx) {
                            let tmpItem = selItems[idx];
                            let newItem = $(tmpItem);
                            let updateLayout = true;
                            let itemId = newItem.attr("cl_itemid");
                            let itemGroupId = newItem.attr("cl_group");
                            let oldGroupId = newItem.attr("cl_group");
                            if (!placeholder)
                                placeholder = $("#cl_preview_layout").find("li.placeholder");
                            let newGroupId = placeholder.parent().attr("cl_group");
                            if (e.newIndex === e.oldIndex) {
                                let oldparent = newItem.parent();
                                let newparent = placeholder.parent();
                                newItem.insertAfter(placeholder);
                            }
                            // insert into layout
                            // getItem
                            let item = that.clControlFactory.getItemById(itemId);
                            // remove item from layout
                            that.clControlFactory.removeItemFromLayout(that.clControlFactory.instance.layout, itemId);
                            if (item["type"] === "field" && (item["controltype"] === "Radiobutton" || item["controltype"] === "MultipleChoice")) {
                                newItem.find("#" + itemId + " input").attr("name", itemId);
                                let control;
                                if (item["controltype"] === "Radiobutton") {
                                    control = that.clControlFactory.getFieldControl(itemId);
                                    control.setValue(item["value"]);
                                }
                                else if (item["controltype"] === "MultipleChoice") {
                                    control = that.clControlFactory.getFieldControl(itemId);
                                    control.setValue(item["correctvalues"]);
                                }
                            }
                            let control = that.clControlFactory.getFieldControl(itemId);
                            if (newGroupId) {
                                let prevElem = placeholder.prev();
                                let group = that.clControlFactory.getItemById(newGroupId);
                                newItem.attr("cl_group", newGroupId);
                                if (item) {
                                    if (prevElem && prevElem.length === 1) {
                                        let prevItemId = prevElem.attr("cl_itemid");
                                        if (prevItemId)
                                            that.clControlFactory.insertItemToLayoutAfter(item, prevItemId, newGroupId);
                                        else {
                                            // case prevobject is non visible elem in group
                                            prevElem = prevElem.prev();
                                            if (prevElem && prevElem.length === 1)
                                                that.clControlFactory.insertItemToLayoutAfter(item, prevElem.attr("cl_itemid"), newGroupId);
                                            else {
                                                item.parentid = newGroupId;
                                                group.layout.splice(0, 0, item);
                                            }
                                        }
                                    }
                                    else {
                                        item.parentid = newGroupId;
                                        group.layout.splice(0, 0, item);
                                    }
                                }
                                that.setFirstAndLastDummy("cl_preview_layout_" + newGroupId);
                            }
                            else {
                                let prevElem = placeholder.prev();
                                newItem.removeAttr("cl_group");
                                if (item) {
                                    if (prevElem && prevElem.length === 1) {
                                        let prevItemId = prevElem.attr("cl_itemid");
                                        if (prevItemId)
                                            that.clControlFactory.insertItemToLayoutAfter(item, prevItemId, newGroupId);
                                        else {
                                            prevElem = prevElem.prev();
                                            if (prevElem && prevElem.length === 1)
                                                that.clControlFactory.insertItemToLayoutAfter(item, prevElem.attr("cl_itemid"), undefined);
                                            else {
                                                item.parentid = undefined;
                                                that.checklist.layout.splice(0, 0, item);
                                            }
                                        }
                                    }
                                    else {
                                        item.parentid = undefined;
                                        that.checklist.layout.splice(0, 0, item);
                                    }
                                }
                                that.setFirstAndLastDummy("cl_preview_layout");
                            }
                            if (item)
                                that.updateItemsInfo([item], false);
                        }
                    }
                    that.clControlFactory.resetOrder();
                    that.clControlFactory.setChecklistChanged(true);
                },
            }).data("kendoSortable");
            let clPropControlContainer = $("<div style='box-sizing:border-box; border-collapse: collapse; width: 100%;'/>").appendTo(clPropertiesColumn);
            // checklist Properties
            that.createChecklistProperties(clPropControlContainer);
            // Init checklist
            if (that.checklist.layout && that.checklist.layout.length > 0) {
                $.each(that.checklist.layout, (idx, value) => {
                    that.addItemToLayout(value, previewList, 0);
                });
                that.updateItemsInfo(that.checklist.layout);
                that.clControlFactory.setRelationBetweenFields();
                that.clControlFactory.setInitialConditionRelationBetweenFields();
            }
            that.setHelpToolbarItem();
            previewList.appendTo(previewListContainer);
            $("#cl_preview_layout").focus();
            let lastElem = $("<li id='cl_preview_layout_last'  class='cl_draggable previewControl disabled cldummyListElement' />").appendTo(previewList);
            let fieldPropControlContainer = $("<div style='height:calc(100% - 50px); box-sizing:border-box; overflow-y:scroll; width: 100%; border-collapse: collapse; overflow:auto;'/>").appendTo(fieldPropertiesColumn);
            // field property
            that.createFieldProperties(fieldPropControlContainer);
            function copyItems() {
                let selectedItems = $("#cl_preview_layout").find(".cl_draggable.previewControl.highlightControl").filter(function () {
                    return $(this).parents(".cl_draggable.previewControl.highlightControl").length === 0;
                });
                let itemsToCopy = [];
                $.each(selectedItems, (idx, item) => {
                    let itemId = item.getAttribute("cl_itemid");
                    let currentItem = that.clControlFactory.getItemById(itemId);
                    // check if item already in list
                    if (!that.checkIfItemAlreadyInCopyList(itemsToCopy, currentItem))
                        itemsToCopy.push(currentItem); // add already selected item
                });
                if (itemsToCopy.length > 0)
                    that.clipboardItems = $.extend(true, [], itemsToCopy);
                else
                    that.clipboardItems.splice(0);
            }
            $("#cl_preview_layout").on("clcontrolchange", function (e, item) {
                that.updateItemsInfo([item]);
            });
            $("#cl_preview_layout").on("clcopy", function (e) {
                that.lastCPCommand = "clcopy";
                copyItems();
                Utilities_1.synUtil.Notifications.success(Utilities_1.synUtil.Strings.getValue("clcopynotification"));
            });
            $("#cl_preview_layout").on("clcut", function (e) {
                that.lastCPCommand = "clcut";
                copyItems();
                let elemToFocus;
                let lastItem;
                // Get element to focus
                if (that.clipboardItems && that.clipboardItems.length > 0) {
                    let firstItem = that.clipboardItems[0];
                    if (that.clipboardItems.length > 1)
                        lastItem = that.clipboardItems[that.clipboardItems.length - 1];
                    else
                        lastItem = firstItem;
                    let firstDomElem = $(".cl_draggable.previewControl[cl_itemid=" + firstItem.id + "]");
                    let lastDomElem = $(".cl_draggable.previewControl[cl_itemid=" + firstItem.id + "]");
                    let nextElem = lastDomElem.next(".cl_draggable.previewControl").not(".disabled, .highlightControl");
                    if (nextElem.length === 0) {
                        let prevElem = firstDomElem.prev(".cl_draggable.previewControl").not(".disabled, .highlightControl");
                        if (prevElem.length === 0)
                            elemToFocus = $("#cl_preview_layout");
                        else
                            elemToFocus = prevElem;
                    }
                    else
                        elemToFocus = nextElem;
                    $.each(that.clipboardItems, (idx, item) => {
                        if (item["condition"]) {
                            let tmpControl = that.clControlFactory.getFieldControl(item.id);
                            if (tmpControl) {
                                if (tmpControl.ConditionParentFields && tmpControl.ConditionParentFields.length > 0) {
                                    $.each(tmpControl.ConditionParentFields, (idx2, parentControl) => {
                                        if (parentControl) {
                                            parentControl.ConditionChildFields = parentControl.ConditionChildFields.filter(elem => elem.field.id !== item.id);
                                        }
                                    });
                                }
                            }
                        }
                        that.clControlFactory.removeItem(item.id);
                    });
                    // Check linkedfield
                    $.each(that.clipboardItems, (idx, item) => {
                        if (item["linkedfield"]) {
                        }
                    });
                }
                else
                    elemToFocus = $("#cl_preview_layout");
                that.updatePropertiesAfterRemove();
                that.clControlFactory.setChecklistChanged(true);
                Utilities_1.synUtil.Notifications.success(Utilities_1.synUtil.Strings.getValue("clcutnotification"));
                if (elemToFocus)
                    elemToFocus.focus();
            });
            $("#cl_preview_layout").on("clpaste", function (e) {
                let deleteClipboard = false;
                if (that.lastCPCommand === "clcut")
                    deleteClipboard = true;
                that.lastCPCommand = "clpaste";
                let selectedItems = $("#cl_preview_layout").find(".cl_draggable.previewControl.highlightControl");
                let elementToInsertAfter;
                if (selectedItems && selectedItems.length > 0) {
                    elementToInsertAfter = selectedItems[selectedItems.length - 1];
                }
                else {
                    let layoutItems = $("#cl_preview_layout").find(".cl_draggable.previewControl");
                    if (layoutItems && layoutItems.length > 0) {
                        for (let idx = layoutItems.length - 1; idx > 0; idx--) {
                            let elem = layoutItems[idx];
                            if (!$(elem).hasClass("cldummyListElement")) {
                                elementToInsertAfter = elem;
                                break;
                            }
                        }
                    }
                }
                let allowed = true;
                if (elementToInsertAfter) {
                    let groupId = elementToInsertAfter.getAttribute("cl_group");
                    // Check if copy is allowed
                    if (groupId) {
                        $.each(that.clipboardItems, (idx, newItem) => {
                            if (newItem.type === "page")
                                allowed = false;
                        });
                    }
                    if (allowed) {
                        let externalIdMap = [];
                        let relevantIds = [];
                        let linkedFieldsMap = [];
                        let linkedFieldsIds = [];
                        let idMap = [];
                        for (let idx = that.clipboardItems.length - 1; idx >= 0; --idx) {
                            let newItem = that.clipboardItems[idx];
                            let res = that.copyItemToLayout(newItem, $(elementToInsertAfter), groupId, false, !deleteClipboard);
                            externalIdMap = externalIdMap.concat(res.exIdMap);
                            relevantIds = relevantIds.concat(res.idList);
                            linkedFieldsMap = linkedFieldsMap.concat(res.linkedFieldsMap);
                            linkedFieldsIds = linkedFieldsIds.concat(res.linkedFieldsIds);
                            idMap = idMap.concat(res.idMap);
                        }
                        $.each(relevantIds, (idx, tmpId) => {
                            let item = that.clControlFactory.getItemById(tmpId);
                            if (item.condition) {
                                let control = that.clControlFactory.getFieldControl(tmpId);
                                $.each(externalIdMap, (idx, exIdMap) => {
                                    item.condition = item.condition.replace(exIdMap.oldId, exIdMap.newId);
                                    let parentControl = control.ConditionParentFields.find(_control => _control.field.id === exIdMap.oldId);
                                    if (parentControl) {
                                        parentControl.ConditionChildFields = parentControl.ConditionChildFields.filter(elem => elem.field.id !== item.id);
                                        control.ConditionParentFields = control.ConditionParentFields.filter(elem => elem.field.id !== parentControl.field.id);
                                    }
                                });
                                that.clControlFactory.setConditionRelationBetweenFields([control]);
                            }
                        });
                        if (linkedFieldsIds.length > 0) {
                            if (deleteClipboard) { // cut
                                if (linkedFieldsIds.length > 0 && linkedFieldsMap.length > 0) {
                                    $.each(that.clControlFactory.Fields(), (idx, item) => {
                                        if (item.linkedfield) {
                                            $.each(linkedFieldsMap, (idx, linkedFieldMap) => {
                                                item.linkedfield = item.linkedfield.replace(linkedFieldMap.oldId, linkedFieldMap.newId);
                                            });
                                        }
                                    });
                                }
                            }
                            else {
                                if (linkedFieldsIds.length === 1 && linkedFieldsMap.length === 1) { // only parentfield selected
                                    let item = that.clControlFactory.getItemById(linkedFieldsIds[0]);
                                    item.linkedfield = undefined;
                                }
                                else {
                                    $.each(linkedFieldsIds, (idx, tmpId) => {
                                        let item = that.clControlFactory.getItemById(tmpId);
                                        if (item.linkedfield) {
                                            $.each(linkedFieldsMap, (idx, linkedFieldMap) => {
                                                item.linkedfield = item.linkedfield.replace(linkedFieldMap.oldId, linkedFieldMap.newId);
                                            });
                                        }
                                    });
                                }
                            }
                        }
                        $.each(idMap, (idx, idTuple) => {
                            let item = that.clControlFactory.getItemById(idTuple.newId);
                            if (item.dependentfield) {
                                // Check if parent is in list too
                                if (deleteClipboard) { // cut
                                }
                                else {
                                    let tuple = idMap.find(_tuple => _tuple.oldId === item.dependentfield);
                                    if (tuple) {
                                        item.dependentfield = tuple.newId;
                                    }
                                }
                            }
                        });
                        that.clControlFactory.resetOrder();
                        that.clControlFactory.setRelationBetweenFields();
                    }
                    else
                        Utilities_1.synUtil.Notifications.error(Utilities_1.synUtil.Strings.getValue("clpastenotallowednotification"));
                }
                if (allowed)
                    Utilities_1.synUtil.Notifications.warning(Utilities_1.synUtil.Strings.getValue("clpastenotification"));
                that.clControlFactory.setChecklistChanged(true);
                that.updateItemsInfo(that.checklist.layout);
                if (deleteClipboard)
                    that.clipboardItems.splice(0);
            });
            $("#cl_preview_layout").on("clpreview", function (e) {
                let instance = that.getChecklist();
                if (instance) {
                    let copyInstance = $.extend(true, {}, instance);
                    that.ChangeIdsForPreview(copyInstance);
                    Utilities_1.synUtil.beginAjaxProgress();
                    let windowData = Utilities_1.synUtil.popupWindow({
                        title: "Checklist",
                        actions: ["Maximize", "Close"],
                        width: 1024,
                        height: 768,
                        resizable: true,
                        modal: true,
                        synDesktopAware: false
                    });
                    let windowId = "content_popup_" + windowData.guid;
                    let clContainer = $("<div class='clParent' />").appendTo($("#" + windowId));
                    let checklistPane = clContainer;
                    checklistPane.synChecklist();
                    checklistPane.synChecklist("setInstance", copyInstance, undefined, ChecklistControls_1.ChecklistMode.Editor | ChecklistControls_1.ChecklistMode.Preview, false, undefined);
                    Utilities_1.synUtil.endAjaxProgress();
                }
            });
            $("#cl_preview_layout").on("clshowrelations", function (e) {
                that.showConditionIcons();
                that.showLinkedFieldsIcons();
                that.showDependentFieldsIcons();
            });
            $("#cl_preview_layout").on("clhelp", function (e) {
                that.clControlFactory.helpButtonChecked = !that.clControlFactory.helpButtonChecked;
                if (that.clControlFactory.helpButtonChecked)
                    $("#cl_preview_layout").find(".checklisthelplabelcolumn").addClass("highlightHelpLabel");
                else
                    $("#cl_preview_layout").find(".checklisthelplabelcolumn").removeClass("highlightHelpLabel");
            });
            $("#" + configData.designerControlColumn).on("click", function (e) {
                that.dismissSelectedItems();
            });
            $("#" + configData.designerTemplateColumn).on("click", function (e) {
                that.dismissSelectedItems();
            });
            $("#cl_preview_layout").on("click", ".cl_del_icon", function (e) {
                e.stopPropagation();
                let itemId = e.target.parentElement.getAttribute("cl_itemid");
                if (itemId) {
                    let item = that.clControlFactory.getItemById(itemId);
                    let deleteItem = true;
                    if (item && item["linkedfield"] && item["linkedfield"] === item["id"]) {
                        deleteItem = confirm(Utilities_1.synUtil.Strings.getValue("clconfirmdeleteparentfield"));
                    }
                    if (deleteItem) {
                        if (item.condition) {
                            let tmpControl = that.clControlFactory.getFieldControl(itemId);
                            if (tmpControl) {
                                if (tmpControl.ConditionParentFields && tmpControl.ConditionParentFields.length > 0) {
                                    $.each(tmpControl.ConditionParentFields, (idx2, parentControl) => {
                                        if (parentControl) {
                                            parentControl.ConditionChildFields = parentControl.ConditionChildFields.filter(elem => elem.field.id !== itemId);
                                        }
                                    });
                                }
                            }
                        }
                        that.clControlFactory.removeItem(itemId);
                        if (item && item["linkedfield"]) {
                            if (item["linkedfield"] === item["id"]) {
                                $.each(that.clControlFactory.GetLinkedFields(item["linkedfield"]), (idx, linkedField) => {
                                    linkedField["linkedfield"] = undefined;
                                });
                            }
                            else {
                                let linkedFields = that.clControlFactory.GetLinkedFields(item["linkedfield"]);
                                if (linkedFields && linkedFields.length === 1 && linkedFields[0]["id"] === item["linkedfield"]) {
                                    linkedFields[0]["linkedfield"] = undefined;
                                }
                            }
                        }
                        that.updatePropertiesAfterRemove();
                        that.clControlFactory.setChecklistChanged(true);
                    }
                }
            });
            $("#cl_preview_layout").on("click", ".conditionIcon", function (e) {
                e.stopPropagation();
                let itemId = e.target.parentElement.parentElement.parentElement.getAttribute("cl_itemid");
                if (itemId) {
                    let control = that.clControlFactory.getFieldControl(itemId);
                    if (control.ConditionChildFields.length > 0) {
                        that.selectedItem = undefined;
                        that.selectedItems.splice(0);
                        $.each(control.ConditionChildFields, (idx, childControl) => {
                            that.selectedItems.push(childControl.field);
                        });
                        that.updateProperties(that.selectedItems);
                    }
                }
            });
            $("#cl_preview_layout").on("click", ".linkedFieldIcon", function (e) {
                e.stopPropagation();
                let itemId = e.target.parentElement.parentElement.parentElement.getAttribute("cl_itemid");
                if (itemId) {
                    let linkedFields = that.clControlFactory.GetLinkedFields(itemId);
                    if (linkedFields && linkedFields.length > 1) {
                        that.selectedItem = undefined;
                        that.selectedItems.splice(0);
                        $.each(linkedFields, (idx, linkedField) => {
                            if (itemId !== linkedField["id"])
                                that.selectedItems.push(linkedField);
                        });
                        that.updateProperties(that.selectedItems);
                    }
                }
            });
            $("#cl_preview_layout").on("click", ".dependentFieldIcon", function (e) {
                e.stopPropagation();
                let itemId = e.target.parentElement.parentElement.parentElement.getAttribute("cl_itemid");
                if (itemId) {
                    let dependentFields = that.clControlFactory.GetChildFields(itemId);
                    if (dependentFields && dependentFields.length > 0) {
                        that.selectedItem = undefined;
                        that.selectedItems.splice(0);
                        $.each(dependentFields, (idx, dependentField) => {
                            that.selectedItems.push(dependentField);
                        });
                        that.updateProperties(that.selectedItems);
                    }
                }
            });
            $("#cl_preview_layout").on("click", ".cl_draggable.previewControl", function (e) {
                if (!$(e.target).is(".cl_lightbox") && !$(e.target).is(".cl_del_icon")) {
                    e.stopPropagation();
                    let itemId = e.currentTarget.getAttribute("cl_itemid");
                    if (!itemId) {
                        // Check if dummyElement
                        if ($(e.currentTarget).hasClass("cldummyListElement"))
                            itemId = $(e.currentTarget).parent().closest(".cl_draggable.previewControl").attr("cl_itemid");
                    }
                    if (itemId) {
                        let item = that.clControlFactory.getItemById(itemId);
                        if (e.ctrlKey) {
                            // getselecteditems
                            let currentItemAlreadySelected = false;
                            let alreadySelectedItems = $("#cl_preview_layout").find(".cl_draggable.previewControl.highlightControl");
                            let selectedItems = [];
                            $.each(alreadySelectedItems, (idx, tmpItem) => {
                                let tmpItemId = tmpItem.getAttribute("cl_itemid");
                                if (tmpItemId === itemId) {
                                    currentItemAlreadySelected = true; // item already selected, so skip an unselect it
                                }
                                else {
                                    selectedItems.push(that.clControlFactory.getItemById(tmpItemId)); // add already selected item
                                }
                            });
                            if (currentItemAlreadySelected) {
                                item.listItem.removeClass("highlightControl");
                                item.selectionIcon.removeClass("cl_selected");
                            }
                            else
                                selectedItems.push(item);
                            that.selectedItem = item;
                            that.selectedItems = selectedItems;
                            that.updateProperties(selectedItems);
                        }
                        else if (e.shiftKey) {
                            let selectedItems = [];
                            let selectedElements;
                            let selectedElement;
                            if (that.selectedItem)
                                selectedElement = $(".cl_draggable.previewControl[cl_itemid=" + that.selectedItem.id + "]");
                            let newElement = $(".cl_draggable.previewControl[cl_itemid=" + item.id + "]");
                            let allElements = $("#cl_preview_layout").find(".previewControl.cl_draggable").not(".disabled");
                            let newElementIdx = allElements.index(newElement);
                            if (selectedElement) {
                                let selectedElementIdx = allElements.index(selectedElement);
                                if (newElementIdx > selectedElementIdx)
                                    selectedElements = allElements.slice(selectedElementIdx, newElementIdx + 1);
                                else
                                    selectedElements = allElements.slice(newElementIdx, selectedElementIdx + 1);
                            }
                            else
                                selectedElements = allElements.slice(0, newElementIdx + 1);
                            $.each(selectedElements, (idx, element) => {
                                selectedItems.push(that.clControlFactory.getItemById(element.getAttribute("cl_itemid")));
                            });
                            that.selectedItems = selectedElements;
                            that.updateProperties(selectedItems);
                        }
                        else {
                            that.selectedItem = item;
                            that.selectedItems = [item];
                            that.updateProperties([item]);
                        }
                    }
                    if ($(e.target).is("div") || $(e.target).is("li") || $(e.target).is("label") || $(e.target).is("ul")) {
                        // Check if dummyElement
                        if ($(e.currentTarget).hasClass("cldummyListElement"))
                            $(e.currentTarget).parent().closest(".cl_draggable.previewControl").focus();
                        else
                            $(e.currentTarget).focus();
                    }
                }
            });
            $("#cl_preview_layout").on("lightbox_clicked", ".cl_draggable.previewControl", function (e) {
                e.stopPropagation();
                let itemId = e.currentTarget.getAttribute("cl_itemid");
                if (itemId) {
                    let item = that.clControlFactory.getItemById(itemId);
                    that.updateProperties([item]);
                }
            });
            $("#cl_preview_layout").on("mouseover", ".previewControl", function (e) {
                let itemId = e.currentTarget.getAttribute("cl_itemid");
                let item;
                if (itemId)
                    item = that.clControlFactory.getItemById(itemId);
                if (!$(e.currentTarget).is(".disabled")) {
                    e.stopPropagation();
                    $(e.currentTarget).addClass("cl_hover");
                    if (item) {
                        item.delIcon.addClass("cl_hovervisibility");
                        if (item["condition"])
                            item.conditionIcon.addClass("cl_hovervisibility");
                        if (item["linkedfield"] && (item["linkedfield"] !== item["id"]))
                            item.linkedIcon.addClass("cl_hovervisibility");
                        if (item["dependentfield"])
                            item.dependentIcon.addClass("cl_hovervisibility");
                        item.selectionIcon.addClass("cl_hovervisibility");
                    }
                    else {
                        $(e.currentTarget).children(".cl_del_icon").addClass("cl_hovervisibility");
                        $(e.currentTarget).children(".clPreviewIconContainer").children(".conditionIconContainer").children(".conditionIcon").addClass("cl_hovervisibility");
                        $(e.currentTarget).children(".clPreviewIconContainer").children(".linkedFieldIconContainer").children(".linkedFieldIcon").addClass("cl_hovervisibility");
                        $(e.currentTarget).children(".clPreviewIconContainer").children(".dependentFieldIconContainer").children(".dependentFieldIcon").addClass("cl_hovervisibility");
                        $(e.currentTarget).children(".clSelectionMark").addClass("cl_hovervisibility");
                    }
                }
            });
            $("#cl_preview_layout").on("mouseout", ".previewControl", function (e) {
                if (!$(e.currentTarget).is(".disabled")) {
                    e.stopPropagation();
                    let itemId = e.currentTarget.getAttribute("cl_itemid");
                    let item;
                    if (itemId)
                        item = that.clControlFactory.getItemById(itemId);
                    $(e.currentTarget).removeClass("cl_hover");
                    if (item) {
                        item.delIcon.removeClass("cl_hovervisibility");
                        item.conditionIcon.removeClass("cl_hovervisibility");
                        item.linkedIcon.removeClass("cl_hovervisibility");
                        item.dependentIcon.removeClass("cl_hovervisibility");
                        item.selectionIcon.removeClass("cl_hovervisibility");
                    }
                    else {
                        $(e.currentTarget).children(".cl_del_icon").removeClass("cl_hovervisibility");
                        $(e.currentTarget).children(".clPreviewIconContainer").children(".conditionIconContainer").children(".conditionIcon").removeClass("cl_hovervisibility");
                        $(e.currentTarget).children(".clPreviewIconContainer").children(".linkedFieldIconContainer").children(".linkedFieldIcon").removeClass("cl_hovervisibility");
                        $(e.currentTarget).children(".clPreviewIconContainer").children(".dependentFieldIconContainer").children(".dependentFieldIcon").removeClass("cl_hovervisibility");
                        $(e.currentTarget).children(".clSelectionMark").removeClass("cl_hovervisibility");
                    }
                }
            });
            window.keydown(function (event) {
                function isTextBox(element) {
                    let elem = $(element);
                    let tagName = element.tagName.toLowerCase();
                    if (tagName === 'textarea')
                        return true;
                    if (tagName === "span")
                        return elem.hasClass("k-dropdown-wrap");
                    if (tagName !== 'input')
                        return false;
                    let type = element.getAttribute('type').toLowerCase(), inputTypes = ['text', 'password', 'number', 'email', 'tel', 'url', 'search', 'date', 'datetime', 'datetime-local', 'time', 'month', 'week'];
                    return inputTypes.indexOf(type) >= 0;
                }
                if (event.ctrlKey && event.keyCode === 67) { // copy
                    if (!isTextBox(event.target)) {
                        event.stopPropagation();
                        event.preventDefault();
                        $("#cl_preview_layout").trigger("clcopy");
                    }
                }
                else if (event.ctrlKey && event.keyCode === 86) { // paste
                    if (!isTextBox(event.target)) {
                        event.stopPropagation();
                        event.preventDefault();
                        $("#cl_preview_layout").trigger("clpaste");
                    }
                }
                if (event.ctrlKey && event.keyCode === 88) { // cut
                    if (!isTextBox(event.target)) {
                        event.stopPropagation();
                        event.preventDefault();
                        $("#cl_preview_layout").trigger("clcut");
                    }
                }
                if (event.ctrlKey && event.keyCode === 83) { // save
                    event.stopPropagation();
                    event.preventDefault();
                    $("#" + configData.designerlLayout).trigger("clsave");
                }
                if (event.ctrlKey && event.keyCode === 65) { // all
                    if (!isTextBox(event.target)) {
                        let selectedItems = [];
                        let selectedElements = $(".cl_draggable.previewControl").not(".disabled");
                        $.each(selectedElements, (idx, element) => {
                            let tmpItemId = element.getAttribute("cl_itemid");
                            selectedItems.push(that.clControlFactory.getItemById(tmpItemId));
                        });
                        that.selectedItems = selectedItems;
                        that.updateProperties(selectedItems);
                        event.stopPropagation();
                        event.preventDefault();
                    }
                }
            });
            that.clControlFactory.checklistjQuery.on("updateControl", function (e, id) {
                e.stopPropagation();
                let item = that.clControlFactory.getItemById(id);
                that.updateProperties([item], true);
            });
            $("#cl_preview_layout").trigger("clshowrelations");
            // Set initially to changed because mapping could have happend.
            that.clControlFactory.setChecklistChanged(true);
            if (that.clControlFactory.configData["loadingDiv"])
                that.clControlFactory.configData["loadingDiv"].remove();
        };
        that.clControlFactory.getLangId(createCallBack);
    }
    setHelpToolbarItem() {
        let that = this;
        let showItem = that.clControlFactory.checkIfItemsHaveHelpLabel(that.clControlFactory.instance.layout);
        if (showItem)
            that.helpToolbarItem.css("display", "list-item");
        else
            that.helpToolbarItem.css("display", "none");
    }
    showConditionIcons(showIcon = true) {
        let that = this;
        $.each(that.clControlFactory.Items(), (idx, item) => {
            if (item["condition"] && that.showRelationsIconPressed && showIcon)
                item.conditionIcon.addClass("highlightConditionIcon");
            else
                item.conditionIcon.removeClass("highlightConditionIcon");
        });
    }
    showLinkedFieldsIcons(showIcon = true) {
        let that = this;
        $.each(that.clControlFactory.Fields(), (idx, field) => {
            if (field["linkedfield"] && (field["linkedfield"] !== field["id"]) && that.showRelationsIconPressed && showIcon)
                field.linkedIcon.addClass("highlightConditionIcon");
            else
                field.linkedIcon.removeClass("highlightConditionIcon");
        });
    }
    showDependentFieldsIcons(showIcon = true) {
        let that = this;
        $.each(that.clControlFactory.Fields(), (idx, field) => {
            if (field["dependentfield"] && that.showRelationsIconPressed && showIcon)
                field.dependentIcon.addClass("highlightConditionIcon");
            else
                field.dependentIcon.removeClass("highlightConditionIcon");
        });
    }
    getSelectedItems(dragItem) {
        let selectedItems = $("#cl_preview_layout").find(".cl_draggable.previewControl.highlightControl").not(".placeholder").filter(function () {
            return $(this).parents(".cl_draggable.previewControl.highlightControl").length === 0;
        });
        let itemAlreadySelected = false;
        $.each(selectedItems, (idx, item) => {
            $.each(dragItem, (idx_drag, item_drag) => {
                if (item.getAttribute("cl_itemid") === item_drag.getAttribute("cl_itemid"))
                    itemAlreadySelected = true;
            });
        });
        if (itemAlreadySelected)
            return selectedItems;
        else
            return dragItem;
    }
    dismissSelectedItems() {
        this.selectedItem = undefined;
        this.selectedItems.splice(0);
        this.updateProperties(this.selectedItems);
    }
    updateMenuAccordingToSelection() {
        let menu = this.menu.data("kendoMenu");
        menu.enable(".buttonMenu", this.selectedItems.length === 0);
    }
    copyItemToLayout(newItem, elementToInsertAfter, groupId, append, copy) {
        let that = this;
        let idList = [];
        let exIdMap = [];
        let linkedFieldsMap = [];
        let linkedFieldsIds = [];
        let idMap = [];
        if (that.fieldCanBeInserted(undefined)) {
            let item = $.extend(true, {}, newItem);
            if (copy) {
                let newId = Utilities_1.synUtil.getGUID(true);
                if (item.linkedfield) {
                    if (item.linkedfield === item.id)
                        linkedFieldsMap.push({ newId, oldId: item.id });
                    linkedFieldsIds.push(newId);
                }
                idMap.push({ newId, oldId: item.id });
                item.id = newId;
                let oldExternalId = item.externalid;
                if (item.externalid) {
                    if (newItem.externalid.includes(newItem.id, 0))
                        item.externalid = newItem.externalid.replace(newItem.id, item.id);
                    else
                        item.externalid = item.id + item.externalid;
                    idList.push(item.id);
                    exIdMap.push({ newId: item.externalid, oldId: newItem.externalid });
                }
            }
            let layout;
            if (item["layout"] && item["layout"].length > 0) {
                layout = $.extend(true, [], item["layout"]);
                item["layout"] = [];
            }
            let levelcount = 0;
            let type = item["type"];
            let control;
            let lastItem;
            let pageId = undefined;
            if (groupId) {
                let groupControl = that.clControlFactory.getFieldControl(groupId);
                if (groupControl)
                    pageId = groupControl.getPageId();
            }
            switch (type) {
                case "field":
                    let field = item;
                    let controltype = item["controltype"];
                    let datatype = item["datatype"];
                    switch (controltype) {
                        case "StaticText":
                            control = new ChecklistControls_1.ClStaticText(field["id"], field, that.clControlFactory, levelcount, field["datatype"]);
                            break;
                        case "Input":
                            switch (datatype) {
                                case "String":
                                    control = new ChecklistControls_1.ClTextInput(field["id"], field, that.clControlFactory, levelcount);
                                    break;
                                case "Integer":
                                case "Float":
                                    control = new ChecklistControls_1.ClNumericInput(field["id"], field, that.clControlFactory, levelcount, field["datatype"]);
                                    break;
                                case "Date":
                                case "Time":
                                case "Datetime":
                                    control = new ChecklistControls_1.ClDatetime(field["id"], field, that.clControlFactory, levelcount, field["datatype"]);
                                    break;
                            }
                            break;
                        case "TextArea":
                            control = new ChecklistControls_1.ClTextArea(field["id"], field, that.clControlFactory, levelcount);
                            break;
                        case "Radiobutton":
                            control = new ChecklistControls_1.ClMVCheckBoxRadio(field["id"], field, that.clControlFactory, levelcount, field["controltype"]);
                            break;
                        case "Checkbox":
                            if (field["multivalue"] === true)
                                control = new ChecklistControls_1.ClMVCheckBoxRadio(field["id"], field, that.clControlFactory, levelcount, field["controltype"]);
                            else
                                control = new ChecklistControls_1.ClSVCheckBoxSwitch(field["id"], field, that.clControlFactory, levelcount, field["controltype"]);
                            break;
                        case "Combobox":
                            if (field["isselfrefft"])
                                control = new ChecklistControls_1.ClSRComboboxContainer(field["id"], field, that.clControlFactory, levelcount);
                            else
                                control = new ChecklistControls_1.ClCombobox(field["id"], field, that.clControlFactory, levelcount);
                            break;
                        case "ImageView":
                            control = new ChecklistControls_1.ClImageViewControl(field["id"], field, that.clControlFactory, levelcount, that.clControlFactory.instance["containerid"]);
                            break;
                        case "Switch":
                            control = new ChecklistControls_1.ClSVCheckBoxSwitch(field["id"], field, that.clControlFactory, levelcount, field["controltype"]);
                            break;
                        case "MultipleChoice":
                            control = new ChecklistControls_1.ClMultipleChoice(field["id"], field, that.clControlFactory, levelcount);
                            break;
                        default:
                            break;
                    }
                    if (append)
                        that.clControlFactory.appendItemToLayout(item, elementToInsertAfter.attr("cl_group"));
                    else
                        that.clControlFactory.insertItemToLayoutAfter(item, elementToInsertAfter.attr("cl_itemid"), elementToInsertAfter.attr("cl_group"));
                    if (control != undefined) {
                        control.setPageId(pageId);
                        that.clControlFactory.fieldCollection.allControls.push(control);
                        let listItem = that.createChecklistElement(elementToInsertAfter, item, append);
                        if (groupId)
                            listItem.attr("cl_group", groupId);
                        listItem.attr("cl_itemid", field["id"]);
                        let guid2 = Utilities_1.synUtil.getGUID(true);
                        if (groupId)
                            listItem.attr("cl_group", groupId);
                        control.init(listItem);
                    }
                    break;
                case "group":
                    control = new ChecklistControls_1.ClGroup(item["id"], item, that.clControlFactory);
                    control.setPageId(pageId);
                    that.clControlFactory.fieldCollection.allControls.push(control);
                    let groupListItem = that.createChecklistElement(elementToInsertAfter, item, append);
                    groupListItem.attr("cl_itemid", item["id"]);
                    if (groupId)
                        groupListItem.attr("cl_group", groupId);
                    control.init(groupListItem);
                    let groupContainer = control.getInputControl();
                    let groupList = $("<ul id='cl_preview_layout_" + item["id"] + "' class='cl_sortable cl_group_sortable' style='min-height:100px;width: 100 %; list-style: none; padding-left: 0px; '/>").appendTo(groupContainer);
                    groupList.attr("cl_group", item["id"]);
                    let firstListItem = $("<li id='cl_preview_layout_" + item["id"] + "_first' class='cl_draggable previewControl disabled cldummyListElement' />").appendTo(groupList);
                    firstListItem.attr("cl_group", item["id"]);
                    if (append)
                        that.clControlFactory.appendItemToLayout(item, groupListItem.attr("cl_group"));
                    else
                        that.clControlFactory.insertItemToLayoutAfter(item, elementToInsertAfter.attr("cl_itemid"), groupListItem.attr("cl_group"));
                    // Init layout
                    if (layout && layout.length > 0) {
                        for (let idx_group = 0; idx_group < layout.length; ++idx_group) {
                            let res = that.copyItemToLayout(layout[idx_group], groupList, item["id"], true, copy);
                            idList = idList.concat(res.idList);
                            exIdMap = exIdMap.concat(res.exIdMap);
                            linkedFieldsMap = linkedFieldsMap.concat(res.linkedFieldsMap);
                            linkedFieldsIds = linkedFieldsIds.concat(res.linkedFieldsIds);
                            idMap = idMap.concat(res.idMap);
                        }
                    }
                    lastItem = $("<li id='cl_preview_layout_" + item["id"] + "_last' class='cl_draggable previewControl disabled cldummyListElement' />").appendTo(groupList);
                    lastItem.attr("cl_group", item["id"]);
                    break;
                case "page":
                    control = new ChecklistControls_1.ClPage(item["id"], item, that.clControlFactory, true, false);
                    that.clControlFactory.fieldCollection.allControls.push(control);
                    let pageListItem = that.createChecklistElement(elementToInsertAfter, item, append);
                    pageListItem.attr("cl_itemid", item["id"]);
                    if (groupId)
                        pageListItem.attr("cl_group", groupId);
                    control.init(pageListItem);
                    let pageContainer = control.getInputControl();
                    let pageList = $("<ul id='cl_preview_layout_" + item["id"] + "' class='cl_sortable cl_page_sortable' style='min-height:100px;width: 100 %; list-style: none; padding-left: 0px; '/>").appendTo(pageContainer);
                    pageList.attr("cl_group", item["id"]);
                    firstListItem = $("<li id='cl_preview_layout_" + item["id"] + "_first' class='cl_draggable previewControl disabled cldummyListElement' />").appendTo(pageList);
                    firstListItem.attr("cl_group", item["id"]);
                    if (append)
                        that.clControlFactory.appendItemToLayout(item, pageListItem.attr("cl_group"));
                    else
                        that.clControlFactory.insertItemToLayoutAfter(item, elementToInsertAfter.attr("cl_itemid"), pageListItem.attr("cl_group"));
                    // Init layout
                    if (layout && layout.length > 0) {
                        for (let idx_page = 0; idx_page < layout.length; ++idx_page) {
                            let res = that.copyItemToLayout(layout[idx_page], pageList, item["id"], true, copy);
                            idList = idList.concat(res.idList);
                            exIdMap = exIdMap.concat(res.exIdMap);
                            linkedFieldsMap = linkedFieldsMap.concat(res.linkedFieldsMap);
                            linkedFieldsIds = linkedFieldsIds.concat(res.linkedFieldsIds);
                            idMap = idMap.concat(res.idMap);
                        }
                    }
                    lastItem = $("<li id='cl_preview_layout_" + item["id"] + "_last' class='cl_draggable previewControl disabled cldummyListElement' />").appendTo(pageList);
                    lastItem.attr("cl_group", item["id"]);
                    break;
                case "layoutitem":
                    if (item["layouttype"] === "HorizontalLine") {
                        control = new ChecklistControls_1.LayoutItem(item["id"], item, that.clControlFactory);
                    }
                    if (control != undefined) {
                        control.setPageId(pageId);
                        that.clControlFactory.fieldCollection.allControls.push(control);
                        let listItem = that.createChecklistElement(elementToInsertAfter, item, append);
                        listItem.attr("cl_itemid", item["id"]);
                        if (groupId)
                            listItem.attr("cl_group", groupId);
                        control.init(listItem);
                    }
                    if (append)
                        that.clControlFactory.appendItemToLayout(item, elementToInsertAfter.attr("cl_group"));
                    else
                        that.clControlFactory.insertItemToLayoutAfter(item, elementToInsertAfter.attr("cl_itemid"), elementToInsertAfter.attr("cl_group"));
                    break;
                default:
                    break;
            }
            that.clControlFactory.setConditionRelationBetweenFields([control]);
        }
        return { idList, exIdMap, linkedFieldsMap, linkedFieldsIds, idMap };
    }
    checkIfItemAlreadyInCopyList(copyList, item) {
        let inList = false;
        $.each(copyList, (idx, tmpItem) => {
            if (!inList) {
                if (item.id === tmpItem.id)
                    inList = true;
                else {
                    if (item.type === "group" || item.type === "page") {
                        $.each(item.layout, (idx2, item2) => {
                            if (!inList)
                                inList = this.checkIfItemAlreadyInCopyList(copyList, item2);
                        });
                    }
                }
            }
        });
        return inList;
    }
    ChangeIdsForPreview(instance) {
        let externalIdMap = this.ChangeIdsForPreviewInternal(instance.layout);
        $.each(externalIdMap, (idx, externalIdTuple) => {
            this.clControlFactory.updateConditionIds(externalIdTuple.oldExternalId, externalIdTuple.newExternalId);
        });
    }
    ChangeIdsForPreviewInternal(layout) {
        let externalIdMap = [];
        $.each(layout, (idx, item) => {
            item.id = item.id + "_clpreview";
            let oldExternalId = item.externalid;
            item.externalid = item.externalid + "_clpreview";
            externalIdMap.push({ oldExternId: oldExternalId, newExternalId: item.externalid });
            if (item["layout"])
                externalIdMap = externalIdMap.concat(this.ChangeIdsForPreviewInternal(item["layout"]));
        });
        return externalIdMap;
    }
    UpdataDataPresentedInfo(layout) {
        $.each(layout, (idx, item) => {
            let datapresentedinfoCallback = function (datapresentedinfo) {
                if (datapresentedinfo) {
                    if (!item["datapresentedinfo"])
                        item["datapresentedinfo"] = {};
                    $.each(datapresentedinfo, function (key, value) {
                        item["datapresentedinfo"][key] = value;
                    });
                }
            };
            if (item["datapresentedinfo"])
                this.clControlFactory.getComboboxInfo(item, item["value"], datapresentedinfoCallback);
            if (item["layout"])
                this.UpdataDataPresentedInfo(item["layout"]);
        });
    }
    checklistHasPage(layout) {
        let hasPage = false;
        if (layout) {
            $.each(layout, (idx, item) => {
                if (!hasPage) {
                    if (item.type === "page")
                        return true;
                    else {
                        if (item.layout)
                            hasPage = this.checklistHasPage(item.layout);
                    }
                }
            });
        }
        return hasPage;
    }
    limitDropZones(draggableEvent, dragItem) {
        // Check if drag of template control
        let templateDragged = false;
        let selectedItemContainsPage = false;
        let selectedItemContainsItem = false;
        let layoutHasPages = this.checklistHasPage(this.checklist.layout);
        if (draggableEvent.currentTarget && draggableEvent.currentTarget.length === 1 && draggableEvent.currentTarget[0].id) {
            if ($("#" + draggableEvent.currentTarget[0].id).hasClass("templateControl"))
                templateDragged = true;
            if (templateDragged) {
                if ($("#" + draggableEvent.currentTarget[0].id).hasClass("clPage"))
                    selectedItemContainsPage = true;
                else
                    selectedItemContainsItem = true;
            }
        }
        if (!templateDragged) {
            let selectedItems = this.selectedDragElements;
            if (selectedItems && selectedItems.length > 0) {
                if (selectedItems.find(".clPage").length > 0)
                    selectedItemContainsPage = true;
                if (selectedItems.find().not(".clPage").length > 0)
                    selectedItemContainsPage = true;
            }
        }
        if (layoutHasPages) {
            if (selectedItemContainsPage && selectedItemContainsItem) {
                $("li.previewControl").removeClass("cl_draggable");
            }
            else if (selectedItemContainsPage) {
                $("li.previewControl").removeClass("cl_draggable");
                $("#cl_preview_layout").children("li").addClass("cl_draggable");
            }
            else {
                if (!templateDragged) {
                    $("#cl_preview_layout").children("li").addClass("cl_draggable");
                }
                else {
                    $("li.previewControl").removeClass("cl_draggable");
                    $("#cl_preview_layout").find(".cl_page_sortable").find("li.previewControl").addClass("cl_draggable");
                }
            }
        }
        else {
            if (selectedItemContainsPage) {
                $("li.previewControl").removeClass("cl_draggable");
                $("#cl_preview_layout").children("li").addClass("cl_draggable");
            }
            else
                $("li.previewControl").addClass("cl_draggable");
        }
    }
    setFirstAndLastDummy(listId) {
        if (listId) {
            $("#" + listId + "_first").prependTo($("#" + listId));
            $("#" + listId + "_last").appendTo($("#" + listId));
        }
    }
    fieldCanBeInserted(controltype) {
        let bReturn = true;
        // Check if max number of fields and image fields is reached
        if (this.clControlFactory.getNumberOfFields() >= this.clControlFactory.maxNumberOfFields && this.clControlFactory.instance.checklimits) {
            bReturn = false;
            // raise error
            let errorMsg = Utilities_1.synUtil.Strings.getValue("ERROR_200042|14", undefined);
            if (!errorMsg)
                errorMsg = "Max number {0} of allowed fields is reached.";
            errorMsg = errorMsg.replace("{0}", this.clControlFactory.maxNumberOfFields.toString());
            Utilities_1.synUtil.Notifications.error(errorMsg);
        }
        else {
            if (controltype === "ImageView" && this.clControlFactory.getNumberOfImageFields() >= this.clControlFactory.maxNumberOfImageFields && this.clControlFactory.instance.checklimits) {
                bReturn = false;
                // raise error
                let errorMsg = Utilities_1.synUtil.Strings.getValue("ERROR_200042|15", undefined);
                if (!errorMsg)
                    errorMsg = "Max number {0} of allowed image fields is reached.";
                errorMsg = errorMsg.replace("{0}", this.clControlFactory.maxNumberOfFields.toString());
                Utilities_1.synUtil.Notifications.error(errorMsg);
            }
        }
        return bReturn;
    }
    updateItemsInfo(items, withChildren = true) {
        let that = this;
        $.each(items, (idx, item) => {
            this.updateFieldInfo(item);
            if (item["layout"] && withChildren)
                that.updateItemsInfo(item["layout"], withChildren);
        });
    }
    checkItems() {
        let wrongItems = this.checkItemsInternal(this.checklist.layout);
        if (wrongItems && wrongItems.length > 0) {
            Utilities_1.synUtil.Notifications.error(Utilities_1.synUtil.Strings.getValue("clincompletenotification"));
            let firstItem = $(".cl_draggable.previewControl[cl_itemid=" + wrongItems[0].id + "]");
            if (firstItem && firstItem.length > 0)
                firstItem[0].scrollIntoView();
            return false;
        }
        else
            return true;
    }
    checkItemsInternal(layout) {
        let wrongItems = [];
        $.each(layout, (idx, item) => {
            if (!this.checkItem(item))
                wrongItems.push(item);
            if (item["layout"])
                wrongItems = wrongItems.concat(this.checkItemsInternal(item["layout"]));
        });
        return wrongItems;
    }
    checkItem(item) {
        let check = true;
        let infoLabel = item.infoLabel;
        if (infoLabel)
            infoLabel.text("");
        let errorLabel = item.errorLabel;
        if (errorLabel)
            errorLabel.text("");
        if (item.type === "field") {
            if (item.datatype === "List") {
                if (!item.dataname || !item.datafield) {
                    check = false;
                    if (errorLabel)
                        errorLabel.text(Utilities_1.synUtil.Strings.getValue("clnocollectionerrornotification"));
                }
                if (item.controltype === "MultipleChoice" && ((this.clControlFactory.Mode & ChecklistControls_1.ChecklistMode.Questionnaire) === ChecklistControls_1.ChecklistMode.Questionnaire)) {
                    let control = this.clControlFactory.getFieldControl(item.id);
                    if (control) {
                        let correctvalues = control.getValue();
                        if (!correctvalues) {
                            check = false;
                            if (errorLabel)
                                errorLabel.text(Utilities_1.synUtil.Strings.getValue("clnocorrectvalueerrornotification"));
                        }
                    }
                }
                // Get local collection check if column is part of
                if (item.dataname && item.datafield) {
                    let collection = this.clControlFactory.getCollectionFromInstance(item.dataname);
                    if (collection && collection.columns) {
                        if (collection.columns.indexOf(item.datafield) === -1) {
                            check = false;
                            if (errorLabel)
                                errorLabel.text(Utilities_1.synUtil.Strings.getValue("clcolumnnotexisterrornotification"));
                        }
                    }
                }
                if (item["linkedfield"]) {
                    if (!this.checkParentLinkedField(item)) {
                        check = false;
                        if (errorLabel)
                            errorLabel.text(Utilities_1.synUtil.Strings.getValue("clparentfieldnotexisterrornotification"));
                    }
                }
                if (item["dependentfield"]) {
                    if (!this.checkParentDependentField(item)) {
                        check = false;
                        if (errorLabel)
                            errorLabel.text(Utilities_1.synUtil.Strings.getValue("cldependentfieldnotexisterrornotification"));
                    }
                }
            }
            if (item["datatype"] !== "StaticImage") {
                if (item.labels.findIndex(label => label.langid === this.checklist["langid"] && label.text) === -1) {
                    check = false;
                    if (errorLabel)
                        errorLabel.text(Utilities_1.synUtil.Strings.getValue("clnolabelerrornotification"));
                }
            }
            if (item["usebarcode"]) {
                if (!item["barcodetypes"] || item["barcodetypes"].length === 0) {
                    check = false;
                    if (errorLabel)
                        errorLabel.text(Utilities_1.synUtil.Strings.getValue("clnobarcodetypeerrornotification"));
                }
                if (item.datatype === "List" && !item["barcodecolumn"]) {
                    check = false;
                    if (errorLabel)
                        errorLabel.text(Utilities_1.synUtil.Strings.getValue("clnobarcodecolumnerrornotification"));
                }
            }
            if (item["istelnr"] && item.datatype === "List" && !item["telnrcolumn"]) {
                check = false;
                if (errorLabel)
                    errorLabel.text(Utilities_1.synUtil.Strings.getValue("clnotelnrcolumnerrornotification"));
            }
        }
        else if (item.type === "page") {
            if (item.labels.findIndex(label => label.langid === this.checklist["langid"] && label.text) === -1) {
                check = false;
                if (errorLabel)
                    errorLabel.text(Utilities_1.synUtil.Strings.getValue("clnolabelerrornotification"));
            }
        }
        if (!(item.type === "field" && item["controltype"] === "StaticText")) {
            let html = this.clControlFactory.getLabel(item.labels, this.clControlFactory.userUILangId, this.checklist["langid"]);
            let label = this.clControlFactory.getLabelText(item.labels, this.clControlFactory.userUILangId, this.checklist["langid"]);
            let labelAppropriate = this.checkIfLabelIsAppropriateForMobile(label, html);
            let helpHtml = this.clControlFactory.getLabel(item.helplabels, this.clControlFactory.userUILangId, this.checklist["langid"]);
            let helpLabel = this.clControlFactory.getLabelText(item.helplabels, this.clControlFactory.userUILangId, this.checklist["langid"]);
            let htmlLabelAppropriate = this.checkIfLabelIsAppropriateForMobile(helpLabel, helpHtml);
            if (!labelAppropriate || !htmlLabelAppropriate) {
                if (infoLabel)
                    infoLabel.text(Utilities_1.synUtil.Strings.getValue("cllabelnotappropriateformobileinfo"));
                item.infoIcon.show();
            }
            else {
                if (infoLabel)
                    infoLabel.text("");
                item.infoIcon.hide();
            }
        }
        if (check) {
            if (item.type === "page") {
                if (item.parentid) {
                    check = false;
                    if (errorLabel)
                        errorLabel.text(Utilities_1.synUtil.Strings.getValue("clpageerrornotification"));
                }
            }
            else {
                if (this.checklistContainsPages() && !this.hasPageAsParent(item)) {
                    check = false;
                    if (errorLabel)
                        errorLabel.text(Utilities_1.synUtil.Strings.getValue("clnotinpageerrornotification"));
                }
            }
        }
        return check;
    }
    checkIfLabelIsAppropriateForMobile(label, html) {
        let appropriate = true;
        if (html != undefined && label != undefined) {
            if (label === " ") // Weiche um blank zu erlauben
                label = "<p/>";
            label = label.trim();
            html = html.trim();
            if (html.indexOf("<p>") === 0)
                html = html.substr(3);
            if (html.lastIndexOf("</p>") === html.length - 4)
                html = html.substr(0, html.length - 4);
            label = label.replace(new RegExp("  \r?\n", "g"), "<br>");
            label = label.replace(new RegExp("\r?\n", "g"), "");
            label = label.replace(new RegExp("<br/>", "g"), "<br>");
            label = label.replace(new RegExp("<br >", "g"), "<br>");
            label = label.replace(new RegExp("<br />", "g"), "<br>");
            html = html.replace(new RegExp("&quot;", "g"), "\"");
            html = html.replace(new RegExp("&amp;", "g"), "&");
            html = html.replace(new RegExp("&lt;", "g"), "<");
            html = html.replace(new RegExp("&gt;", "g"), ">");
            html = html.replace(new RegExp("<br>\r?\n", "g"), "<br>");
            let tokens = label.split("<br>");
            let correctedLabel = "";
            $.each(tokens, (idx, value) => {
                correctedLabel += value.trim() + "<br>";
            });
            correctedLabel = correctedLabel.substr(0, correctedLabel.length - 4);
            if (html !== correctedLabel) {
                appropriate = false;
            }
        }
        return appropriate;
    }
    checkParentLinkedField(field) {
        let check = false;
        if (field["linkedfield"]) {
            $.each(this.clControlFactory.Fields(), (idx, item) => {
                if (item["id"] === field["linkedfield"])
                    check = true;
            });
        }
        return check;
    }
    checkParentDependentField(field) {
        let check = false;
        if (field["dependentfield"]) {
            $.each(this.clControlFactory.Fields(), (idx, item) => {
                if (item["id"] === field["dependentfield"])
                    check = true;
            });
        }
        return check;
    }
    checklistContainsPages() {
        let hasPage = false;
        $.each(this.clControlFactory.instance.layout, (idx, item) => {
            if (item.type === "page")
                hasPage = true;
        });
        return hasPage;
    }
    hasPageAsParent(item) {
        let hasPageAsParent = false;
        if (item.parentid) {
            let parent = this.clControlFactory.getItemById(item.parentid);
            if (parent.type === "page")
                hasPageAsParent = true;
            else
                hasPageAsParent = this.hasPageAsParent(parent);
        }
        return hasPageAsParent;
    }
    updateFieldInfo(item) {
        let showWarning = false;
        item.infoIcon.hide();
        if (this.checkItem(item)) {
            item.warningIcon.hide();
            item.errorLabel.hide();
            item.listItem.removeClass("cl_warning");
        }
        else {
            item.warningIcon.show();
            item.errorLabel.show();
            item.listItem.addClass("cl_warning");
        }
        if (item && item["linkedfield"]) {
            if (this.checkParentLinkedField(item)) {
                $(".cl_draggable.previewControl[cl_itemid=" + item.id + "] > .checklistrow").removeClass("disableControl");
            }
            else
                $(".cl_draggable.previewControl[cl_itemid=" + item.id + "] > .checklistrow").addClass("disableControl");
        }
        if (item && item["dependentfield"]) {
            if (this.checkParentDependentField(item)) {
                $(".cl_draggable.previewControl[cl_itemid=" + item.id + "] > .checklistrow").removeClass("disableControl");
            }
            else
                $(".cl_draggable.previewControl[cl_itemid=" + item.id + "] > .checklistrow").addClass("disableControl");
        }
    }
    updateControl(field, propertyId, oldValue) {
        let that = this;
        let control = this.clControlFactory.getFieldControl(field["id"]);
        let levelcount = control.levelcount;
        let callback;
        if (field["type"] === "field") {
            switch (propertyId) {
                case "multivalue":
                    callback = function () {
                        let oldControl = $("#" + control.id + "_item");
                        let parentControl = oldControl.parent();
                        oldControl.remove();
                        let pageId = control.getPageId();
                        switch (field["controltype"]) {
                            case "Input":
                                switch (field["datatype"]) {
                                    case "String":
                                        control = new ChecklistControls_1.ClTextInput(field["id"], field, that.clControlFactory, levelcount);
                                        break;
                                    case "Integer":
                                    case "Float":
                                        control = new ChecklistControls_1.ClNumericInput(field["id"], field, that.clControlFactory, levelcount, field["datatype"]);
                                        break;
                                    case "Date":
                                    case "Time":
                                    case "Datetime":
                                        control = new ChecklistControls_1.ClDatetime(field["id"], field, that.clControlFactory, levelcount, field["datatype"]);
                                        break;
                                }
                                break;
                            case "TextArea":
                                control = new ChecklistControls_1.ClTextArea(field["id"], field, that.clControlFactory, levelcount);
                                break;
                            case "Checkbox":
                            case "Radiobutton":
                                if (field["multivalue"])
                                    field["controltype"] = "Checkbox";
                                else
                                    field["controltype"] = "Radiobutton";
                                control = new ChecklistControls_1.ClMVCheckBoxRadio(field["id"], field, that.clControlFactory, levelcount, field["controltype"]);
                                break;
                            case "Combobox":
                                if (field.isselfrefft)
                                    control = new ChecklistControls_1.ClSRComboboxContainer(field["id"], field, that.clControlFactory, levelcount);
                                else
                                    control = new ChecklistControls_1.ClCombobox(field["id"], field, that.clControlFactory, levelcount);
                                break;
                            case "MultipleChoice":
                                control = new ChecklistControls_1.ClMultipleChoice(field["id"], field, that.clControlFactory, levelcount);
                                break;
                            default:
                                break;
                        }
                        control.setPageId(pageId);
                        control.init(parentControl);
                        that.clControlFactory.updateControl(field["id"], control);
                        that.clControlFactory.setRelationBetweenFields();
                        that.clControlFactory.setConditionRelationBetweenFields();
                    };
                    if (!field["multivalue"]) {
                        if (field["value"] && field["value"] instanceof Array && field["value"].length > 0)
                            field["value"] = field["value"][0];
                        else
                            field["value"] = undefined;
                        if (field["controltype"] === "MultipleChoice") {
                            if (field["correctvalues"] && field["correctvalues"] instanceof Array && field["correctvalues"].length > 0)
                                field["correctvalues"] = [field["correctvalues"][0]];
                            else
                                field["correctvalues"] = [];
                        }
                        if (field["datatype"] === "List") {
                            let comboboxInfoCallback = function (datapresentedinfo) {
                                if (datapresentedinfo) {
                                    if (!field["datapresentedinfo"])
                                        field["datapresentedinfo"] = {};
                                    $.each(datapresentedinfo, (key, value) => {
                                        field["datapresentedinfo"][key] = value;
                                    });
                                }
                                callback();
                            };
                            if (field["controltype"] === "MultipleChoice")
                                that.clControlFactory.getComboboxInfo(field, field["correctvalues"], comboboxInfoCallback);
                            else
                                that.clControlFactory.getComboboxInfo(field, field["value"], comboboxInfoCallback);
                        }
                        else
                            callback();
                    }
                    else {
                        if (field["value"]) {
                            if (!(field["value"] instanceof Array))
                                field["value"] = [field["value"]];
                        }
                        else
                            field["value"] = [];
                        if (field["controltype"] === "MultipleChoice") {
                            if (field["correctvalues"]) {
                                if (!(field["correctvalues"] instanceof Array))
                                    field["correctvalues"] = [field["correctvalues"]];
                            }
                            else
                                field["correctvalues"] = [];
                        }
                        if (field["datatype"] === "List") {
                            let comboboxInfoCallback = function (datapresentedinfo) {
                                if (datapresentedinfo) {
                                    if (!field["datapresentedinfo"])
                                        field["datapresentedinfo"] = {};
                                    $.each(datapresentedinfo, (key, value) => {
                                        field["datapresentedinfo"][key] = value;
                                    });
                                }
                                callback();
                            };
                            if (field["controltype"] === "MultipleChoice")
                                that.clControlFactory.getComboboxInfo(field, field["correctvalues"], comboboxInfoCallback);
                            else
                                that.clControlFactory.getComboboxInfo(field, field["value"], comboboxInfoCallback);
                        }
                        else
                            callback();
                    }
                    break;
                case "typedefinition":
                    callback = function () {
                        let oldControl = $("#" + control.id + "_item");
                        let parentControl = oldControl.parent();
                        oldControl.remove();
                        let pageId = control.getPageId();
                        switch (field["controltype"]) {
                            case "Input":
                                switch (field["datatype"]) {
                                    case "String":
                                        control = new ChecklistControls_1.ClTextInput(field["id"], field, that.clControlFactory, levelcount);
                                        break;
                                    case "Integer":
                                    case "Float":
                                        control = new ChecklistControls_1.ClNumericInput(field["id"], field, that.clControlFactory, levelcount, field["datatype"]);
                                        break;
                                    case "Date":
                                    case "Time":
                                    case "Datetime":
                                        control = new ChecklistControls_1.ClDatetime(field["id"], field, that.clControlFactory, levelcount, field["datatype"]);
                                        break;
                                }
                                break;
                            case "TextArea":
                                control = new ChecklistControls_1.ClTextArea(field["id"], field, that.clControlFactory, levelcount);
                                break;
                            case "Switch":
                            case "Checkbox":
                            case "Radiobutton":
                                if (field["datatype"] === "Bool") {
                                    control = new ChecklistControls_1.ClSVCheckBoxSwitch(field["id"], field, that.clControlFactory, levelcount, field["controltype"]);
                                }
                                else {
                                    field["correctvalues"] = [];
                                    control = new ChecklistControls_1.ClMVCheckBoxRadio(field["id"], field, that.clControlFactory, levelcount, field["controltype"]);
                                }
                                break;
                            case "Combobox":
                                field["correctvalues"] = [];
                                if (field.isselfrefft)
                                    control = new ChecklistControls_1.ClSRComboboxContainer(field["id"], field, that.clControlFactory, levelcount);
                                else
                                    control = new ChecklistControls_1.ClCombobox(field["id"], field, that.clControlFactory, levelcount);
                                break;
                            case "MultipleChoice":
                                field["value"] = undefined;
                                control = new ChecklistControls_1.ClMultipleChoice(field["id"], field, that.clControlFactory, levelcount);
                                break;
                            default:
                                break;
                        }
                        control.setPageId(pageId);
                        control.init(parentControl);
                        that.clControlFactory.updateControl(field["id"], control);
                        that.clControlFactory.setRelationBetweenFields();
                    };
                    if (field["datatype"] === "List") {
                        let comboboxInfoCallback = function (datapresentedinfo) {
                            if (datapresentedinfo) {
                                if (!field["datapresentedinfo"])
                                    field["datapresentedinfo"] = {};
                                $.each(datapresentedinfo, (key, value) => {
                                    field["datapresentedinfo"][key] = value;
                                });
                            }
                            callback();
                        };
                        that.clControlFactory.getComboboxInfo(field, field["value"], comboboxInfoCallback);
                    }
                    else
                        callback();
                    break;
                case "rowcount":
                    if (control instanceof ChecklistControls_1.ClTextArea)
                        control.updateRowCount();
                    break;
                case "colcount":
                    if (control instanceof ChecklistControls_1.ClMVCheckBoxRadio || control instanceof ChecklistControls_1.ClImageViewControl)
                        control.updateColCount();
                    break;
                case "mandatory":
                    control.notifyChange(true);
                    this.propertyMap["readonly"].setVisibility(true, true, field["mandatory"]);
                    if (control instanceof ChecklistControls_1.ClImageViewControl) {
                        control.updateControl();
                        $.each(this.selectedItems, (idx, item) => {
                            this.propertyMap["attachment"].setItem(item, this.selectedItems, false);
                        });
                    }
                    break;
                case "readonly":
                    if (field.datatype === "StaticImage") {
                        control.resetLayout();
                    }
                    else {
                        control.enable(!field["readonly"]);
                        this.propertyMap["mandatory"].setVisibility(true, true, field["readonly"]);
                        if (field["controltype"] === "Radiobutton" || field["controltype"] === "MultipleChoice")
                            this.propertyMap["removevalue"].setVisibility(true, field["readonly"]);
                    }
                    break;
                case "labelhorizontaloption":
                case "labelverticaloption":
                    if (control instanceof ChecklistControls_1.ClStaticText)
                        control.resetLabel(undefined);
                    else if (control instanceof ChecklistControls_1.ClImageViewControl && field["datatype"] === "StaticImage")
                        control.resetLayout();
                    else if (control instanceof ChecklistControls_1.ClFieldControl)
                        control.resetLabel(undefined);
                    break;
                case "layoutposition":
                    if (control instanceof ChecklistControls_1.ClStaticText)
                        control.resetLabel(undefined);
                    else if (control instanceof ChecklistControls_1.ClImageViewControl)
                        control.resetLayout();
                    break;
                case "condition":
                    let fieldIds = this.clControlFactory.getItemIdsFromCondition(field["condition"]);
                    let oldFieldIds = this.clControlFactory.getItemIdsFromCondition(oldValue);
                    let fieldsToRemove = oldFieldIds.filter(element => fieldIds.indexOf(element) === -1);
                    let fieldsToAdd = fieldIds.filter(element => oldFieldIds.indexOf(element) === -1);
                    $.each(fieldsToRemove, (idx, fieldToRemove) => {
                        let tmpControl = that.clControlFactory.getFieldControl(fieldToRemove);
                        tmpControl.ConditionChildFields = tmpControl.ConditionChildFields.filter(elem => elem.field.id !== field.id);
                        control.ConditionParentFields = control.ConditionParentFields.filter(elem => elem.field.id !== fieldToRemove);
                        tmpControl.field.conditionIcon.removeClass("highlightConditionIcon");
                    });
                    $.each(fieldsToAdd, (idx, fieldToAdd) => {
                        let tmpControl = that.clControlFactory.getFieldControl(fieldToAdd);
                        tmpControl.ConditionChildFields.push(control);
                        control.ConditionParentFields.push(tmpControl);
                        tmpControl.field.conrelfield = true;
                    });
                    this.highlightItemsForCondition(field);
                    break;
                case "externalid":
                    this.clControlFactory.updateConditionIds(oldValue, field[propertyId]);
                    break;
                case "attachment":
                    if (control instanceof ChecklistControls_1.ClImageViewControl)
                        control.updateControl();
                    break;
                case "maxwidth":
                    if (control instanceof ChecklistControls_1.ClImageViewControl)
                        control.updateControl();
                    break;
                case "imageonly":
                    let oldControl = $("#" + control.id + "_item");
                    let parentControl = oldControl.parent();
                    oldControl.remove();
                    let pageId = control.getPageId();
                    control = new ChecklistControls_1.ClImageViewControl(field["id"], field, that.clControlFactory, levelcount, that.clControlFactory.instance["containerid"]);
                    control.setPageId(pageId);
                    control.init(parentControl);
                    that.clControlFactory.updateControl(field["id"], control);
                    break;
                case "linkedfield":
                    control.updateValue(field, false);
                    break;
                case "dependentfield":
                    that.clControlFactory.setRelationBetweenFields();
                    if (!field["dependentfield"] && control instanceof ChecklistControls_1.ClFieldControl)
                        control.updateUsability();
                    if (!control.ParentField) {
                        control.updateDataSource();
                    }
                    this.highlightDependentFields(field);
                    break;
            }
        }
        else {
            if (field["type"] === "layoutitem") {
                if (control instanceof ChecklistControls_1.LayoutItem)
                    control.updateControl();
            }
            else if (field["type"] === "group") {
                if (control instanceof ChecklistControls_1.ClGroup)
                    control.updateControl();
            }
            else if (field["type"] === "page") {
                if (control instanceof ChecklistControls_1.ClPage)
                    control.updateControl();
            }
            if (propertyId === "condition")
                this.highlightItemsForCondition(field);
        }
        this.clControlFactory.updateControl(field.id, control);
    }
    addItemToLayout(item, jQueryElem, levelcount, groupId) {
        let that = this;
        let type = item["type"];
        item["typedefinition"] = that.getTypeDefinition(item);
        let control;
        let pageId = undefined;
        if (groupId) {
            let groupControl = that.clControlFactory.getFieldControl(groupId);
            if (groupControl)
                pageId = groupControl.getPageId();
        }
        if ((that.clControlFactory.Mode & ChecklistControls_1.ChecklistMode.Questionnaire) === ChecklistControls_1.ChecklistMode.Questionnaire) {
            let field = item;
            let controltype = item["controltype"];
            let datatype = item["datatype"];
            if (controltype === "MultipleChoice")
                control = new ChecklistControls_1.ClMultipleChoice(field["id"], field, that.clControlFactory, levelcount);
            if (control != undefined) {
                control.setPageId(pageId);
                that.clControlFactory.fieldCollection.allControls.push(control);
                let listItem = that.createChecklistElement(jQueryElem, field);
                listItem.attr("cl_itemid", field["id"]);
                let guid2 = Utilities_1.synUtil.getGUID(true);
                control.init(listItem);
            }
        }
        else {
            let lastItem;
            switch (type) {
                case "field":
                    let field = item;
                    let controltype = item["controltype"];
                    let datatype = item["datatype"];
                    let childListItem;
                    let listItem;
                    switch (controltype) {
                        case "StaticText":
                            control = new ChecklistControls_1.ClStaticText(field["id"], field, that.clControlFactory, levelcount, field["datatype"]);
                            break;
                        case "Input":
                            switch (datatype) {
                                case "String":
                                    control = new ChecklistControls_1.ClTextInput(field["id"], field, that.clControlFactory, levelcount);
                                    break;
                                case "Integer":
                                case "Float":
                                    control = new ChecklistControls_1.ClNumericInput(field["id"], field, that.clControlFactory, levelcount, field["datatype"]);
                                    break;
                                case "Date":
                                case "Time":
                                case "Datetime":
                                    control = new ChecklistControls_1.ClDatetime(field["id"], field, that.clControlFactory, levelcount, field["datatype"]);
                                    break;
                            }
                            break;
                        case "TextArea":
                            control = new ChecklistControls_1.ClTextArea(field["id"], field, that.clControlFactory, levelcount);
                            break;
                        case "Radiobutton":
                            control = new ChecklistControls_1.ClMVCheckBoxRadio(field["id"], field, that.clControlFactory, levelcount, field["controltype"]);
                            break;
                        case "Checkbox":
                            if (field["multivalue"] === true)
                                control = new ChecklistControls_1.ClMVCheckBoxRadio(field["id"], field, that.clControlFactory, levelcount, field["controltype"]);
                            else
                                control = new ChecklistControls_1.ClSVCheckBoxSwitch(field["id"], field, that.clControlFactory, levelcount, field["controltype"]);
                            break;
                        case "Combobox":
                            if (field["isselfrefft"])
                                control = new ChecklistControls_1.ClSRComboboxContainer(field["id"], field, that.clControlFactory, levelcount);
                            else
                                control = new ChecklistControls_1.ClCombobox(field["id"], field, that.clControlFactory, levelcount);
                            break;
                        case "ImageView":
                            control = new ChecklistControls_1.ClImageViewControl(field["id"], field, that.clControlFactory, levelcount, that.clControlFactory.instance["containerid"]);
                            break;
                        case "Switch":
                            control = new ChecklistControls_1.ClSVCheckBoxSwitch(field["id"], field, that.clControlFactory, levelcount, field["controltype"]);
                            break;
                        case "MultipleChoice":
                            control = new ChecklistControls_1.ClMultipleChoice(field["id"], field, that.clControlFactory, levelcount);
                            break;
                        default:
                            break;
                    }
                    if (control != undefined) {
                        control.setPageId(pageId);
                        that.clControlFactory.fieldCollection.allControls.push(control);
                        listItem = that.createChecklistElement(jQueryElem, item);
                        if (groupId)
                            listItem.attr("cl_group", groupId);
                        listItem.attr("cl_itemid", field["id"]);
                        let guid2 = Utilities_1.synUtil.getGUID(true);
                        if (groupId)
                            listItem.attr("cl_group", groupId);
                        control.init(listItem);
                    }
                    break;
                case "group":
                    control = new ChecklistControls_1.ClGroup(item["id"], item, that.clControlFactory);
                    control.setPageId(pageId);
                    that.clControlFactory.fieldCollection.allControls.push(control);
                    listItem = that.createChecklistElement(jQueryElem, item);
                    listItem.attr("cl_itemid", item["id"]);
                    if (groupId)
                        listItem.attr("cl_group", groupId);
                    control.init(listItem);
                    let groupContainer = control.getInputControl();
                    let groupList = $("<ul id='cl_preview_layout_" + item["id"] + "' class='cl_sortable cl_group_sortable' style='min-height:100px;width: 100 %; list-style: none; padding-left: 0px; '/>").appendTo(groupContainer);
                    groupList.attr("cl_group", item["id"]);
                    childListItem = $("<li id='cl_preview_layout_" + item["id"] + "_first' class='cl_draggable previewControl disabled cldummyListElement' />").appendTo(groupList);
                    childListItem.attr("cl_group", item["id"]);
                    // Init layout
                    if (item["layout"] && item["layout"].length > 0) {
                        $.each(item["layout"], (idx, value) => {
                            that.addItemToLayout(value, groupList, ++levelcount, item["id"]);
                        });
                    }
                    lastItem = $("<li id='cl_preview_layout_" + item["id"] + "_last' class='cl_draggable previewControl disabled cldummyListElement' />").appendTo(groupList);
                    lastItem.attr("cl_group", item["id"]);
                    break;
                case "page":
                    control = new ChecklistControls_1.ClPage(item["id"], item, that.clControlFactory, true, false);
                    that.clControlFactory.fieldCollection.allControls.push(control);
                    listItem = that.createChecklistElement(jQueryElem, item);
                    listItem.attr("cl_itemid", item["id"]);
                    if (groupId)
                        listItem.attr("cl_group", groupId);
                    control.init(listItem);
                    let pageContainer = control.getInputControl();
                    let pageList = $("<ul id='cl_preview_layout_" + item["id"] + "' class='cl_sortable cl_page_sortable' style='min-height:100px;width: 100 %; list-style: none; padding-left: 0px; '/>").appendTo(pageContainer);
                    pageList.attr("cl_group", item["id"]);
                    childListItem = $("<li id='cl_preview_layout_" + item["id"] + "_first' class='cl_draggable previewControl disabled cldummyListElement' />").appendTo(pageList);
                    childListItem.attr("cl_group", item["id"]);
                    // Init layout
                    if (item["layout"] && item["layout"].length > 0) {
                        $.each(item["layout"], (idx, value) => {
                            that.addItemToLayout(value, pageList, ++levelcount, item["id"]);
                        });
                    }
                    lastItem = $("<li id='cl_preview_layout_" + item["id"] + "_last' class='cl_draggable previewControl disabled cldummyListElement' />").appendTo(pageList);
                    lastItem.attr("cl_group", item["id"]);
                    break;
                case "layoutitem":
                    if (item["layouttype"] === "HorizontalLine") {
                        control = new ChecklistControls_1.LayoutItem(item["id"], item, that.clControlFactory);
                    }
                    if (control != undefined) {
                        control.setPageId(pageId);
                        that.clControlFactory.fieldCollection.allControls.push(control);
                        let listItem = that.createChecklistElement(jQueryElem, item);
                        listItem.attr("cl_itemid", item["id"]);
                        if (groupId)
                            listItem.attr("cl_group", groupId);
                        control.init(listItem);
                    }
                    break;
                default:
                    break;
            }
        }
    }
    allowDrop(ev) {
        ev.preventDefault();
    }
    drag(ev) {
        let controltype = $(ev.target).attr("controltype");
        let datatype = $(ev.target).attr("datatype");
        ev.originalEvent.dataTransfer.setData("controltype", controltype);
        ev.originalEvent.dataTransfer.setData("datatype", datatype);
        $("#dropTemplateZone").show();
    }
    dragend(ev) {
        $("#dropTemplateZone").hide();
    }
    drop(ev) {
        ev.preventDefault();
        let controltype = ev.originalEvent.dataTransfer.getData("controltype");
        let datatype = ev.originalEvent.dataTransfer.getData("datatype");
        ev.data.clfac.addControlToPreview(controltype, datatype);
    }
    addControlToPreview(type, controltype, datatype, layouttype, jQueryElem, parentGroupId) {
        let that = this;
        let control;
        let item;
        let pageId = undefined;
        if (parentGroupId) {
            let parentGroup = that.clControlFactory.getFieldControl(parentGroupId);
            if (parentGroup)
                pageId = parentGroup.getPageId();
        }
        if (type === "field") {
            item = new Field(controltype, datatype);
            item["type"] = type;
            item["typedefinition"] = type + "|" + datatype + "|" + controltype;
            switch (controltype) {
                case "StaticText":
                    control = new ChecklistControls_1.ClStaticText(item["id"], item, that.clControlFactory, 0, item["datatype"]);
                    break;
                case "Input":
                    switch (datatype) {
                        case "String":
                            control = new ChecklistControls_1.ClTextInput(item["id"], item, that.clControlFactory, 0);
                            break;
                        case "Integer":
                        case "Float":
                            control = new ChecklistControls_1.ClNumericInput(item["id"], item, that.clControlFactory, 0, item["datatype"]);
                            break;
                        case "Date":
                        case "Time":
                        case "Datetime":
                            control = new ChecklistControls_1.ClDatetime(item["id"], item, that.clControlFactory, 0, item["datatype"]);
                            break;
                    }
                    break;
                case "TextArea":
                    control = new ChecklistControls_1.ClTextArea(item["id"], item, that.clControlFactory, 0);
                    break;
                case "Radiobutton":
                    item["typedefinition"] = type + "|" + datatype + "|List";
                    control = new ChecklistControls_1.ClMVCheckBoxRadio(item["id"], item, that.clControlFactory, 0, item["controltype"]);
                    break;
                case "Checkbox":
                    if (item.multivalue === true) {
                        item["colcount"] = 0;
                        item["typedefinition"] = type + "|" + datatype + "|List";
                        control = new ChecklistControls_1.ClMVCheckBoxRadio(item["id"], item, that.clControlFactory, 0, item["controltype"]);
                    }
                    else
                        control = new ChecklistControls_1.ClSVCheckBoxSwitch(item["id"], item, that.clControlFactory, 0, item["controltype"]);
                    break;
                case "Combobox":
                    if (item["isselfrefft"])
                        control = new ChecklistControls_1.ClSRComboboxContainer(item["id"], item, that.clControlFactory, 0);
                    else
                        control = new ChecklistControls_1.ClCombobox(item["id"], item, that.clControlFactory, 0);
                    break;
                case "ImageView":
                    if (datatype !== "StaticImage") {
                        if (that.clControlFactory.instance.checklimits)
                            item.max = 5;
                        else
                            item.max = 100;
                    }
                    control = new ChecklistControls_1.ClImageViewControl(item["id"], item, that.clControlFactory, 0, that.clControlFactory.instance["containerid"]);
                    break;
                case "Switch":
                    control = new ChecklistControls_1.ClSVCheckBoxSwitch(item["id"], item, that.clControlFactory, 0, item["controltype"]);
                    break;
                case "MultipleChoice":
                    control = new ChecklistControls_1.ClMultipleChoice(item["id"], item, that.clControlFactory, 0);
                    break;
                default:
                    break;
            }
        }
        else if (type === "layoutitem") {
            item = new CLLayoutItem();
            item["type"] = type;
            item["typedefinition"] = type + "||";
            item["layouttype"] = layouttype;
            control = new ChecklistControls_1.LayoutItem(item["id"], item, that.clControlFactory);
        }
        else if (type === "group") {
            item = new Group();
            item["type"] = type;
            item["typedefinition"] = type + "||";
            control = new ChecklistControls_1.ClGroup(item["id"], item, that.clControlFactory);
        }
        else if (type === "page") {
            item = new Page();
            item["type"] = type;
            item["typedefinition"] = type + "||";
            control = new ChecklistControls_1.ClPage(item["id"], item, that.clControlFactory, true, false);
        }
        if (control != undefined) {
            control.setPageId(pageId);
            let listItem = that.createChecklistElement(jQueryElem, item, false);
            listItem.attr("cl_itemid", item["id"]);
            if (parentGroupId)
                listItem.attr("cl_group", parentGroupId);
            that.clControlFactory.fieldCollection.allControls.push(control);
            control.init(listItem);
            if (type === "group") {
                let groupContainer = control.getInputControl();
                let groupList = $("<ul id='cl_preview_layout_" + item["id"] + "' class='cl_sortable cl_group_sortable' style='min-height:100px;width: 100 %; list-style: none; padding-left: 0px; '/>").appendTo(groupContainer);
                groupList.attr("cl_group", item["id"]);
                let firstElem = $("<li id='cl_preview_layout_" + item["id"] + "_first'  class='cl_draggable previewControl disabled cldummyListElement' />").appendTo(groupList);
                firstElem.attr("cl_group", item["id"]);
                let lastElem = $("<li id='cl_preview_layout_" + item["id"] + "_last'  class='cl_draggable previewControl disabled cldummyListElement' />").appendTo(groupList);
                lastElem.attr("cl_group", item["id"]);
            }
            else if (type === "page") {
                let pageContainer = control.getInputControl();
                let pageList = $("<ul id='cl_preview_layout_" + item["id"] + "' class='cl_sortable cl_page_sortable' style='min-height:100px;width: 100 %; list-style: none; padding-left: 0px; '/>").appendTo(pageContainer);
                pageList.attr("cl_group", item["id"]);
                let firstElem = $("<li id='cl_preview_layout_" + item["id"] + "_first'  class='cl_draggable previewControl disabled cldummyListElement' />").appendTo(pageList);
                firstElem.attr("cl_group", item["id"]);
                let lastElem = $("<li id='cl_preview_layout_" + item["id"] + "_last'  class='cl_draggable previewControl disabled cldummyListElement' />").appendTo(pageList);
                lastElem.attr("cl_group", item["id"]);
            }
        }
        return item;
    }
    getTypeDefinition(item) {
        let datatype = "";
        let controltype = "";
        if (item["datatype"])
            datatype = item["datatype"];
        if (item["controltype"])
            controltype = item["controltype"];
        if (datatype === "List" && (controltype === "Radiobutton" || controltype === "Checkbox"))
            controltype = "List";
        return item["type"] + "|" + datatype + "|" + controltype;
    }
    createChecklistElement(jQueryElem, item, append = true) {
        item.listItem = $("<li class='cl_draggable previewControl cl_hoverable' tabindex='-1'> </li>");
        item.selectionIcon = $("<div class='clSelectionMark'/>").appendTo(item.listItem);
        item.delIcon = $("<span class='cl_del_icon fa fa-times'/>").appendTo(item.listItem);
        let iconContainer = $("<div class='clPreviewIconContainer' style='width: 4.5em;display:inline-block;'/>").appendTo(item.listItem);
        item.infoBlock = $("<div class='cl_infoblock'/>").appendTo(item.listItem);
        item.warningIcon = $("<span class='cl_warning_icon fa fa-exclamation-triangle'/>").appendTo(item.infoBlock);
        item.errorLabel = $("<label class='cl_item_errorlabel' />").appendTo(item.infoBlock);
        item.infoIcon = $("<span class='cl_info_icon fa fa-exclamation-triangle'/>").appendTo(item.infoBlock);
        item.infoLabel = $("<label class='cl_item_infolabel' />").appendTo(item.infoBlock);
        let conditionIconContainer = $("<div style='width: 1.5;display:inline-block;' class='conditionIconContainer'/>").appendTo(iconContainer);
        let linkedFieldIconContainer = $("<div style='width: 1.5;display:inline-block;' class='linkedFieldIconContainer'/>").appendTo(iconContainer);
        let dependentFieldIconContainer = $("<div style='width: 1.5;display:inline-block;' class='dependentFieldIconContainer'/>").appendTo(iconContainer);
        item.conditionIcon = $("<span class='fa fa-code conditionIcon' />").appendTo(conditionIconContainer);
        item.dependentIcon = $("<span class='fa fa-list dependentFieldIcon'/>").appendTo(dependentFieldIconContainer);
        item.linkedIcon = $("<span class='fa fa-sitemap linkedFieldIcon'/>").appendTo(linkedFieldIconContainer);
        if (append)
            item.listItem.appendTo(jQueryElem);
        else
            item.listItem.insertAfter(jQueryElem);
        return item.listItem;
    }
    getJointProperties(items) {
        let propIds = ["typedefinition", "id", "externalid", "condition", "staticlabel", "label", "helplabel", "layoutposition", "labelhorizontaloption", "labelverticaloption", "multivalue", "mandatory", "readonly", "visible", "rowcount", "colcount", "value", "removevalue", "linkedfield", "collection", "maxwidth", "attachment", "variable", "barcode", "telephone", "color", "height", "backgroundcolor", "bordercolor"];
        if (items.length !== 1) {
            propIds.splice(1, 2);
        }
        let tempPropIds = propIds;
        if (items.length === 0) {
            tempPropIds = [];
        }
        else if (items.length === 1) {
            tempPropIds = this.getItemProperties(items[0]);
        }
        else {
            let sameType = true;
            let defType = items[0].type;
            let defControlType = items[0]["controltype"];
            let defDataType = items[0]["datatype"];
            $.each(items, (idx, item) => {
                if (sameType && item["datatype"] !== defDataType)
                    sameType = false;
            });
            if (sameType) {
                for (let index = 0; index < items.length; ++index) {
                    let itemPropIds = this.getItemProperties(items[index]);
                    tempPropIds = tempPropIds.filter(elem => itemPropIds.indexOf(elem) !== -1);
                }
            }
            else
                tempPropIds = ["typedefinition", "condition", "visible"];
        }
        return tempPropIds;
    }
    getItemsProperty(items, propertyId, item) {
        let property;
        let sameValue = true;
        let diffProperties = [];
        let tmpItem = $.extend(true, {}, item);
        if (items.length !== 1) {
            $.each(items, (idx, value) => {
                if (sameValue) {
                    switch (propertyId) {
                        case "typedefinition":
                            let valueParts = value["typedefinition"].split("|");
                            let tmpItemParts = tmpItem["typedefinition"].split("|");
                            if (valueParts[0] === tmpItemParts[0]) {
                                if (valueParts[1] !== tmpItemParts[1]) {
                                    sameValue = false;
                                    diffProperties.push("datatype");
                                }
                                if (valueParts[2] !== tmpItemParts[2]) {
                                    sameValue = false;
                                    diffProperties.push("controltype");
                                }
                            }
                            else
                                sameValue = false;
                            break;
                        case "label":
                            if (value["labels"].length !== tmpItem["labels"].length)
                                sameValue = false;
                            else {
                                for (let idx = 0; idx < value["labels"].length; ++idx) {
                                    if (value["labels"][idx].text !== tmpItem["labels"][idx].text || value["labels"][idx].langid !== tmpItem["labels"][idx].langid)
                                        sameValue = false;
                                }
                            }
                            break;
                        case "helplabel":
                            if (value["helplabels"].length !== tmpItem["helplabels"].length)
                                sameValue = false;
                            else {
                                for (let idx = 0; idx < value["helplabels"].length; ++idx) {
                                    if (value["helplabels"][idx].text !== tmpItem["helplabels"][idx].text || value["helplabels"][idx].langid !== tmpItem["helplabels"][idx].langid)
                                        sameValue = false;
                                }
                            }
                            break;
                        case "collection":
                            if (value["dataname"] !== tmpItem["dataname"]) {
                                diffProperties.push("dataname");
                                sameValue = false;
                                let collection1 = this.clControlFactory.instance.collections.find(coll => coll.id === value["dataname"]);
                                let collection2 = this.clControlFactory.instance.collections.find(coll => coll.id === tmpItem["dataname"]);
                                if (collection1 && collection2) {
                                    if (collection1.isft !== collection2.isft)
                                        diffProperties.push("isft");
                                    if (collection1.embedded !== collection2.embedded)
                                        diffProperties.push("embedded");
                                    if (collection1.ismultilangft !== collection2.ismultilangft)
                                        diffProperties.push("ismultilangft");
                                }
                                else
                                    diffProperties = diffProperties.concat(["isft", "embedded", "ismultilangft"]);
                            }
                            if (value["datafield"] !== tmpItem["datafield"]) {
                                diffProperties.push("datafield");
                                sameValue = false;
                            }
                            if (value["isselfrefft"] !== tmpItem["isselfrefft"]) {
                                diffProperties.push("isselfrefft");
                                sameValue = false;
                            }
                            if (value["ftsort"] !== tmpItem["ftsort"]) {
                                diffProperties.push("ftsort");
                                sameValue = false;
                            }
                            if (value["dependentfield"] !== tmpItem["dependentfield"]) {
                                diffProperties.push("dependentfield");
                                sameValue = false;
                            }
                            break;
                        case "value":
                            if (value["max"] !== tmpItem["max"]) {
                                diffProperties.push("max");
                                sameValue = false;
                            }
                            if (value["min"] !== tmpItem["min"]) {
                                diffProperties.push("min");
                                sameValue = false;
                            }
                            if (value["steps"] !== tmpItem["steps"]) {
                                diffProperties.push("steps");
                                sameValue = false;
                            }
                            if (value["maxlength"] !== tmpItem["maxlength"]) {
                                diffProperties.push("maxlength");
                                sameValue = false;
                            }
                            break;
                        case "attachment":
                            if (value["max"] !== tmpItem["max"]) {
                                diffProperties.push("max");
                                sameValue = false;
                            }
                            if (value["min"] !== tmpItem["min"]) {
                                diffProperties.push("min");
                                sameValue = false;
                            }
                            if (value["aspectratio"] !== tmpItem["aspectratio"]) {
                                diffProperties.push("aspectratio");
                                sameValue = false;
                            }
                            if (value["imageonly"] !== tmpItem["imageonly"]) {
                                diffProperties.push("imageonly");
                                sameValue = false;
                            }
                            if (value["attachmentsource"] !== tmpItem["attachmentsource"]) {
                                diffProperties.push("attachmentsource");
                                sameValue = false;
                            }
                            break;
                        case "barcode":
                            if (value["usebarcode"] !== tmpItem["usebarcode"]) {
                                diffProperties.push("usebarcode");
                                sameValue = false;
                            }
                            if (value["barcodecolumn"] !== tmpItem["barcodecolumn"]) {
                                diffProperties.push("barcodecolumn");
                                sameValue = false;
                            }
                            if (value["barcoderegex"] !== tmpItem["barcoderegex"]) {
                                diffProperties.push("barcoderegex");
                                sameValue = false;
                            }
                            if (value["barcodetypes"] && tmpItem["barcodetypes"]) {
                                let filter1 = value["barcodetypes"].filter(item => tmpItem["barcodetypes"].indexOf(item) < 0);
                                let filter2 = tmpItem["barcodetypes"].filter(item => value["barcodetypes"].indexOf(item) < 0);
                                if (filter1.length > 0 || filter2.length > 0) {
                                    diffProperties.push("barcodetypes");
                                    sameValue = false;
                                }
                            }
                            else {
                                if (!(!value["barcodetypes"] && !tmpItem["barcodetypes"])) {
                                    diffProperties.push("barcodetypes");
                                    sameValue = false;
                                }
                            }
                            break;
                        case "variable":
                            if (value["variables"] && tmpItem["variables"]) {
                                let filter1 = value["variables"].filter(item => tmpItem["variables"].indexOf(item) < 0);
                                let filter2 = tmpItem["variables"].filter(item => value["variables"].indexOf(item) < 0);
                                if (filter1.length > 0) {
                                    diffProperties = diffProperties.concat(filter1);
                                    sameValue = false;
                                }
                                if (filter2.length > 0) {
                                    diffProperties = diffProperties.concat(filter2);
                                    sameValue = false;
                                }
                            }
                            else {
                                if (value["variables"]) {
                                    diffProperties = diffProperties.concat(value["variables"]);
                                    sameValue = false;
                                }
                                else if (tmpItem["variables"]) {
                                    diffProperties = diffProperties.concat(tmpItem["variables"]);
                                    sameValue = false;
                                }
                            }
                        case "telephone":
                            if (value["istelnr"] !== tmpItem["istelnr"]) {
                                diffProperties.push("istelnr");
                                sameValue = false;
                            }
                            if (value["telnrcolumn"] !== tmpItem["telnrcolumn"]) {
                                diffProperties.push("telnrcolumn");
                                sameValue = false;
                            }
                            break;
                        default:
                            if (value[propertyId] !== tmpItem[propertyId])
                                sameValue = false;
                            break;
                    }
                }
            });
            if (!sameValue) {
                switch (propertyId) {
                    case "typedefinition":
                        tmpItem["typedefinition"] = undefined;
                        $.each(diffProperties, (idx, prop) => {
                            tmpItem[prop] = undefined;
                        });
                        break;
                    case "label":
                        tmpItem["labels"] = [];
                        break;
                    case "helplabel":
                        tmpItem["helplabels"] = [];
                        break;
                    case "collection":
                    case "value":
                    case "attachment":
                    case "barcode":
                    case "variable":
                    case "telephone":
                        $.each(diffProperties, (idx, prop) => {
                            tmpItem[prop] = undefined;
                        });
                        break;
                    default:
                        tmpItem[propertyId] = undefined;
                }
            }
        }
        return { item: tmpItem, diffValue: !sameValue, diffProperties };
    }
    getItemProperties(item) {
        let propIds = ["typedefinition", "id", "externalid", "condition"];
        if (item["type"] === "field") {
            let field = item;
            let controltype = field["controltype"];
            let datatype = field["datatype"];
            if (datatype !== "StaticImage") {
                if (controltype === "StaticText")
                    propIds.push("staticlabel");
                else
                    propIds.push("label");
            }
            propIds.push("labelhorizontaloption");
            if (controltype !== "StaticText")
                propIds.push("helplabel");
            switch (controltype) {
                case "StaticText":
                    propIds = propIds.concat(["layoutposition", "visible"]);
                    break;
                case "Input":
                    propIds = propIds.concat(["labelverticaloption", "multivalue", "mandatory", "readonly", "visible", "value"]);
                    switch (datatype) {
                        case "String":
                            propIds = propIds.concat(["barcode", "telephone"]);
                            break;
                        case "Integer":
                            propIds = propIds.concat(["variable", "barcode"]);
                            break;
                        case "Time":
                        case "Date":
                        case "Datetime":
                            propIds.push("variable");
                            break;
                    }
                    break;
                case "TextArea":
                    propIds = propIds.concat(["labelverticaloption", "mandatory", "readonly", "visible", "rowcount", "value"]);
                    break;
                case "Radiobutton":
                    propIds = propIds.concat(["labelverticaloption", "multivalue", "mandatory", "readonly", "visible", "colcount", "removevalue"]);
                    break;
                case "Checkbox":
                    if (field.multivalue)
                        propIds = propIds.concat(["labelverticaloption", "multivalue", "mandatory", "readonly", "visible", "colcount"]);
                    else
                        propIds = propIds.concat(["labelverticaloption", "readonly", "visible"]);
                    break;
                case "Combobox":
                    propIds = propIds.concat(["labelverticaloption", "multivalue", "mandatory", "readonly", "visible", "variable", "barcode", "telephone"]);
                    break;
                case "ImageView":
                    if (datatype === "StaticImage")
                        propIds = propIds.concat(["layoutposition", "readonly", "visible", "maxwidth", "attachment"]);
                    else
                        propIds = propIds.concat(["labelverticaloption", "mandatory", "readonly", "visible", "colcount", "attachment"]);
                    break;
                case "Switch":
                    propIds = propIds.concat(["labelverticaloption", "readonly", "visible",]);
                    break;
                case "MultipleChoice":
                    propIds.push("multivalue");
                    if (!field.multivalue)
                        propIds.push("removevalue");
                    break;
                default:
                    break;
            }
            if (datatype === "List")
                propIds = propIds.concat(["linkedfield", "collection"]);
        }
        else if (item["type"] === "layoutitem") {
            propIds = propIds.concat(["visible", "color", "height"]);
        }
        else if (item["type"] === "group") {
            propIds = propIds.concat(["label", "helplabel", "visible", "backgroundcolor", "bordercolor"]);
        }
        else if (item["type"] === "page") {
            propIds = propIds.concat(["label", "helplabel", "visible", "backgroundcolor"]);
        }
        return propIds;
    }
    updateProperties(items, updateAnyway = false, reloadProperties = false) {
        let that = this;
        that.updateMenuAccordingToSelection();
        that.showConditionIcons(false);
        that.showLinkedFieldsIcons(false);
        that.showDependentFieldsIcons(false);
        $.each(that.clControlFactory.Items(), (idx, item) => {
            if (item) {
                item.listItem.removeClass("highlightControl");
                item.selectionIcon.removeClass("cl_selected");
            }
        });
        $.each(items, (idx, item) => {
            item.listItem.addClass("highlightControl");
            if (item["condition"])
                item.conditionIcon.addClass("highlightConditionIcon");
            if (item["linkedfield"] && (item["linkedfield"] !== item["id"]))
                item.linkedIcon.addClass("highlightConditionIcon");
            if (item["dependentfield"])
                item.dependentIcon.addClass("highlightConditionIcon");
            item.selectionIcon.addClass("cl_selected");
        });
        if (!updateAnyway || reloadProperties) {
            $.each(this.propertyMap, (key, value) => {
                this.propertyMap[key].setVisibility(false);
            });
        }
        if (items.length > 0) {
            let propIds = this.getJointProperties(items);
            let tmpItem = $.extend(true, {}, items[0]);
            if (items.length === 1) {
                this.highlightItemsForCondition(tmpItem);
                this.highlightLinkedFields(tmpItem);
                this.highlightDependentFields(tmpItem);
            }
            // if properties contain barcode show mobile header
            if (propIds.find(id => id === "barcode"))
                this.propertiesMobileColumn.show();
            else
                this.propertiesMobileColumn.hide();
            $.each(propIds, (idx, property) => {
                if (items.length === 1) {
                    this.propertyMap[property].setItem(tmpItem, items, false);
                    let readonly = false;
                    let enabled = true;
                    switch (property) {
                        case "id":
                            enabled = false;
                            break;
                        case "typedefinition":
                        case "labelhorizontaloption":
                        case "labelverticaloption":
                        case "layoutposition":
                            readonly = true;
                            break;
                        case "mandatory":
                        case "removevalue":
                            enabled = !tmpItem["readonly"];
                            break;
                        case "readonly":
                            enabled = !tmpItem["mandatory"];
                            break;
                    }
                    this.propertyMap[property].setVisibility(true, enabled, readonly);
                }
                else {
                    let res = that.getItemsProperty(items, property, tmpItem);
                    tmpItem = res.item;
                    this.propertyMap[property].setItem(tmpItem, items, res.diffValue, res.diffProperties);
                    let readonly = false;
                    let enabled = true;
                    switch (property) {
                        case "id":
                            enabled = false;
                            break;
                        case "typedefinition":
                        case "labelhorizontaloption":
                        case "labelverticaloption":
                        case "layoutposition":
                            readonly = true;
                            break;
                    }
                    this.propertyMap[property].setVisibility(true, enabled, readonly);
                }
            });
        }
        else {
            this.propertiesMobileColumn.hide();
            $("#cl_preview_layout").trigger("clshowrelations");
        }
    }
    updatePropertiesAfterRemove() {
        let selectedElements = $("#cl_preview_layout").find(".cl_draggable.previewControl.highlightControl");
        let selectedItems = [];
        $.each(selectedElements, (idx, element) => {
            let tmpItemId = element.getAttribute("cl_itemid");
            selectedItems.push(this.clControlFactory.getItemById(tmpItemId));
        });
        this.selectedItems = selectedItems;
        this.updateProperties(this.selectedItems);
        this.updateItemsInfo(this.checklist.layout);
    }
    updateTemplateInfo(savedInstance) {
        this.clControlFactory.instance["istemplate"] = savedInstance["istemplate"];
        this.clControlFactory.instance["checklistid"] = savedInstance["checklistid"];
        this.clControlFactory.instance["templateid"] = savedInstance["templateid"];
        this.clControlFactory.instance["templateversion"] = savedInstance["templateversion"];
        if (this.clControlFactory.instance["istemplate"])
            $("#cl_designer_istemplatecb").prop("checked", true);
        $("#cl_designer_templateversioninput").val(this.clControlFactory.instance["templateversion"]);
    }
    createChecklistProperties(propertiesColumn) {
        let that = this;
        let isTemplateContainer = $("<div id='cl_designer_istemplate_container' class='clpropertyitem clpropertyfirstitem'/>").appendTo(propertiesColumn);
        let templateVersionContainer = $("<div id='cl_designer_templateversion_container' class='clpropertyitem' />").appendTo(propertiesColumn);
        let defLangContainer = $("<div  id='cl_designer_deflang_container' class='clpropertyitem' />").appendTo(propertiesColumn);
        let defCultureContainer = $("<div id='cl_designer_defculture_container' class='clpropertyitem' />").appendTo(propertiesColumn);
        let maxWidthContainer = $("<div id='cl_designer_maxwidth_container' class='clpropertyitem' />").appendTo(propertiesColumn);
        let minWidthContainer = $("<div id='cl_designer_minwidth_container' class='clpropertyitem' />").appendTo(propertiesColumn);
        let rowSpacingContainer = $("<div id='cl_designer_rowspacing_container' class='clpropertyitem' />").appendTo(propertiesColumn);
        let fontSizeContainer = $("<div id='cl_designer_fontsize_container' class='clpropertyitem' />").appendTo(propertiesColumn);
        let jpegQualityContainer = $("<div id='cl_designer_fontsize_container' class='clpropertyitem' />").appendTo(propertiesColumn);
        let isTemplateLabelOuterContainer = $("<div id='cl_designer_istemplate_label_outercontainer' class='clpropertylabeloutercontainer'>").appendTo(isTemplateContainer);
        let isTemplateLabelInnerContainer = $("<div id='cl_designer_istemplate_label_innercontainer' class='clpropertylabelinnercontainer'>").appendTo(isTemplateLabelOuterContainer);
        let isTemplateControlOuterContainer = $("<div id='cl_designer_istemplate_control_outercontainer' class='clpropertycontroloutercontainer'>").appendTo(isTemplateContainer);
        let isTemplateControlInnerContainer = $("<div id='cl_designer_istemplate_control_innercontainer' class='clpropertycontrolinnercontainer'>").appendTo(isTemplateControlOuterContainer);
        let templateVersionLabelOuterContainer = $("<div id='cl_designer_templateversion_label_outercontainer' class='clpropertylabeloutercontainer'>").appendTo(templateVersionContainer);
        let templateVersionLabelInnerContainer = $("<div id='cl_designer_templateversion_label_innercontainer' class='clpropertylabelinnercontainer'>").appendTo(templateVersionLabelOuterContainer);
        let templateVersionControlOuterContainer = $("<div id='cl_designer_templateversion_control_outercontainer' class='clpropertycontroloutercontainer'>").appendTo(templateVersionContainer);
        let templateVersionControlInnerContainer = $("<div id='cl_designer_templateversion_control_innercontainer' class='clpropertycontrolinnercontainer'>").appendTo(templateVersionControlOuterContainer);
        let defLangLabelOuterContainer = $("<div id='cl_designer_deflang_label_outercontainer' class='clpropertylabeloutercontainer'>").appendTo(defLangContainer);
        let defLangLabelInnerContainer = $("<div id='cl_designer_deflang_label_innercontainer' class='clpropertylabelinnercontainer'>").appendTo(defLangLabelOuterContainer);
        let defLangControlOuterContainer = $("<div id='cl_designer_deflang_control_outercontainer' class='clpropertycontroloutercontainer'>").appendTo(defLangContainer);
        let defLangControlInnerContainer = $("<div id='cl_designer_deflang_control_innercontainer' class='clpropertycontrolinnercontainer'>").appendTo(defLangControlOuterContainer);
        let defCultureLabelOuterContainer = $("<div id='cl_designer_defculture_label_outercontainer' class='clpropertylabeloutercontainer'>").appendTo(defCultureContainer);
        let defCultureLabelInnerContainer = $("<div id='cl_designer_defculture_label_innercontainer' class='clpropertylabelinnercontainer'>").appendTo(defCultureLabelOuterContainer);
        let defCultureControlOuterContainer = $("<div id='cl_designer_defculture_control_outercontainer' class='clpropertycontroloutercontainer'>").appendTo(defCultureContainer);
        let defCultureControlInnerContainer = $("<div id='cl_designer_defculture_control_innercontainer' class='clpropertycontrolinnercontainer'>").appendTo(defCultureControlOuterContainer);
        let maxWidthLabelOuterContainer = $("<div id='cl_designer_maxwidth_label_outercontainer' class='clpropertylabeloutercontainer'>").appendTo(maxWidthContainer);
        let maxWidthLabelInnerContainer = $("<div id='cl_designer_maxwidth_label_innercontainer' class='clpropertylabelinnercontainer'>").appendTo(maxWidthLabelOuterContainer);
        let maxWidthControlOuterContainer = $("<div id='cl_designer_maxwidth_control_outercontainer' class='clpropertycontroloutercontainer'>").appendTo(maxWidthContainer);
        let maxWidthControlInnerContainer = $("<div id='cl_designer_maxwidth_control_innercontainer' class='clpropertycontrolinnercontainer'>").appendTo(maxWidthControlOuterContainer);
        let minWidthLabelOuterContainer = $("<div id='cl_designer_minwidth_label_outercontainer' class='clpropertylabeloutercontainer'>").appendTo(minWidthContainer);
        let minWidthLabelInnerContainer = $("<div id='cl_designer_minwidth_label_innercontainer' class='clpropertylabelinnercontainer'>").appendTo(minWidthLabelOuterContainer);
        let minWidthControlOuterContainer = $("<div id='cl_designer_minwidth_control_outercontainer' class='clpropertycontroloutercontainer'>").appendTo(minWidthContainer);
        let minWidthControlInnerContainer = $("<div id='cl_designer_minwidth_control_innercontainer' class='clpropertycontrolinnercontainer'>").appendTo(minWidthControlOuterContainer);
        let rowSpacingLabelOuterContainer = $("<div id='cl_designer_rowspacing_label_outercontainer' class='clpropertylabeloutercontainer'>").appendTo(rowSpacingContainer);
        let rowSpacingLabelInnerContainer = $("<div id='cl_designer_rowspacing_label_innercontainer' class='clpropertylabelinnercontainer'>").appendTo(rowSpacingLabelOuterContainer);
        let rowSpacingControlOuterContainer = $("<div id='cl_designer_rowspacing_control_outercontainer' class='clpropertycontroloutercontainer'>").appendTo(rowSpacingContainer);
        let rowSpacingControlInnerContainer = $("<div id='cl_designer_rowspacing_control_innercontainer' class='clpropertycontrolinnercontainer'>").appendTo(rowSpacingControlOuterContainer);
        let fontSizeLabelOuterContainer = $("<div id='cl_designer_fontsize_label_outercontainer' class='clpropertylabeloutercontainer'>").appendTo(fontSizeContainer);
        let fontSizeLabelInnerContainer = $("<div id='cl_designer_fontsize_label_innercontainer' class='clpropertylabelinnercontainer'>").appendTo(fontSizeLabelOuterContainer);
        let fontSizeControlOuterContainer = $("<div id='cl_designer_fontsize_control_outercontainer' class='clpropertycontroloutercontainer'>").appendTo(fontSizeContainer);
        let fontSizeControlInnerContainer = $("<div id='cl_designer_fontsize_control_innercontainer' class='clpropertycontrolinnercontainer'>").appendTo(fontSizeControlOuterContainer);
        let jpegQualityLabelOuterContainer = $("<div id='cl_designer_jpegquality_label_outercontainer' class='clpropertylabeloutercontainer'>").appendTo(jpegQualityContainer);
        let jpegQualityLabelInnerContainer = $("<div id='cl_designer_jpegquality_label_innercontainer' class='clpropertylabelinnercontainer'>").appendTo(jpegQualityLabelOuterContainer);
        let jpegQualityControlOuterContainer = $("<div id='cl_designer_jpegquality_control_outercontainer' class='clpropertycontroloutercontainer'>").appendTo(jpegQualityContainer);
        let jpegQualityControlInnerContainer = $("<div id='cl_designer_jpegquality_control_innercontainer' class='clpropertycontrolinnercontainer'>").appendTo(jpegQualityControlOuterContainer);
        $("<label>" + Utilities_1.synUtil.Strings.getValue("clistemplateproperty") + "</label>").appendTo(isTemplateLabelInnerContainer);
        $("<label>" + Utilities_1.synUtil.Strings.getValue("cltemplateversionproperty") + "</label>").appendTo(templateVersionLabelInnerContainer);
        $("<label>" + Utilities_1.synUtil.Strings.getValue("cldeflangproperty") + "</label>").appendTo(defLangLabelInnerContainer);
        $("<label>" + Utilities_1.synUtil.Strings.getValue("cldefcultureproperty") + "</label>").appendTo(defCultureLabelInnerContainer);
        $("<label>" + Utilities_1.synUtil.Strings.getValue("clmaxwidthproperty") + "</label>").appendTo(maxWidthLabelInnerContainer);
        $("<label>" + Utilities_1.synUtil.Strings.getValue("clminwidthproperty") + "</label>").appendTo(minWidthLabelInnerContainer);
        $("<label>" + Utilities_1.synUtil.Strings.getValue("clrowspacingproperty") + "</label>").appendTo(rowSpacingLabelInnerContainer);
        $("<label>" + Utilities_1.synUtil.Strings.getValue("clfontsizeproperty") + "</label>").appendTo(fontSizeLabelInnerContainer);
        $("<label>" + Utilities_1.synUtil.Strings.getValue("cljpegqualityproperty") + "</label>").appendTo(jpegQualityLabelInnerContainer);
        let isTemplateCheckBoxContainer = $("<div style='width:1.5em; display:inline-block;' />").appendTo(isTemplateControlInnerContainer);
        let newTemplateButtonContainer = $("<div style='width:calc(100% - 1.5em); display:inline-block; text-align:right; white-space: pre-wrap;' />").appendTo(isTemplateControlInnerContainer);
        let isTemplateCheckBox = $("<input id='cl_designer_istemplatecb' type='checkbox' style='vertical-align: middle;'>").appendTo(isTemplateCheckBoxContainer);
        let newTemplateButton = $("<button id='cl_designer_newtemplatebtn' type='button' class='btn btn-primary' style=' max-width: 100%; box-sizing: border-box; white-space: pre-wrap;' >" + Utilities_1.synUtil.Strings.getValue("clgeneratenewtemplatelabelproperty") + "</button>").appendTo(newTemplateButtonContainer);
        let templateVersionInput = $("<input id='cl_designer_templateversioninput' style='width:100%;' type='text' class='clInput k-textbox' >").appendTo(templateVersionControlInnerContainer);
        let defLangIdDropDown = $("<input id='cl_designer_deflangdropdown' style='width:100%;'>").appendTo(defLangControlInnerContainer);
        let defCultureDropDown = $("<input id='cl_designer_defculturedropdown' style='width:100%;'>").appendTo(defCultureControlInnerContainer);
        let maxWidthInput = $("<input id='cl_designer_maxwidthinput' style='width:100%;'>").appendTo(maxWidthControlInnerContainer);
        let minWidthInput = $("<input id='cl_designer_minwidthinput' style='width:100%;'>").appendTo(minWidthControlInnerContainer);
        let rowSpacingInput = $("<input id='cl_designer_rowspacinginput' style='width:100%;'>").appendTo(rowSpacingControlInnerContainer);
        let fontSizeInput = $("<input id='cl_designer_fontsizeinput' style='width:100%;'>").appendTo(fontSizeControlInnerContainer);
        let jpegQualityInput = $("<input id='cl_designer_jpegqualityinput' style='width:100%;'>").appendTo(jpegQualityControlInnerContainer);
        isTemplateCheckBox.attr("disabled", "disabled");
        isTemplateCheckBox.addClass("clReadOnly");
        templateVersionInput.attr("disabled", "disabled");
        templateVersionInput.addClass("clReadOnly");
        if (that.clControlFactory.instance["istemplate"])
            isTemplateCheckBox.prop("checked", true);
        templateVersionInput.val(that.clControlFactory.instance["templateversion"]);
        newTemplateButton.on("click", function () {
            let checklist = that.getChecklist();
            let checklistSaveUrl = Utilities_1.synUtil.getWSUrl("ChecklistSaveInstance");
            let requestdata = {
                instance: JSON.stringify(checklist),
                id: checklist.synerisid,
                checkin: false,
                fromDesigner: true,
                newtemplate: true,
                haschanged: true
            };
            Utilities_1.synUtil.getAJAXData({
                method: "PUT",
                url: checklistSaveUrl,
                requestData: requestdata,
                done(templateInfo) {
                    if (templateInfo) {
                        that.updateTemplateInfo(templateInfo);
                    }
                    Utilities_1.synUtil.Notifications.success(Utilities_1.synUtil.Strings.getValue("savedchanges"));
                    that.clControlFactory.setChecklistChanged(false);
                },
            });
        });
        defLangIdDropDown.kendoDropDownList({
            dataTextField: "name",
            dataValueField: "id",
            noDataTemplate: kendo.htmlEncode(Utilities_1.synUtil.Strings.getValue("dynpnomatchingitemfound")),
            change(e) {
                that.clControlFactory.instance.langid = e.sender.value();
                that.clControlFactory.userUILangId = e.sender.value();
                that.updateLabels();
                if (that.selectedItems)
                    that.updateProperties(that.selectedItems, true);
                that.clControlFactory.setChecklistChanged(true);
            },
        });
        defCultureDropDown.kendoDropDownList({
            dataTextField: "name",
            dataValueField: "id",
            noDataTemplate: kendo.htmlEncode(Utilities_1.synUtil.Strings.getValue("dynpnomatchingitemfound")),
            change(e) {
                if (e.sender.dataItem()) {
                    let culture = e.sender.dataItem()["code"];
                    that.clControlFactory.instance.culture = culture;
                    that.clControlFactory.userCulture = culture;
                    $.each(that.clControlFactory.Fields(), (idx, item) => {
                        let control = that.clControlFactory.getFieldControl(item.id);
                        if (control instanceof ChecklistControls_1.ClDatetime || control instanceof ChecklistControls_1.ClNumericInput) {
                            let oldControl = $("#" + control.id + "_item");
                            let parentControl = oldControl.parent();
                            oldControl.remove();
                            let updatePropertyControlAgain = false;
                            let pageId = control.getPageId();
                            if (control instanceof ChecklistControls_1.ClDatetime)
                                control = new ChecklistControls_1.ClDatetime(control.field["id"], control.field, that.clControlFactory, control.levelcount, control.field["datatype"]);
                            else
                                control = new ChecklistControls_1.ClNumericInput(control.field["id"], control.field, that.clControlFactory, control.levelcount, control.field["datatype"]);
                            control.setPageId(pageId);
                            control.init(parentControl);
                            if (updatePropertyControlAgain)
                                this.updateProperties([control.field], true);
                        }
                    });
                    that.clControlFactory.setChecklistChanged(true);
                }
            },
        });
        maxWidthInput.kendoNumericTextBox({
            min: 0,
            max: 100,
            decimals: 0,
            format: "# \\%",
            step: 1,
            downArrowText: "",
            upArrowText: "",
            change: (e) => {
                if (e.sender.value())
                    this.clControlFactory.instance["maxwidth"] = e.sender.value();
                else
                    this.clControlFactory.instance["maxwidth"] = 0;
                that.clControlFactory.setChecklistChanged(true);
            }
        });
        maxWidthInput.parent().children("input.k-input").removeAttr("title");
        maxWidthInput.data("kendoNumericTextBox").value(that.clControlFactory.instance["maxwidth"]);
        minWidthInput.kendoNumericTextBox({
            min: 0,
            decimals: 0,
            step: 1,
            format: "# px",
            downArrowText: "",
            upArrowText: "",
            change: (e) => {
                if (e.sender.value())
                    this.clControlFactory.instance["minwidth"] = e.sender.value();
                else
                    this.clControlFactory.instance["minwidth"] = 0;
                that.clControlFactory.setChecklistChanged(true);
            }
        });
        minWidthInput.parent().children("input.k-input").removeAttr("title");
        minWidthInput.data("kendoNumericTextBox").value(that.clControlFactory.instance["minwidth"]);
        rowSpacingInput.kendoNumericTextBox({
            min: 0,
            decimals: 0,
            step: 1,
            format: "# px",
            downArrowText: "",
            upArrowText: "",
            change: (e) => {
                if (e.sender.value())
                    this.clControlFactory.instance["rowspacing"] = e.sender.value();
                else
                    this.clControlFactory.instance["rowspacing"] = 0;
                that.clControlFactory.setChecklistChanged(true);
            }
        });
        rowSpacingInput.parent().children("input.k-input").removeAttr("title");
        rowSpacingInput.data("kendoNumericTextBox").value(that.clControlFactory.instance["rowspacing"]);
        fontSizeInput.kendoNumericTextBox({
            min: 0,
            decimals: 0,
            step: 1,
            format: "# px",
            downArrowText: "",
            upArrowText: "",
            change: (e) => {
                this.clControlFactory.instance["fontsize"] = e.sender.value();
                that.clControlFactory.setChecklistChanged(true);
            }
        });
        fontSizeInput.parent().children("input.k-input").removeAttr("title");
        if (that.clControlFactory.instance["fontsize"])
            fontSizeInput.data("kendoNumericTextBox").value(that.clControlFactory.instance["fontsize"]);
        jpegQualityInput.kendoNumericTextBox({
            min: 0,
            max: 100,
            decimals: 0,
            format: "# \\%",
            step: 1,
            downArrowText: "",
            upArrowText: "",
            change: (e) => {
                if (e.sender.value())
                    this.clControlFactory.instance["jpegquality"] = e.sender.value();
                else
                    this.clControlFactory.instance["jpegquality"] = 0;
                that.clControlFactory.setChecklistChanged(true);
            }
        });
        jpegQualityInput.parent().children("input.k-input").removeAttr("title");
        jpegQualityInput.data("kendoNumericTextBox").value(that.clControlFactory.instance["jpegquality"]);
        let userLangCallBack = function (langid) {
            let allLangCallback = function (userLangId, allLangIds) {
                that.allLangIds = allLangIds;
                defLangIdDropDown.data("kendoDropDownList").setDataSource(new kendo.data.DataSource({ data: allLangIds }));
                defLangIdDropDown.data("kendoDropDownList").value(userLangId);
            };
            Utilities_1.synUtil.getAJAXData({
                method: "POST",
                url: Utilities_1.synUtil.getWSUrl("ForeigntableEntries") + "dzvlanguage/",
                done(languages) {
                    let languageNames = [];
                    if (languages.items) {
                        $.each(languages.items, (idx, value) => {
                            languageNames.push({ name: value["name"], id: value["id"] });
                        });
                    }
                    allLangCallback(langid, languageNames);
                },
                fail(jqXHR, textStatus, errorThrown, url) {
                    Utilities_1.synUtil.getAJAXDataFail(jqXHR, textStatus, errorThrown, url);
                }
            });
        };
        let userCultureCallback = function (cultureid) {
            let allCultureCallback = function (userCultureId, allCultureIds) {
                that.allCultureIds = allCultureIds;
                defCultureDropDown.data("kendoDropDownList").setDataSource(new kendo.data.DataSource({ data: allCultureIds }));
                let cultureId = "";
                $.each(allCultureIds, (idx, value) => {
                    if (value["code"] === userCultureId)
                        cultureId = value["id"];
                });
                defCultureDropDown.data("kendoDropDownList").value(cultureId);
            };
            Utilities_1.synUtil.getAJAXData({
                method: "POST",
                url: Utilities_1.synUtil.getWSUrl("ForeigntableEntries") + "dzvculture/",
                done(cultures) {
                    let cultureNames = [];
                    if (cultures.items) {
                        $.each(cultures.items, (idx, value) => {
                            cultureNames.push({ name: value["name"], id: value["id"], code: value["code"] });
                        });
                    }
                    allCultureCallback(cultureid, cultureNames);
                },
                fail(jqXHR, textStatus, errorThrown, url) {
                    Utilities_1.synUtil.getAJAXDataFail(jqXHR, textStatus, errorThrown, url);
                }
            });
        };
        if (that.clControlFactory.instance.langid) {
            that.clControlFactory.userUILangId = that.clControlFactory.instance.langid;
            userLangCallBack(that.clControlFactory.userUILangId);
        }
        else {
            Utilities_1.synUtil.getAJAXData({
                method: "GET",
                url: Utilities_1.synUtil.getWSUrl("UserInfo"),
                done(userData) {
                    userLangCallBack(userData.userInfo.UILanguageId);
                },
                fail(jqXHR, textStatus, errorThrown, url) {
                    Utilities_1.synUtil.getAJAXDataFail(jqXHR, textStatus, errorThrown, url);
                }
            });
        }
        if (that.clControlFactory.instance.culture) {
            that.clControlFactory.userCulture = that.clControlFactory.instance.culture;
            userCultureCallback(that.clControlFactory.userCulture);
        }
        else {
            Utilities_1.synUtil.getAJAXData({
                method: "GET",
                url: Utilities_1.synUtil.getWSUrl("UserInfo"),
                done(userDataJSON) {
                    return tslib_1.__awaiter(this, void 0, void 0, function* () {
                        let instance = yield Instance_1.Instance.fromJSON(userDataJSON.instance);
                        userCultureCallback(instance.items["dzvculture.code"].value);
                    });
                },
                fail(jqXHR, textStatus, errorThrown, url) {
                    Utilities_1.synUtil.getAJAXDataFail(jqXHR, textStatus, errorThrown, url);
                }
            });
        }
    }
    updateLabels() {
        this.updateLabelsInternal(this.clControlFactory.instance.layout);
    }
    updateLabelsInternal(layout) {
        let that = this;
        $.each(layout, (idx, item) => {
            let control = that.clControlFactory.getFieldControl(item.id);
            control.resetLabel(undefined);
            control.resetHelpLabel(undefined);
            that.setHelpToolbarItem();
            that.clControlFactory.updateControl(item.id, control);
            if (item["datatype"] === "List") {
                if (control instanceof ChecklistControls_1.ClMVCheckBoxRadio || control instanceof ChecklistControls_1.ClMultipleChoice) {
                    control.resetData(undefined, undefined, undefined, false);
                    that.clControlFactory.updateControl(item.id, control);
                }
                else {
                    let innerCallback = function (datapresentedinfo) {
                        if (datapresentedinfo) {
                            if (!item["datapresentedinfo"])
                                item["datapresentedinfo"] = {};
                            $.each(datapresentedinfo, (key, value) => {
                                item["datapresentedinfo"][key] = value;
                            });
                        }
                        let newControl;
                        switch (item["controltype"]) {
                            case "Radiobutton":
                                newControl = new ChecklistControls_1.ClMVCheckBoxRadio(item.id, item, that.clControlFactory, 0, item["controltype"]);
                                break;
                            case "Checkbox":
                                newControl = new ChecklistControls_1.ClMVCheckBoxRadio(item.id, item, that.clControlFactory, 0, item["controltype"]);
                                break;
                            case "Combobox":
                                if (item["isselfrefft"])
                                    newControl = new ChecklistControls_1.ClSRComboboxContainer(item.id, item, that.clControlFactory, 0);
                                else
                                    newControl = new ChecklistControls_1.ClCombobox(item.id, item, that.clControlFactory, 0);
                                break;
                            case "MultipleChoice":
                                newControl = new ChecklistControls_1.ClMultipleChoice(item.id, item, that.clControlFactory, 0);
                                break;
                        }
                        if (newControl != undefined) {
                            newControl.setPageId(control.getPageId());
                            let jQueryParent = $("#" + control.id + "_item").closest('.previewControl');
                            jQueryParent.children('.checklistrow').remove();
                            newControl.init(jQueryParent);
                            control = newControl;
                        }
                        that.clControlFactory.updateControl(item.id, control);
                    };
                    if (item["controltype"] === "MultipleChoice") {
                        item["correctvalues"] = control.getValue();
                        that.clControlFactory.getComboboxInfo(item, control.getValue(), innerCallback);
                    }
                    else {
                        item["value"] = control.getValue();
                        that.clControlFactory.getComboboxInfo(item, control.getValue(), innerCallback);
                    }
                }
            }
            if (item["type"] === "group" || item["type"] === "page") {
                that.updateLabelsInternal(item.layout);
            }
        });
        that.updateItemsInfo(that.checklist.layout);
    }
    removeValue(clControlFactory, field) {
        let that = this;
        if (field.controltype === "Radiobutton" || field.controltype === "MultipleChoice") {
            let control = clControlFactory.getFieldControl(field["id"]);
            control.setValue(undefined);
            control.notifyChange();
            if (field.controltype === "Radiobutton")
                field["value"] = undefined;
            else
                field["correctvalues"] = undefined;
            clControlFactory.updateControl(field.id, control);
        }
    }
    getTypeDefinitionLabel(typeDefiniton) {
        let idx1 = typeDefiniton.indexOf("|");
        let idx2 = typeDefiniton.lastIndexOf("|");
        let type = typeDefiniton.substr(0, idx1);
        idx1 += 1;
        let datatype = typeDefiniton.substr(idx1, idx2 - idx1);
        let controltype = typeDefiniton.substr(idx2 + 1);
        let label;
        if (type === "group")
            label = Utilities_1.synUtil.Strings.getValue("clgroupcontrol");
        else if (type === "page")
            label = Utilities_1.synUtil.Strings.getValue("clpagecontrol");
        else if (type === "layoutitem")
            label = Utilities_1.synUtil.Strings.getValue("clhorizontallinecontrol");
        else if (type === "field") {
            switch (datatype) {
                case "String":
                    if (controltype === "Input")
                        label = Utilities_1.synUtil.Strings.getValue("clstringinputcontrol");
                    else if (controltype === "TextArea")
                        label = Utilities_1.synUtil.Strings.getValue("cltextareacontrol");
                    else if (controltype === "StaticText")
                        label = Utilities_1.synUtil.Strings.getValue("clstatictextcontrol");
                    break;
                case "Integer":
                    label = Utilities_1.synUtil.Strings.getValue("clintinputcontrol");
                    break;
                case "Float":
                    label = Utilities_1.synUtil.Strings.getValue("clfloatinputcontrol");
                    break;
                case "Bool":
                    if (controltype === "Switch")
                        label = Utilities_1.synUtil.Strings.getValue("clsswitchcontrol");
                    else
                        label = Utilities_1.synUtil.Strings.getValue("clcheckboxcontrol");
                    break;
                case "Time":
                    label = Utilities_1.synUtil.Strings.getValue("cltimeinputcontrol");
                    break;
                case "Date":
                    label = Utilities_1.synUtil.Strings.getValue("cldateinputcontrol");
                    break;
                case "Datetime":
                    label = Utilities_1.synUtil.Strings.getValue("cldatetimeinputcontrol");
                    break;
                case "List":
                    if (controltype === "List" || controltype === "Checkbox" || controltype === "Radiobutton")
                        label = Utilities_1.synUtil.Strings.getValue("cllistcontrol");
                    else if (controltype === "Combobox")
                        label = Utilities_1.synUtil.Strings.getValue("clcomboboxcontrol");
                    else if (controltype === "MultipleChoice")
                        label = Utilities_1.synUtil.Strings.getValue("clmultiplechoicecontrol");
                    break;
                case "StaticImage":
                    label = Utilities_1.synUtil.Strings.getValue("clstaticattachmentcontrol");
                    break;
                case "EmbeddedImage":
                    label = Utilities_1.synUtil.Strings.getValue("clembeddedattachmentcontrol");
                    break;
            }
        }
        return label;
    }
    getAvailableControlTypes(item, selectedItems) {
        let that = this;
        let controlTypes = new Array();
        if (item["datatype"] && that.ControlDataTypeMap[item["datatype"]]) {
            let possibleControlTypes = that.ControlDataTypeMap[item["datatype"]];
            let allControlTypePossible = false;
            switch (item["datatype"]) {
                case "Bool":
                    controlTypes = possibleControlTypes;
                    break;
                case "String":
                    let noControlTypePossible = false;
                    allControlTypePossible = true;
                    $.each(selectedItems, (idx, it) => {
                        if (it["controltype"] === "StaticText")
                            noControlTypePossible = true;
                        if (it["multivalue"] || it["usebarcode"] || it["istelnr"])
                            allControlTypePossible = false;
                    });
                    if (!noControlTypePossible) {
                        if (allControlTypePossible)
                            controlTypes = possibleControlTypes;
                        else
                            controlTypes = ["field|String|Input"];
                    }
                    break;
                case "List":
                    allControlTypePossible = true;
                    $.each(selectedItems, (idx, it) => {
                        if (it["isselfrefft"] || it["usebarcode"] || it["istelnr"])
                            allControlTypePossible = false;
                    });
                    if (allControlTypePossible)
                        controlTypes = possibleControlTypes;
                    else
                        controlTypes = ["field|List|Combobox"];
                    break;
            }
        }
        return controlTypes;
    }
    createFieldProperties(propertiesColumn) {
        let commonPropertiesColumn = $("<div />").appendTo(propertiesColumn);
        let mobilePropertiesColumn = $("<div />").appendTo(propertiesColumn);
        this.propertiesMobileColumn = $("<div class='propertiesMobileColumnContainer'><label class='propertiesMobileColumnLabel'>" +
            Utilities_1.synUtil.Strings.getValue("clcontrolpropertiesmobileheadinglabel") + "</label></div>").appendTo(mobilePropertiesColumn);
        this.propertiesMobileColumn.hide();
        // TypeDefinition
        let typedefinitionProperty = new PropertyItem(this, "typedefinition", Utilities_1.synUtil.Strings.getValue("cltypedefinitionproperty"), false, "Combobox", "text", undefined);
        typedefinitionProperty.init(commonPropertiesColumn);
        this.propertyMap["typedefinition"] = typedefinitionProperty;
        // Id
        let idProperty = new PropertyItem(this, "id", Utilities_1.synUtil.Strings.getValue("clidproperty"), true, "Input", "text", undefined);
        idProperty.init(commonPropertiesColumn);
        this.propertyMap["id"] = idProperty;
        // ExternalId
        let externalidProperty = new PropertyItem(this, "externalid", Utilities_1.synUtil.Strings.getValue("clexternalidproperty"), true, "Input", "text", undefined);
        externalidProperty.init(commonPropertiesColumn);
        this.propertyMap["externalid"] = externalidProperty;
        // StaticLabel
        let staticlabelProperty = new PropertyLabelContainer("staticlabel", Utilities_1.synUtil.Strings.getValue("cllabelproperty"), true, this, true);
        staticlabelProperty.propertyId = "label";
        staticlabelProperty.init(commonPropertiesColumn);
        this.propertyMap["staticlabel"] = staticlabelProperty;
        // Label
        let labelProperty = new PropertyLabelContainer("label", Utilities_1.synUtil.Strings.getValue("cllabelproperty"), true, this, false);
        labelProperty.init(commonPropertiesColumn);
        this.propertyMap["label"] = labelProperty;
        // HelpLabel
        let helpLabelProperty = new PropertyLabelContainer("helplabel", Utilities_1.synUtil.Strings.getValue("clhelplabelproperty"), true, this, false);
        helpLabelProperty.init(commonPropertiesColumn);
        this.propertyMap["helplabel"] = helpLabelProperty;
        // Label Horizontal option
        let labelhorizontaloptionProperty = new PropertyItem(this, "labelhorizontaloption", Utilities_1.synUtil.Strings.getValue("cllabelhorizontaloptionproperty"), true, "Combobox", undefined, [{
                id: "Left", name: Utilities_1.synUtil.Strings.getValue("cllabelhorizontaloptionleftlabelproperty")
            }, { id: "Right", name: Utilities_1.synUtil.Strings.getValue("cllabelhorizontaloptionrightlabelproperty") }, { id: "Center", name: Utilities_1.synUtil.Strings.getValue("cllabelhorizontaloptioncenterlabelproperty") }, { id: "Justify", name: Utilities_1.synUtil.Strings.getValue("cllabelhorizontaloptionjustifylabelproperty") }]);
        labelhorizontaloptionProperty.init(commonPropertiesColumn);
        this.propertyMap["labelhorizontaloption"] = labelhorizontaloptionProperty;
        // Label Vertical option
        let labelverticaloptionProperty = new PropertyItem(this, "labelverticaloption", Utilities_1.synUtil.Strings.getValue("cllabelverticaloptionproperty"), true, "Combobox", undefined, [{ id: "Top", name: Utilities_1.synUtil.Strings.getValue("cllabelverticaloptiontoplabelproperty") }, { id: "Bottom", name: Utilities_1.synUtil.Strings.getValue("cllabelverticaloptionbottomlabelproperty") }, { id: "Middle", name: Utilities_1.synUtil.Strings.getValue("cllabelverticaloptionmiddlelabelproperty") }]);
        labelverticaloptionProperty.init(commonPropertiesColumn);
        this.propertyMap["labelverticaloption"] = labelverticaloptionProperty;
        // Horizontal position
        let layoutpositionProperty = new PropertyItem(this, "layoutposition", Utilities_1.synUtil.Strings.getValue("cllayoutpositionproperty"), true, "Combobox", undefined, [{ id: "All", name: Utilities_1.synUtil.Strings.getValue("cllayoutpositionalllabelproperty") }, { id: "Label", name: Utilities_1.synUtil.Strings.getValue("cllayoutpositionlabellabelproperty") }, { id: "Control", name: Utilities_1.synUtil.Strings.getValue("cllayoutpositioncontrollabelproperty") }]);
        layoutpositionProperty.init(commonPropertiesColumn);
        this.propertyMap["layoutposition"] = layoutpositionProperty;
        // Multivalue
        let multivalueProperty = new PropertyItem(this, "multivalue", Utilities_1.synUtil.Strings.getValue("clmultivalueproperty"), false, "Input", "checkbox", undefined);
        multivalueProperty.init(commonPropertiesColumn);
        this.propertyMap["multivalue"] = multivalueProperty;
        // Mandatory
        let mandatoryProperty = new PropertyItem(this, "mandatory", Utilities_1.synUtil.Strings.getValue("clmandatoryproperty"), false, "Input", "checkbox", undefined);
        mandatoryProperty.init(commonPropertiesColumn);
        this.propertyMap["mandatory"] = mandatoryProperty;
        // Readonly
        let readonlyProperty = new PropertyItem(this, "readonly", Utilities_1.synUtil.Strings.getValue("clreadonlyproperty"), false, "Input", "checkbox", undefined);
        readonlyProperty.init(commonPropertiesColumn);
        this.propertyMap["readonly"] = readonlyProperty;
        // Visible
        let visibleProperty = new PropertyItem(this, "visible", Utilities_1.synUtil.Strings.getValue("clvisibleproperty"), false, "Input", "checkbox", undefined);
        visibleProperty.init(commonPropertiesColumn);
        this.propertyMap["visible"] = visibleProperty;
        // Condition
        let conditionProperty = new PropertyItem(this, "condition", Utilities_1.synUtil.Strings.getValue("clconditionproperty"), false, "Input", "text", undefined);
        conditionProperty.init(commonPropertiesColumn);
        this.propertyMap["condition"] = conditionProperty;
        // add Collection property
        let collectionProperty = new PropertyCollectionItem(this, "collection", Utilities_1.synUtil.Strings.getValue("clcollecionproperty"), true);
        collectionProperty.init(commonPropertiesColumn);
        this.propertyMap["collection"] = collectionProperty;
        // Colcount
        let colcountProperty = new PropertyItem(this, "colcount", Utilities_1.synUtil.Strings.getValue("clcolcountproperty"), false, "Input", "number", undefined, undefined, 0, 10);
        colcountProperty.init(commonPropertiesColumn);
        this.propertyMap["colcount"] = colcountProperty;
        // Rowcount
        let rowcountProperty = new PropertyItem(this, "rowcount", Utilities_1.synUtil.Strings.getValue("clrowcountproperty"), false, "Input", "number", undefined, undefined, 1, 10);
        rowcountProperty.init(commonPropertiesColumn);
        this.propertyMap["rowcount"] = rowcountProperty;
        // MaxWidth
        let maxWidthProperty = new PropertyItem(this, "maxwidth", Utilities_1.synUtil.Strings.getValue("clmaxwidthproperty"), false, "Input", "number", undefined, undefined, 0, 100);
        maxWidthProperty.init(commonPropertiesColumn);
        this.propertyMap["maxwidth"] = maxWidthProperty;
        // LinkedField
        let linkedfieldProperty = new PropertyLinkedFieldItem(this, "linkedfield", Utilities_1.synUtil.Strings.getValue("cllinkedfieldproperty"), false);
        linkedfieldProperty.init(commonPropertiesColumn);
        this.propertyMap["linkedfield"] = linkedfieldProperty;
        // Attachments
        let attachmentProperty = new PropertyAttachmentItem(this, "attachment", Utilities_1.synUtil.Strings.getValue("clattachmentproperty"), false);
        attachmentProperty.init(commonPropertiesColumn);
        this.propertyMap["attachment"] = attachmentProperty;
        // Value
        let valueProperty = new PropertyValueItem(this, "value", Utilities_1.synUtil.Strings.getValue("clvalueproperty"));
        valueProperty.init(commonPropertiesColumn);
        this.propertyMap["value"] = valueProperty;
        // RemoveValueButton
        let removeValueProperty = new PropertyItem(this, "removevalue", Utilities_1.synUtil.Strings.getValue("clvalueproperty"), false, "Button", undefined, undefined, this.removeValue, undefined, undefined, Utilities_1.synUtil.Strings.getValue("clremovevalueproperty"));
        removeValueProperty.init(commonPropertiesColumn);
        this.propertyMap["removevalue"] = removeValueProperty;
        // Variable
        let variableProperty = new PropertyVariableItem(this, "variable", Utilities_1.synUtil.Strings.getValue("clvariableproperty"), false);
        variableProperty.init(commonPropertiesColumn);
        this.propertyMap["variable"] = variableProperty;
        // Barcode
        let barcodeProperty = new PropertyBarcodeItem(this, "barcode", Utilities_1.synUtil.Strings.getValue("clbarcodeproperty"), false);
        barcodeProperty.init(mobilePropertiesColumn);
        this.propertyMap["barcode"] = barcodeProperty;
        // Telephone
        let telephoneProperty = new ProopertyTelephoneItem(this, "telephone", Utilities_1.synUtil.Strings.getValue("cltelephoneproperty"), false);
        telephoneProperty.init(commonPropertiesColumn);
        this.propertyMap["telephone"] = telephoneProperty;
        // LayoutItem
        // Color
        let colorProperty = new PropertyItem(this, "color", Utilities_1.synUtil.Strings.getValue("clcolorproperty"), false, "Input", "color", undefined);
        colorProperty.init(commonPropertiesColumn);
        this.propertyMap["color"] = colorProperty;
        // Height
        colorProperty = new PropertyItem(this, "height", Utilities_1.synUtil.Strings.getValue("clheightproperty"), false, "Input", "number", undefined, undefined, 0);
        colorProperty.init(commonPropertiesColumn);
        this.propertyMap["height"] = colorProperty;
        // Group
        // BorderColor
        let bordercolorProperty = new PropertyItem(this, "bordercolor", Utilities_1.synUtil.Strings.getValue("clbordercolorproperty"), false, "Input", "color", undefined);
        bordercolorProperty.init(commonPropertiesColumn);
        this.propertyMap["bordercolor"] = bordercolorProperty;
        // BackgroundColor
        let backgroundcolorProperty = new PropertyItem(this, "backgroundcolor", Utilities_1.synUtil.Strings.getValue("clbackgroundcolorproperty"), false, "Input", "color", undefined);
        backgroundcolorProperty.init(commonPropertiesColumn);
        this.propertyMap["backgroundcolor"] = backgroundcolorProperty;
    }
    getChecklist(checkItems = true) {
        let that = this;
        if (!checkItems || that.checkItems()) {
            return that.clControlFactory.instance;
        }
        else
            return undefined;
    }
    removeControlFromItems(layout) {
        $.each(layout, (idx, item) => {
            delete item.control;
            if (item.type === "group") {
                this.removeControlFromItems(item["layout"]);
            }
        });
    }
    anyFieldReferencesCollection(collectionId) {
        return this.anyFieldReferencesCollectionInternal(collectionId, this.clControlFactory.instance.layout);
    }
    anyFieldReferencesCollectionInternal(collectionId, layout) {
        let fields = [];
        let that = this;
        for (let index = 0; index < layout.length; ++index) {
            let item = layout[index];
            if (item.type === "field") {
                if (item["dataname"] === collectionId)
                    fields.push(item);
            }
            else if (item.type === "group") {
                fields.push(this.anyFieldReferencesCollectionInternal(collectionId, item.layout));
            }
        }
        return fields;
    }
    highlightLinkedFields(item) {
        if (item["linkedfield"]) {
            let linkedFields = this.clControlFactory.GetLinkedFields(item["linkedfield"]);
            $.each(linkedFields, (idx, field) => {
                field.linkedIcon.addClass("highlightConditionIcon");
            });
        }
    }
    highlightDependentFields(item) {
        let dependentFields = this.clControlFactory.GetDependentFields(item.id);
        if (dependentFields != undefined && dependentFields.length > 0) {
            item.dependentIcon.addClass("highlightConditionIcon");
            $.each(dependentFields, (idx, field) => {
                field.dependentIcon.addClass("highlightConditionIcon");
            });
        }
    }
    highlightItemsForCondition(item) {
        let that = this;
        if (item["id"]) {
            if (item["condition"]) {
                item.conditionIcon.addClass("highlightConditionIcon");
            }
            else {
                item.conditionIcon.removeClass("highlightConditionIcon");
            }
        }
        let control = that.clControlFactory.getFieldControl(item["id"]);
        if (control.ConditionChildFields.length > 0 || control.ConditionParentFields.length > 0)
            item.conditionIcon.addClass("highlightConditionIcon");
        $.each(control.ConditionParentFields, (idx, parentControl) => {
            parentControl.field.conditionIcon.addClass("highlightConditionIcon");
        });
        $.each(control.ConditionChildFields, (idx, childControl) => {
            childControl.field.conditionIcon.addClass("highlightConditionIcon");
        });
    }
    updateLocalCollectionColumnsForLinkedField(dataName, dataField, callback) {
        let that = this;
        let localCollection = that.clControlFactory.getCollectionFromInstance(dataName);
        let selectedType = localCollection && localCollection.isft;
        let embbeded = localCollection && localCollection.embedded && localCollection.data && localCollection.data.length > 0;
        if (localCollection.columns.indexOf(dataField) === -1 && selectedType === "1" && !embbeded) {
            Utilities_1.synUtil.getAJAXData({
                url: Utilities_1.synUtil.getWSUrl("ChecklistGetForeignTableColumns") + dataName,
                done(ftColumns) {
                    if (ftColumns.indexOf(dataField) !== -1)
                        localCollection.columns.push(dataField);
                    if (callback)
                        callback();
                }
            });
        }
        else {
            if (callback)
                callback();
        }
    }
    updateLocalCollectionColumns(dataName, dataField, callback) {
        let that = this;
        let localCollection = that.clControlFactory.getCollectionFromInstance(dataName);
        if (localCollection.columns.indexOf(dataField) === -1)
            localCollection.columns.push(dataField);
        if (callback)
            callback();
    }
}
exports.ClDesigner = ClDesigner;
class PropertyBaseItem {
    constructor(designer, propertyId, propertyName, controlType, mandatory) {
        this.propertyId = propertyId;
        this.name = propertyName;
        this.controlId = "cl_designer_property_" + propertyId;
        this.designer = designer;
        this.controlType = controlType;
        this.mandatory = mandatory;
    }
    init(jQueryElem) {
        this.container = $("<div " + " id='" + this.controlId + "_container' class='clpropertyitem' />").appendTo(jQueryElem);
        let labeloutercontainer = $("<div id='" + this.controlId + "_labeloutercontainer' class='clpropertylabeloutercontainer'>").appendTo(this.container);
        let labelinnercontainer = $("<div id='" + this.controlId + "_labelinnercontainer' class='clpropertylabelinnercontainer'>").appendTo(labeloutercontainer);
        $("<label style='width:100%;word-break: break-all;'>" + this.name + "</label>").appendTo(labelinnercontainer);
        let controlouter = $("<div id='" + this.controlId + "_controloutercontainer' class='clpropertycontroloutercontainer'>").appendTo(this.container);
        this.controlcontainer = $("<div id='" + this.controlId + "_controlinnercontainer' class='clpropertycontrolinnercontainer'>").appendTo(controlouter);
    }
    setVisibility(visible) {
        if (visible)
            $("#" + this.controlId + "_container").show();
        else
            $("#" + this.controlId + "_container").hide();
    }
    setItem(item, selectedItems, diffValue, diffProperties) {
        let that = this;
        that.diffValue = diffValue;
        that.item = item;
        that.selectedItems = selectedItems;
        that.diffProperties = diffProperties;
        that.linkedFieldSelected = false;
        that.parentLinkedFieldSelected = false;
        that.dependentFieldSelected = false;
        $.each(selectedItems, (idx, field) => {
            if (field["linkedfield"]) {
                that.linkedFieldSelected = true;
                if (field["linkedfield"] === field["id"])
                    that.parentLinkedFieldSelected = true;
            }
            if (field["dependentfield"]) {
                that.dependentFieldSelected = true;
            }
        });
    }
    highlightMandatory() {
        if (this.mandatory) {
            $("#" + this.controlId + "_container").addClass("clMandatoryProperty");
        }
        else {
            $("#" + this.controlId + "_container").removeClass("clMandatoryProperty");
        }
    }
    updatePropertyColor() {
        if (this.diffValue)
            $("#" + this.controlId + "_container").addClass("clDiffValue");
        else
            $("#" + this.controlId + "_container").removeClass("clDiffValue");
    }
    setDiffValue() {
        let res = this.designer.getItemsProperty(this.selectedItems, this.propertyId, this.item);
        this.diffValue = res.diffValue;
    }
    notifyChange() {
        this.setDiffValue();
        this.highlightMandatory();
        this.updatePropertyColor();
        this.designer.clControlFactory.setChecklistChanged(true);
        this.designer.updateItemsInfo(this.selectedItems);
    }
}
class PropertyValueItem extends PropertyBaseItem {
    constructor(designer, propertyId, propertyName) {
        super(designer, propertyId, propertyName, undefined, false);
    }
    init(jQueryElem) {
        super.init(jQueryElem);
        let that = this;
        that.decimalsLabel = $("<label style='width:100%'>" + Utilities_1.synUtil.Strings.getValue("cldecimalslabelproperty") + " </label>").appendTo(that.controlcontainer);
        that.decimalsInput = $("<input id='" + that.propertyId + "_decimalvalueproperty' type='number' style='width:100%'/>").appendTo(that.controlcontainer);
        that.decimalsInput.prop("disabled", true);
        that.decimalsInput.kendoNumericTextBox({
            min: 0,
            max: 20,
            decimals: 0,
            format: "n0",
            culture: that.designer.clControlFactory.userCulture,
            downArrowText: "",
            upArrowText: "",
            change: (e) => {
                e.sender.element.parent().children("input.k-input").removeAttr("title");
                e.sender.element.parent().children("input.k-input").removeAttr("placeholder");
                let decVal = that.decimalsInput.data("kendoNumericTextBox").value();
                that.updateDecimalValue(decVal);
            }
        });
        that.decimalsInput.parent().children("input.k-input").removeAttr("title");
        that.decimalsInput.data("kendoNumericTextBox").bind("spin", function (e) {
            let decVal = that.decimalsInput.data("kendoNumericTextBox").value();
            that.updateDecimalValue(decVal);
        });
        that.minLabel = $("<label style='width:100%' >" + Utilities_1.synUtil.Strings.getValue("clminlabelproperty") + " </label>").appendTo(that.controlcontainer);
        that.minInput = $("<input style='width:100%' type='number' maxlength='10000' />").appendTo(that.controlcontainer);
        that.minInput.kendoNumericTextBox({
            culture: that.designer.clControlFactory.userCulture,
            downArrowText: "",
            upArrowText: "",
            change: (e) => {
                e.preventDefault();
                e.sender.element.parent().children("input.k-input").removeAttr("title");
                e.sender.element.parent().children("input.k-input").removeAttr("placeholder");
                let minVal = that.minInput.data("kendoNumericTextBox").value();
                that.updateMinValue(minVal);
            }
        });
        that.minInput.parent().children("input.k-input").removeAttr("title");
        that.minInput.data("kendoNumericTextBox").bind("spin", function (e) {
            let minVal = that.minInput.data("kendoNumericTextBox").value();
            that.updateMinValue(minVal);
        });
        that.maxLabel = $("<label style='width:100%'>" + Utilities_1.synUtil.Strings.getValue("clmaxlabelproperty") + " </label>").appendTo(that.controlcontainer);
        that.maxInput = $("<input style='width:100%' type='number' maxlength='10000' />").appendTo(that.controlcontainer);
        that.maxInput.kendoNumericTextBox({
            culture: that.designer.clControlFactory.userCulture,
            downArrowText: "",
            upArrowText: "",
            change: (e) => {
                e.sender.element.parent().children("input.k-input").removeAttr("title");
                e.sender.element.parent().children("input.k-input").removeAttr("placeholder");
                let maxVal = that.maxInput.data("kendoNumericTextBox").value();
                that.updateMaxValue(maxVal);
            }
        });
        that.maxInput.parent().children("input.k-input").removeAttr("title");
        that.maxInput.data("kendoNumericTextBox").bind("spin", function (e) {
            let maxVal = that.maxInput.data("kendoNumericTextBox").value();
            that.updateMaxValue(maxVal);
        });
        that.maxlengthLabel = $("<label style='width:100%'>" + Utilities_1.synUtil.Strings.getValue("clmaxlengthlabelproperty") + " </label>").appendTo(that.controlcontainer);
        that.maxlengthInput = $("<input style='width:100%' type='number' maxlength='4' />").appendTo(that.controlcontainer);
        that.maxlengthInput.kendoNumericTextBox({
            min: 1,
            max: 4000,
            decimals: 0,
            format: "n0",
            culture: that.designer.clControlFactory.userCulture,
            downArrowText: "",
            upArrowText: "",
            change: (e) => {
                e.sender.element.parent().children("input.k-input").removeAttr("title");
                e.sender.element.parent().children("input.k-input").removeAttr("placeholder");
                let maxlenVal = that.maxlengthInput.data("kendoNumericTextBox").value();
                that.updateMaxLengthValue(maxlenVal);
            }
        });
        that.maxlengthInput.parent().children("input.k-input").removeAttr("title");
        that.maxlengthInput.data("kendoNumericTextBox").bind("spin", function (e) {
            let maxlenVal = that.maxlengthInput.data("kendoNumericTextBox").value();
            that.updateMaxLengthValue(maxlenVal);
        });
        this.setVisibility(false);
    }
    updateMaxLengthValue(value) {
        if (value) {
            this.item["maxlength"] = value;
            $.each(this.selectedItems, (idx, item) => {
                item["maxlength"] = value;
                let control = this.designer.clControlFactory.getFieldControl(item["id"]);
                if (control instanceof ChecklistControls_1.ClTextArea || control instanceof ChecklistControls_1.ClTextInput) {
                    control.updateValueProperties();
                    this.designer.clControlFactory.updateControl(item.id, control);
                }
            });
            this.notifyChange();
        }
    }
    updateMaxValue(value) {
        this.item["max"] = value;
        this.minInput.data("kendoNumericTextBox").options.max = value;
        $.each(this.selectedItems, (idx, item) => {
            item["max"] = value;
            let control = this.designer.clControlFactory.getFieldControl(item["id"]);
            if (control instanceof ChecklistControls_1.ClNumericInput) {
                control.updateValueProperties();
                this.designer.clControlFactory.updateControl(item.id, control);
            }
        });
        this.notifyChange();
    }
    updateMinValue(value) {
        this.item["min"] = value;
        this.maxInput.data("kendoNumericTextBox").options.min = value;
        $.each(this.selectedItems, (idx, item) => {
            item["min"] = value;
            let control = this.designer.clControlFactory.getFieldControl(item["id"]);
            if (control instanceof ChecklistControls_1.ClNumericInput) {
                control.updateValueProperties();
                this.designer.clControlFactory.updateControl(item.id, control);
            }
        });
        this.notifyChange();
    }
    updateDecimalValue(value) {
        this.item["steps"] = this.decimalsInput.data("kendoNumericTextBox").value();
        $.each(this.selectedItems, (idx, item) => {
            item["steps"] = this.decimalsInput.data("kendoNumericTextBox").value();
            let control = this.designer.clControlFactory.getFieldControl(item["id"]);
            if (control instanceof ChecklistControls_1.ClNumericInput) {
                control.updateValueProperties();
                this.designer.clControlFactory.updateControl(item.id, control);
            }
        });
        this.notifyChange();
    }
    setItem(item, selectedItems, diffValue, diffProperties) {
        let that = this;
        super.setItem(item, selectedItems, diffValue, diffProperties);
        let target = this.decimalsInput.data("kendoNumericTextBox").wrapper.find(".k-input");
        if (item["datatype"] === "Integer") {
            if (this.item["steps"] !== 0)
                this.item["steps"] = 0;
            this.decimalsInput.data("kendoNumericTextBox").enable(false);
            this.decimalsInput.addClass("clReadOnly");
            target.addClass("clReadOnly");
            this.minInput.data("kendoNumericTextBox").options.decimals = 0;
            this.maxInput.data("kendoNumericTextBox").options.decimals = 0;
            this.minInput.data("kendoNumericTextBox").options.format = "n0";
            this.maxInput.data("kendoNumericTextBox").options.format = "n0";
        }
        else if (item["datatype"] === "Float") {
            this.minInput.data("kendoNumericTextBox").options.decimals = this.item["steps"];
            this.maxInput.data("kendoNumericTextBox").options.decimals = this.item["steps"];
            this.minInput.data("kendoNumericTextBox").options.format = "n" + this.item["steps"].toString();
            this.maxInput.data("kendoNumericTextBox").options.format = "n" + this.item["steps"].toString();
            this.decimalsInput.data("kendoNumericTextBox").enable(true);
            this.decimalsInput.removeClass("clReadOnly");
            target.removeClass("clReadOnly");
        }
        if (this.item["steps"] == undefined || this.item["steps"] == undefined)
            this.decimalsInput.data("kendoNumericTextBox").value("");
        else
            this.decimalsInput.data("kendoNumericTextBox").value(this.item["steps"]);
        if (this.item["min"] == undefined || this.item["min"] == undefined)
            this.minInput.data("kendoNumericTextBox").value("");
        else
            this.minInput.data("kendoNumericTextBox").value(this.item["min"]);
        if (this.item["max"] == undefined || this.item["max"] == undefined)
            this.maxInput.data("kendoNumericTextBox").value("");
        else
            this.maxInput.data("kendoNumericTextBox").value(this.item["max"]);
        if (this.item["maxlength"] == undefined || this.item["maxlength"] == undefined)
            this.maxlengthInput.data("kendoNumericTextBox").value("");
        else
            this.maxlengthInput.data("kendoNumericTextBox").value(this.item["maxlength"]);
        this.minInput.parent().children("input.k-input").removeAttr("title");
        this.maxInput.parent().children("input.k-input").removeAttr("title");
        this.decimalsInput.parent().children("input.k-input").removeAttr("title");
        this.maxlengthInput.parent().children("input.k-input").removeAttr("title");
        if (item["datatype"] === "String") {
            this.minLabel.hide();
            this.minInput.data("kendoNumericTextBox").wrapper.hide();
            this.maxLabel.hide();
            this.maxInput.data("kendoNumericTextBox").wrapper.hide();
            this.decimalsLabel.hide();
            this.decimalsInput.data("kendoNumericTextBox").wrapper.hide();
            this.maxlengthLabel.show();
            this.maxlengthInput.data("kendoNumericTextBox").wrapper.show();
        }
        else {
            this.minLabel.show();
            this.minInput.data("kendoNumericTextBox").wrapper.show();
            this.maxLabel.show();
            this.maxInput.data("kendoNumericTextBox").wrapper.show();
            this.decimalsLabel.show();
            this.decimalsInput.data("kendoNumericTextBox").wrapper.show();
            this.maxlengthLabel.hide();
            this.maxlengthInput.data("kendoNumericTextBox").wrapper.hide();
        }
        that.maxInput.parent().children("input.k-input").removeAttr("placeholder", Utilities_1.synUtil.Strings.getValue("cldiffpropertylabel"));
        that.minInput.parent().children("input.k-input").removeAttr("placeholder", Utilities_1.synUtil.Strings.getValue("cldiffpropertylabel"));
        that.decimalsInput.parent().children("input.k-input").removeAttr("placeholder", Utilities_1.synUtil.Strings.getValue("cldiffpropertylabel"));
        that.maxlengthInput.parent().children("input.k-input").removeAttr("placeholder", Utilities_1.synUtil.Strings.getValue("cldiffpropertylabel"));
        if (diffProperties) {
            $.each(diffProperties, (idx, property) => {
                switch (property) {
                    case "max":
                        that.maxInput.parent().children("input.k-input").attr("placeholder", Utilities_1.synUtil.Strings.getValue("cldiffpropertylabel"));
                        break;
                    case "min":
                        that.minInput.parent().children("input.k-input").attr("placeholder", Utilities_1.synUtil.Strings.getValue("cldiffpropertylabel"));
                        break;
                    case "steps":
                        that.decimalsInput.parent().children("input.k-input").attr("placeholder", Utilities_1.synUtil.Strings.getValue("cldiffpropertylabel"));
                        break;
                    case "maxlength":
                        that.maxlengthInput.parent().children("input.k-input").attr("placeholder", Utilities_1.synUtil.Strings.getValue("cldiffpropertylabel"));
                        break;
                }
            });
        }
        this.highlightMandatory();
        this.updatePropertyColor();
    }
}
class PropertyAttachmentItem extends PropertyBaseItem {
    constructor(designer, propertyId, propertyName, mandatory) {
        super(designer, propertyId, propertyName, undefined, mandatory);
        this.attachments = [];
    }
    init(jQueryElem) {
        super.init(jQueryElem);
        let that = this;
        that.staticContainer = $("<div style='width:100%;' id='" + this.controlId + "_staticcontainer' class='buttonPane' />").appendTo(that.controlcontainer);
        that.embeddedContainer = $("<div style='width:100%;' id='" + this.controlId + "_embeddedcontainer' class='clattachmentpropcontainer'  />").appendTo(that.controlcontainer);
        that.addLocalAttachmentButton = $("<button type='button' class='btn btn-primary'>" + Utilities_1.synUtil.Strings.getValue("clattachmentlocallabelproperty") + "</button>").appendTo(that.staticContainer);
        that.addSynerisIdAttachmentButton = $("<button type='button' class='btn btn-primary'>" + Utilities_1.synUtil.Strings.getValue("clattachmentidlabelproperty") + "</button>").appendTo(that.staticContainer);
        if (!that.designer.calledFromFatCient) {
            that.addPasteAttachmentButton = $("<button type='button' class='btn btn-primary'>" + Utilities_1.synUtil.Strings.getValue("clattachmentpastelabelproperty") + "</button>").appendTo(that.staticContainer);
            that.addPasteAttachmentButton.on("click", function () {
                let clipboard = $("#Clipboard");
                if (clipboard) {
                    let itemCount = clipboard.synClipboard("itemCount");
                    if (itemCount === 1) {
                        let items = clipboard.synClipboard("pasteForChecklist");
                        $.each(items, (idx, id) => {
                            that.cacheAttachmentAndAddToControl(id);
                        });
                    }
                    else if (itemCount === 0)
                        Utilities_1.synUtil.Notifications.warning(Utilities_1.synUtil.Strings.getValue("clipboardemtpy"));
                    else
                        Utilities_1.synUtil.Notifications.warning("Es darf sich nur 1 Element in der Zwischenablage befinden");
                }
            });
        }
        let checkBoxLabel = $("<label style='width:100%' >" + Utilities_1.synUtil.Strings.getValue("clattachmentsourceproperty") + " </label>").appendTo(that.embeddedContainer);
        let checkBoxContainer = $("<div id='" + this.controlId + "_container' class='checkboxcontainer'/>").appendTo(that.embeddedContainer);
        // AttachmentsSource
        that.listValues = [{ id: 1, name: Utilities_1.synUtil.Strings.getValue("clattachmentsourceuploadlabelproperty") }, { id: 2, name: Utilities_1.synUtil.Strings.getValue("clattachmentsourcecameralabelproperty") }, { id: 4, name: Utilities_1.synUtil.Strings.getValue("clattachmentsourcecameraterminalmodelabelproperty") }, { id: 8, name: Utilities_1.synUtil.Strings.getValue("clattachmentsourcecameraterminalmodefacedetectionlabelproperty") }];
        for (let index = 0; index < that.listValues.length; ++index) {
            let guid = Utilities_1.synUtil.getGUID(true);
            let container = $("<div style='overflow-wrap: break-word;' />").appendTo(checkBoxContainer);
            let checkBox = $("<input id='" + this.controlId + "_" + guid + "' type='checkbox' name='" + this.controlId + "' value='" + that.listValues[index].id + "' class='clListItem' >").appendTo(container);
            let label = $("<label id='" + this.controlId + "_" + guid + "_label' style='overflow-wrap: break-word;display:inline-block;vertical-align:middle;'>" + that.listValues[index].name + "</label>").appendTo(container);
            label.css("width", "calc(100% - 2em )");
            checkBox.change(() => {
                let value = 0;
                $("input[name='" + this.controlId + "']").prop("indeterminate", false);
                let oldValue = that.item["attachmentsource"];
                $("input[name='" + this.controlId + "']:checked").each(function () {
                    value += parseInt($(this).val().toString());
                });
                that.item["attachmentsource"] = value;
                $.each(that.selectedItems, (idx, item) => {
                    item["attachmentsource"] = value;
                    that.designer.updateControl(item, that.propertyId, oldValue);
                });
                that.notifyChange();
            });
        }
        that.addLocalAttachmentButton.on("click", function () {
            let windowData = Utilities_1.synUtil.uploadWindow({
                multiUpload: false,
                action: Utilities_1.synUtil.Strings.getValue("climageuploadlabelproperty"),
                onAction(guids) {
                    $.each(guids, (idx, value) => {
                        Utilities_1.synUtil.getAJAXData({
                            url: Utilities_1.synUtil.getWSUrl("ChecklistCheckAttachment"),
                            method: "POST",
                            requestData: { filecacheGuid: value, jpegquality: that.designer.checklist["jpegquality"], isstaticimage: true, imageonly: true },
                            done(fileInfo) {
                                let imageGuid = Utilities_1.synUtil.getGUID(true);
                                let attachementInfo = new ChecklistControls_1.AttachmentInfo(fileInfo);
                                that.designer.clControlFactory.addImageToField(that.item["id"], imageGuid, fileInfo, true);
                                let control = that.designer.clControlFactory.getFieldControl(that.item["id"]);
                                if (control instanceof ChecklistControls_1.ClImageViewControl) {
                                    control.addAttachment(imageGuid, attachementInfo);
                                    that.designer.clControlFactory.updateControl(that.item.id, control);
                                }
                                $("#" + windowData.windowID).data("kendoWindow").close();
                                that.checkButtonVisibilty();
                            },
                            fail(jqXHR, textStatus, errorThrown, url) {
                                Utilities_1.synUtil.Notifications.error(jqXHR.responseJSON.ErrorDisplayMessage);
                            },
                            cleanUp() { Utilities_1.synUtil.endAjaxProgress("#" + windowData.buttonID); }
                        });
                    });
                },
            });
        });
        that.addSynerisIdAttachmentButton.on("click", function () {
            let windowData = Utilities_1.synUtil.popupWindow({
                title: Utilities_1.synUtil.Strings.getValue("clattachmentsynerisidtitleproperty"),
                actions: ["Maximize", "Close"],
                width: 400,
                height: 300,
                resizable: true,
                modal: true,
                synDesktopAware: true
            });
            let windowId = "popup_" + windowData.guid;
            let listNameControl = $("<input type='text' class='clInput k-textbox'' style='witdh: 100%;' maxlength='100'  autofocus/>").appendTo(windowData.contentDiv);
            let buttonPane = $("<div class='buttonPane' style='padding-top: 5px; padding-bottom: 5px; '>").appendTo(windowData.contentDiv);
            let okButton = $("<button id='listname_dlg_ok_button' type='button' class='btn btn-primary' readonly>" + Utilities_1.synUtil.Strings.getValue("menuok") + "</button>").appendTo(buttonPane);
            let cancelButton = $("<button id='listname_dlg_cancel_button' type='button' class='btn' >" + Utilities_1.synUtil.Strings.getValue("menucancel") + "</button>").appendTo(buttonPane);
            okButton.attr("disabled", "disabled");
            listNameControl.on("input", function (e) {
                if (e) {
                    let value = $(this).val();
                    if (value)
                        okButton.removeAttr("disabled");
                    else
                        okButton.attr("disabled", "disabled");
                }
            });
            okButton.on("click", function (e) {
                let id = listNameControl.val();
                let callback = function () {
                    $("#" + windowId).data("kendoWindow").close();
                };
                that.cacheAttachmentAndAddToControl(id, callback);
            });
            cancelButton.on("click", function (e) {
                $("#" + windowId).data("kendoWindow").close();
            });
        });
        that.minLabel = $("<label style='width:100%' >" + Utilities_1.synUtil.Strings.getValue("clminlabelproperty") + " </label>").appendTo(that.embeddedContainer);
        that.minInput = $("<input style='width:100%' type='number' maxlength='10000' />").appendTo(that.embeddedContainer);
        let max = 100;
        that.minInput.kendoNumericTextBox({
            min: 1,
            max,
            decimals: 0,
            format: "n0",
            culture: that.designer.clControlFactory.userCulture,
            downArrowText: "",
            upArrowText: "",
            change: (e) => {
                e.preventDefault();
                e.sender.element.parent().children("input.k-input").removeAttr("title");
                e.sender.element.parent().children("input.k-input").removeAttr("placeholder");
                let minVal = that.minInput.data("kendoNumericTextBox").value();
                that.updateMinValue(minVal);
            }
        });
        that.minInput.parent().children("input.k-input").removeAttr("title");
        that.minInput.data("kendoNumericTextBox").bind("spin", function (e) {
            e.sender.element.parent().children("input.k-input").removeAttr("title");
            e.sender.element.parent().children("input.k-input").removeAttr("placeholder");
            let minVal = that.minInput.data("kendoNumericTextBox").value();
            that.updateMinValue(minVal);
        });
        that.maxLabel = $("<label style='width:100%'>" + Utilities_1.synUtil.Strings.getValue("clmaxlabelproperty") + " </label>").appendTo(that.embeddedContainer);
        that.maxInput = $("<input style='width:100%' type='number' maxlength='10000' />").appendTo(that.embeddedContainer);
        that.maxInput.kendoNumericTextBox({
            min: 1,
            max,
            decimals: 0,
            format: "n0",
            culture: that.designer.clControlFactory.userCulture,
            downArrowText: "",
            upArrowText: "",
            change: (e) => {
                e.sender.element.parent().children("input.k-input").removeAttr("title");
                e.sender.element.parent().children("input.k-input").removeAttr("placeholder");
                let maxVal = that.maxInput.data("kendoNumericTextBox").value();
                that.updateMaxValue(maxVal);
            }
        });
        that.maxInput.parent().children("input.k-input").removeAttr("title");
        that.maxInput.data("kendoNumericTextBox").bind("spin", function (e) {
            e.sender.element.parent().children("input.k-input").removeAttr("title");
            e.sender.element.parent().children("input.k-input").removeAttr("placeholder");
            let maxVal = that.maxInput.data("kendoNumericTextBox").value();
            that.updateMaxValue(maxVal);
        });
        that.aspectRatioLabel = $("<label style='width:100%'>" + Utilities_1.synUtil.Strings.getValue("claspectratioproperty") + " </label>").appendTo(that.embeddedContainer);
        that.aspectRatioInput = $("<input style='width:100%' maxlength='10000' />").appendTo(that.embeddedContainer);
        that.aspectRatioInput.kendoMaskedTextBox({
            mask: "0:0",
            change: (e) => {
                e.sender.element.parent().children("input.k-input").removeAttr("title");
                e.sender.element.parent().children("input.k-input").removeAttr("placeholder");
                let value = e.sender.value();
                that.item["aspectratio"] = value;
                $.each(this.selectedItems, (idx, item) => {
                    item["aspectratio"] = value;
                });
                that.notifyChange();
            }
        });
        that.imageOnlyLabel = $("<label style='width:100%'>" + Utilities_1.synUtil.Strings.getValue("climageonlyproperty") + " </label>").appendTo(that.embeddedContainer);
        that.imageOnlyInput = $("<input type='checkbox' style='vertical-align:middle;width:1.5em;height:1.5em' />").appendTo(that.embeddedContainer);
        that.imageOnlyInput.on("change", function () {
            that.imageOnlyInput.prop("indeterminate", false);
            that.item["imageonly"] = that.imageOnlyInput.prop("checked");
            // update //check if possible
            $.each(that.selectedItems, (idx, item) => {
                item["imageonly"] = that.imageOnlyInput.prop("checked");
                let control = that.designer.clControlFactory.getFieldControl(item["id"]);
                if (control instanceof ChecklistControls_1.ClImageViewControl) {
                    that.designer.updateControl(item, "imageonly", undefined);
                    // control.updateControl();
                    // that.designer.clControlFactory.updateControl(item.id, control);
                }
            });
            that.notifyChange();
        });
        this.setVisibility(false);
    }
    cacheAttachmentAndAddToControl(id, callback) {
        let that = this;
        Utilities_1.synUtil.getAJAXData({
            method: "POST",
            url: Utilities_1.synUtil.getWSUrl("ChecklistCacheAttachment"),
            requestData: { id, jpegquality: that.designer.checklist["jpegquality"], isstaticimage: true, imageonly: true },
            done(fileInfo) {
                let imageGuid = Utilities_1.synUtil.getGUID(true);
                let attachemntInfo = new ChecklistControls_1.AttachmentInfo(fileInfo);
                that.designer.clControlFactory.addImageToField(that.item["id"], imageGuid, fileInfo, true);
                let control = that.designer.clControlFactory.getFieldControl(that.item["id"]);
                if (control instanceof ChecklistControls_1.ClImageViewControl) {
                    control.addAttachment(imageGuid, attachemntInfo);
                    that.designer.clControlFactory.updateControl(that.item.id, control);
                }
                that.checkButtonVisibilty();
                if (callback)
                    callback();
            },
            fail(jqXHR, textStatus, errorThrown, url) {
                Utilities_1.synUtil.getAJAXDataFail(jqXHR, textStatus, errorThrown, url);
            }
        });
    }
    setVisibility(visible) {
        if (visible)
            $("#" + this.controlId + "_container").show();
        else
            $("#" + this.controlId + "_container").hide();
    }
    setItem(item, selectedItems, diffValue, diffProperties) {
        let that = this;
        super.setItem(item, selectedItems, diffValue, diffProperties);
        this.checkButtonVisibilty();
        if (this.item["min"] == undefined || this.item["min"] == undefined)
            this.minInput.data("kendoNumericTextBox").value("");
        else
            this.minInput.data("kendoNumericTextBox").value(this.item["min"]);
        if (this.item["max"] == undefined || this.item["max"] == undefined)
            this.maxInput.data("kendoNumericTextBox").value("");
        else
            this.maxInput.data("kendoNumericTextBox").value(this.item["max"]);
        this.minInput.parent().children("input.k-input").removeAttr("title");
        this.maxInput.parent().children("input.k-input").removeAttr("title");
        if (this.item["aspectratio"] == undefined || this.item["aspectratio"] == undefined)
            this.aspectRatioInput.data("kendoMaskedTextBox").value("");
        else
            this.aspectRatioInput.data("kendoMaskedTextBox").value(this.item["aspectratio"]);
        if (this.item["imageonly"])
            this.imageOnlyInput.prop("checked", true);
        else
            this.imageOnlyInput.prop("checked", false);
        $("input[name=" + this.controlId + "]").prop("checked", false);
        if (this.item["attachmentsource"]) {
            for (let i = 0; i < this.listValues.length; i++) {
                let tmpId = this.listValues[i].id;
                if ((this.item["attachmentsource"] & tmpId) === tmpId)
                    $("input[name=" + this.controlId + "][value=" + tmpId.toString() + "]").prop("checked", "checked");
            }
        }
        if (item["datatype"] === "StaticImage") {
            this.staticContainer.show();
            this.embeddedContainer.hide();
        }
        else {
            this.staticContainer.hide();
            this.embeddedContainer.show();
            let target = this.minInput.data("kendoNumericTextBox").wrapper.find(".k-input");
            target.removeClass("clReadOnly");
            this.minInput.removeClass("clReadOnly");
            if (this.item["datatype"] === "EmbeddedImage") {
                this.minInput.data("kendoNumericTextBox").enable(this.item["mandatory"]);
                if (!this.item["mandatory"]) {
                    this.minInput.addClass("clReadOnly");
                    target.addClass("clReadOnly");
                }
            }
        }
        that.maxInput.parent().children("input.k-input").removeAttr("placeholder", Utilities_1.synUtil.Strings.getValue("cldiffpropertylabel"));
        that.minInput.parent().children("input.k-input").removeAttr("placeholder", Utilities_1.synUtil.Strings.getValue("cldiffpropertylabel"));
        that.aspectRatioInput.parent().children("input.k-input").removeAttr("placeholder", Utilities_1.synUtil.Strings.getValue("cldiffpropertylabel"));
        that.imageOnlyInput.prop("indeterminate", false);
        $("input[name=" + that.controlId + "]").prop("indeterminate", false);
        if (diffProperties) {
            $.each(diffProperties, (idx, property) => {
                switch (property) {
                    case "min":
                        that.minInput.parent().children("input.k-input").attr("placeholder", Utilities_1.synUtil.Strings.getValue("cldiffpropertylabel"));
                        break;
                    case "max":
                        that.maxInput.parent().children("input.k-input").attr("placeholder", Utilities_1.synUtil.Strings.getValue("cldiffpropertylabel"));
                        break;
                    case "aspectratio":
                        that.maxInput.parent().children("input.k-input").attr("placeholder", Utilities_1.synUtil.Strings.getValue("cldiffpropertylabel"));
                        break;
                    case "imageonly":
                        that.imageOnlyInput.prop("indeterminate", true);
                        break;
                    case "attachmentsource":
                        $("input[name=" + that.controlId + "]").prop("indeterminate", true);
                        break;
                }
            });
        }
        this.highlightMandatory();
        this.updatePropertyColor();
    }
    checkButtonVisibilty() {
        let control = this.designer.clControlFactory.getFieldControl(this.item["id"]);
        if (control instanceof ChecklistControls_1.ClImageViewControl) {
            let disabled = false;
            if (this.item["datatype"] === "StaticImage") {
                if (control.getImageCount() >= 1)
                    disabled = true;
            }
            else {
                if (control.getImageCount() >= this.item["max"])
                    disabled = true;
            }
            this.addLocalAttachmentButton.prop("disabled", disabled);
            this.addSynerisIdAttachmentButton.prop("disabled", disabled);
            if (this.addPasteAttachmentButton)
                this.addPasteAttachmentButton.prop("disabled", disabled);
        }
    }
    updateMaxValue(value) {
        this.item["max"] = value;
        this.minInput.data("kendoNumericTextBox").options.max = value;
        $.each(this.selectedItems, (idx, item) => {
            item["max"] = value;
            let control = this.designer.clControlFactory.getFieldControl(item["id"]);
            if (control instanceof ChecklistControls_1.ClImageViewControl) {
                control.updateControl();
                this.designer.clControlFactory.updateControl(item.id, control);
            }
        });
        this.notifyChange();
    }
    updateMinValue(value) {
        this.item["min"] = value;
        this.maxInput.data("kendoNumericTextBox").options.min = value;
        $.each(this.selectedItems, (idx, item) => {
            item["min"] = value;
            let control = this.designer.clControlFactory.getFieldControl(item["id"]);
            if (control instanceof ChecklistControls_1.ClImageViewControl) {
                control.updateControl();
                this.designer.clControlFactory.updateControl(item.id, control);
            }
        });
        this.notifyChange();
    }
}
class PropertyCollectionItem extends PropertyBaseItem {
    constructor(designer, propertyId, propertyName, mandatory) {
        super(designer, propertyId, propertyName, undefined, mandatory);
        this.changedListNames = [];
        this.isMultiLang = false;
        this.hasPidColumn = false;
    }
    init(jQueryElem) {
        super.init(jQueryElem);
        let control;
        this.setVisibility(false);
    }
    addNewList(callback) {
        let that = this;
        let windowData = Utilities_1.synUtil.popupWindow({
            title: Utilities_1.synUtil.Strings.getValue("clcollecionnewlisttitleproperty"),
            actions: ["Maximize", "Close"],
            width: 400,
            height: 300,
            resizable: true,
            modal: true,
            synDesktopAware: true
        });
        let windowId = "popup_" + windowData.guid;
        let listNameControl = $("<input type='text' class='clInput k-textbox' style='width: 100%;' maxlength='100' autofocus/>").appendTo(windowData.contentDiv);
        let buttonPane = $("<div class='buttonPane' style='padding-top: 5px; padding-bottom: 5px; '>").appendTo(windowData.contentDiv);
        let okButton = $("<button id='listname_dlg_ok_button' type='button' class='btn btn-primary' readonly>" + Utilities_1.synUtil.Strings.getValue("menuok") + "</button>").appendTo(buttonPane);
        let cancelButton = $("<button id='listname_dlg_cancel_button' type='button' class='btn' >" + Utilities_1.synUtil.Strings.getValue("menucancel") + "</button>").appendTo(buttonPane);
        okButton.attr("disabled", "disabled");
        let addList = function (listName) {
            let listNameAlreadyExist = false;
            $.each(that.designer.clControlFactory.instance.collections, (idx, value) => {
                if (value.id === listName)
                    listNameAlreadyExist = true;
            });
            if (!listNameAlreadyExist) {
                // add collection
                that.designer.clControlFactory.instance.collections.push({
                    id: listName,
                    columns: ["id", "name"],
                    embedded: true,
                    ismultilangft: false,
                    issorted: false,
                    data: [{ id: "0", name: "", clid: "0" }],
                });
                if (callback) {
                    // open Listedior
                    callback(listName);
                }
                else {
                    that.openListEditor(listName);
                }
                $("#" + windowId).data("kendoWindow").close();
            }
            else {
                Utilities_1.synUtil.Notifications.error("List" + listName + " already exist.");
            }
        };
        listNameControl.on("input", function (e) {
            let value = $(this).val().toString();
            if (value.match(/[^a-zA-Z0-9]/g)) {
                value = value.replace(/[^a-zA-Z0-9]/g, "");
                $(this).val(value);
            }
            if (value)
                okButton.removeAttr("disabled");
            else
                okButton.attr("disabled", "disabled");
        });
        listNameControl.on("keydown", function (e) {
            if (e.keyCode === 13) {
                let value = $(this).val().toString();
                if (value.match(/[^a-zA-Z0-9]/g)) {
                    value = value.replace(/[^a-zA-Z0-9]/g, "");
                    $(this).val(value);
                }
                if (value)
                    addList(value);
            }
        });
        okButton.on("click", function (e) {
            let listName = listNameControl.val().toString();
            addList(listName);
        });
        cancelButton.on("click", function (e) {
            $("#" + windowId).data("kendoWindow").close();
        });
    }
    setItem(item, selectedItems, diffValue, diffProperties) {
        let that = this;
        super.setItem(item, selectedItems, diffValue, diffProperties);
        this.createPropertyControls(item);
        let listName = item["dataname"];
        let colName = item["datafield"];
        if (listName) {
            let collection = that.designer.clControlFactory.instance.collections.find(coll => coll.id === listName);
            if (collection) {
                if (collection.isft)
                    that.typeSelection.data("kendoComboBox").value(1);
                else
                    that.typeSelection.data("kendoComboBox").value(0);
                that.enableComboBox(that.dataSelection, true);
                that.enableComboBox(that.columnSelection, true);
                that.embeddedSelection.prop("checked", collection.embedded);
                let idx = collection.columns.find(col => col === "langid");
                that.multilangSelection.prop("checked", collection.columns.find(col => col === "langid") != undefined);
                $("#" + that.controlId + "_editbutton").removeAttr("disabled");
                if (colName) {
                    that.hasPidColumn = collection.columns.indexOf("pid") !== -1;
                    that.setSelfRefOrDependentVisibility();
                    that.selfrefSelection.prop("checked", that.item["isselfrefft"]);
                    that.embeddedSelection.prop("checked", collection.embedded);
                    if (collection.isft) {
                        if (!collection.data || collection.data.length === 0)
                            that.embeddedSelection.removeAttr("disabled");
                        if (collection.embedded && (collection.data && collection.data.length > 0))
                            that.clearButtonSelectionContainer.show();
                    }
                    that.setDependentFieldDataSource();
                    if (that.item["dependentfield"])
                        that.dependentFieldSelection.data("kendoComboBox").value(that.item["dependentfield"]);
                }
                that.enableComboBox(that.sortColumnSelection, true);
                that.enableRadioButtons(true);
            }
        }
        that.typeSelection.parent().find("input.k-input").removeAttr("placeholder", Utilities_1.synUtil.Strings.getValue("cldiffpropertylabel"));
        that.dataSelection.parent().find("input.k-input").removeAttr("placeholder", Utilities_1.synUtil.Strings.getValue("cldiffpropertylabel"));
        that.columnSelection.parent().find("input.k-input").removeAttr("placeholder", Utilities_1.synUtil.Strings.getValue("cldiffpropertylabel"));
        that.sortColumnSelection.parent().find("input.k-input").removeAttr("placeholder", Utilities_1.synUtil.Strings.getValue("cldiffpropertylabel"));
        that.embeddedSelection.prop("indeterminate", false);
        that.selfrefSelection.prop("indeterminate", false);
        that.multilangSelection.prop("indeterminate", false);
        that.dependentFieldSelection.parent().find("input.k-input").removeAttr("placeholder", Utilities_1.synUtil.Strings.getValue("cldiffpropertylabel"));
        $("input[name=" + this.controlId + "_sortdirection]").prop("indeterminate", false);
        if (diffProperties) {
            $.each(diffProperties, (idx, property) => {
                switch (property) {
                    case "isft":
                        that.typeSelection.parent().find("input.k-input").attr("placeholder", Utilities_1.synUtil.Strings.getValue("cldiffpropertylabel"));
                        break;
                    case "dataname":
                        that.dataSelection.parent().find("input.k-input").attr("placeholder", Utilities_1.synUtil.Strings.getValue("cldiffpropertylabel"));
                        break;
                    case "datafield":
                        that.columnSelection.parent().find("input.k-input").attr("placeholder", Utilities_1.synUtil.Strings.getValue("cldiffpropertylabel"));
                        break;
                    case "isselfrefft":
                        that.selfrefSelection.prop("indeterminate", true);
                        break;
                    case "ismultilangft":
                        that.multilangSelection.prop("indeterminate", true);
                        break;
                    case "embedded":
                        that.embeddedSelection.prop("indeterminate", true);
                        break;
                    case "ftsort":
                        $("input[name=" + this.controlId + "_sortdirection]").prop("indeterminate", true);
                        that.sortColumnSelection.parent().find("input.k-input").attr("placeholder", Utilities_1.synUtil.Strings.getValue("cldiffpropertylabel"));
                        break;
                    case "dependentfield":
                        that.dependentFieldSelection.parent().find("input.k-input").attr("placeholder", Utilities_1.synUtil.Strings.getValue("cldiffpropertylabel"));
                        break;
                }
            });
        }
        // check if change is allowed
        if (that.linkedFieldSelected && !that.parentLinkedFieldSelected) {
            $("#" + that.controlId + "_newbutton").prop("disabled", true);
            $("#" + that.controlId + "_editbutton").prop("disabled", true);
            that.enableComboBox(that.typeSelection, false);
            that.enableComboBox(that.dataSelection, false);
            that.enableComboBox(that.dependentFieldSelection, false);
            that.selfrefSelection.attr("disabled", "disabled");
            that.multilangSelection.attr("disabled", "disabled");
            that.embeddedSelection.attr("disabled", "disabled");
        }
        this.highlightMandatory();
        this.updatePropertyColor();
    }
    createPropertyControls(item) {
        let that = this;
        that.controlcontainer.children().remove();
        let buttonContainer = $("<div class='buttonPane'  style='text-align: center; padding-bottom: 5px;'></div>").appendTo(that.controlcontainer);
        let newButton = $("<button id='" + this.controlId + "_newbutton' class='btn btn-primary' style='min-width:80px;'>" + Utilities_1.synUtil.Strings.getValue("clcollecionnewbuttonlabelproperty") + "</button>").appendTo(buttonContainer);
        let editButton = $("<button id='" + this.controlId + "_editbutton' class='btn btn-primary' style='min-width:80px;' disabled>" + Utilities_1.synUtil.Strings.getValue("clcollecioneditbuttonlabelproperty") + "</button>").appendTo(buttonContainer);
        that.typeSelection = $("<select id='" + this.controlId + "_typecmb' class='clInput' style='width:100%; box-sizing:border-box;' />").appendTo(that.controlcontainer);
        let dataSelectionContainer = $("<div style='width: 100%; padding-bottom:5px; padding-top:5px;'/>").appendTo(that.controlcontainer);
        that.dataSelection = $("<select id='" + this.controlId + "_datacmb' class='clInput' style='width:100%;box-sizing:border-box;' />").appendTo(dataSelectionContainer);
        let columnSelectionContainer = $("<div style='width: 100%; padding-bottom:5px;' />").appendTo(that.controlcontainer);
        that.columnSelection = $("<select id='" + this.controlId + "_colcmb' class='clInput' style='width:100%;'/>").appendTo(columnSelectionContainer);
        that.multilangSelectionContainer = $("<div id='" + this.controlId + "_multilangcontainer' />").appendTo(that.controlcontainer);
        let multilangLabelContainer = $("<div style='width:50%; display:inline-block;word-break: break-all;'/>").appendTo(that.multilangSelectionContainer);
        let multilangLabel = $("<label id='" + this.controlId + "_multilanglabel' style='vertical-align:middle'>" + Utilities_1.synUtil.Strings.getValue("clcollecionmultilanglabelproperty") + "</label>").appendTo(multilangLabelContainer);
        that.multilangSelection = $("<input id='" + this.controlId + "_multilangcb' type='checkbox' style='vertical-align:middle;width:1.5em;height:1.5em'>").appendTo(that.multilangSelectionContainer);
        that.multilangSelection.attr("disabled", "disabled");
        that.selfrefSelectionContainer = $("<div id='" + this.controlId + "_selfrefcontainer' />").appendTo(that.controlcontainer);
        let selfrefLabelContainer = $("<div style='width:50%; display:inline-block; word-break: break-all;'/>").appendTo(that.selfrefSelectionContainer);
        let selfrefLabel = $("<label id='" + this.controlId + "_selfreflabel' style='vertical-align:middle'>" + Utilities_1.synUtil.Strings.getValue("clcollecionselfreflabelproperty") + "</label>").appendTo(selfrefLabelContainer);
        that.selfrefSelection = $("<input id='" + this.controlId + "_selfrefcb'type='checkbox' style='vertical-align:middle;width:1.5em;height:1.5em'>").appendTo(that.selfrefSelectionContainer);
        that.selfrefSelection.attr("disabled", "disabled");
        that.embeddedSelectionContainer = $("<div id='" + this.controlId + "_embeddedcontainer' />").appendTo(that.controlcontainer);
        let embeddedLabelContainer = $("<div style='width:50%; display:inline-block;word-break: break-all;'/>").appendTo(that.embeddedSelectionContainer);
        let embeddedLabel = $("<label id='" + this.controlId + "_embeddedlabel' style='vertical-align:middle'> " + Utilities_1.synUtil.Strings.getValue("clcollecionembeddedlabelproperty") + " </label>").appendTo(embeddedLabelContainer);
        that.embeddedSelection = $("<input id='" + this.controlId + "_embeddedcb' type='checkbox' style='vertical-align:middle;width:1.5em;height:1.5em'/>").appendTo(that.embeddedSelectionContainer);
        that.embeddedSelection.attr("disabled", "disabled");
        that.clearButtonSelectionContainer = $("<div id='" + this.controlId + "_clearbuttoncontainer' class='buttonPane' style='width: 100%; box-sizing:border-box; text-align:center;'/>").appendTo(that.controlcontainer);
        that.clearButton = $("<button id='" + this.controlId + "_clearbutton' type='button' class='btn btn-primary' >" + Utilities_1.synUtil.Strings.getValue("clcollecionclearbuttonlabelproperty") + "</button>").appendTo(that.clearButtonSelectionContainer);
        that.clearButtonSelectionContainer.hide();
        that.sortColumnSelectionContainer = $("<div id='" + this.controlId + "_sortcolumncontainer' />").appendTo(that.controlcontainer);
        let sortColumnSelectionLabelContainer = $("<div style='width:50%; display:inline-block; word-break: break-all;'/>").appendTo(that.sortColumnSelectionContainer);
        let sortColumnSelectionLabel = $("<label id='" + this.controlId + "_sortcolumnlabel' style='vertical-align:middle'>" + Utilities_1.synUtil.Strings.getValue("clcollecionsortcolumnlabelproperty") + "</label>").appendTo(sortColumnSelectionLabelContainer);
        that.sortColumnSelection = $("<select id='" + this.controlId + "_sortcolumn' class='clInput' style='width:100%;'>").appendTo(that.sortColumnSelectionContainer);
        that.sortDirectionSelectionContainer = $("<div id='" + this.controlId + "_sortdirectioncontainer' />").appendTo(that.controlcontainer);
        let sortDirectionACSLabelContainer = $("<div style='width:50%; display:inline-block; word-break: break-all;'/>").appendTo(that.sortDirectionSelectionContainer);
        let sortDirectionACSLabel = $("<label id='" + this.controlId + "_sortdirectionlabel' style='vertical-align:middle'>" + Utilities_1.synUtil.Strings.getValue("clsortdirectionasclabelproperty") + "</label>").appendTo(sortDirectionACSLabelContainer);
        that.sortDirectionASCSelection = $("<input name='" + this.controlId + "_sortdirection' value='1'  type='radio' style='vertical-align:middle;width:1.5em;height:1.5em'>").appendTo(that.sortDirectionSelectionContainer);
        let sortDirectionDESCLabelContainer = $("<div style='width:50%; display:inline-block; word-break: break-all;'/>").appendTo(that.sortDirectionSelectionContainer);
        let sortDirectionLabel = $("<label id='" + this.controlId + "_sortdirectionlabel' style='vertical-align:middle'>" + Utilities_1.synUtil.Strings.getValue("clsortdirectiondesclabelproperty") + "</label>").appendTo(sortDirectionDESCLabelContainer);
        that.sortDirectionDESCSelection = $("<input name='" + this.controlId + "_sortdirection' value='-1' type='radio' style='vertical-align:middle;width:1.5em;height:1.5em'>").appendTo(that.sortDirectionSelectionContainer);
        that.dependentFieldSelectionContainer = $("<div id='" + this.controlId + "_sortdirectioncontainer' />").appendTo(that.controlcontainer);
        let dependentLabel = $("<label id='" + this.controlId + "_dependentlabel' style='vertical-align:middle'>" + Utilities_1.synUtil.Strings.getValue("cldependentfieldlabelproperty") + "</label>").appendTo(that.dependentFieldSelectionContainer);
        that.dependentFieldSelection = $("<input name='" + this.controlId + "_dependent' style='width:100%;' class='clInput' >").appendTo(that.dependentFieldSelectionContainer);
        // init values
        that.enableComboBox(that.dataSelection, false);
        that.enableComboBox(that.columnSelection, false);
        $("input[name=" + this.controlId + "_sortdirection]").prop("checked", false);
        let listName = item["dataname"];
        let colName = item["datafield"];
        let ftsort = item["ftsort"];
        if (listName) {
            let option = $("<option value='" + listName + "'  selected='selected'>" + listName + "</option>");
            that.dataSelection.append(option);
            if (colName)
                that.columnSelection.append($("<option value='" + colName + "'>" + colName + "</option>"));
            if (ftsort) {
                if (ftsort.indexOf(".") !== -1) {
                    let parts = ftsort.split(".");
                    that.sortColumnSelection.append($("<option value='" + parts[0] + "'>" + parts[0] + "</option>"));
                    $("input[name=" + this.controlId + "_sortdirection][value=" + parts[1] + "]").prop("checked", "checked");
                }
            }
        }
        newButton.on("click", function (e) {
            that.addNewList(undefined);
        });
        that.clearButton.on("click", function () {
            let listName = that.dataSelection.val();
            let cachedCollection1 = that.designer.clControlFactory.getCachedCollection(listName);
            let collection = that.designer.clControlFactory.getCollectionFromInstance(listName);
            collection.embedd = false;
            collection.data.splice(0, collection.data.length);
            let cachedCollection = that.designer.clControlFactory.getCachedCollection(listName);
            let idx = that.designer.clControlFactory.dataCollection.allControls.findIndex(collection => collection.id === listName);
            that.designer.clControlFactory.dataCollection.allControls.splice(idx, 1);
            that.updateFields(listName, collection);
            that.clearButtonSelectionContainer.hide();
            that.designer.updateProperties(that.selectedItems, true);
        });
        editButton.on("click", function (e) {
            if (that.typeSelection.data("kendoComboBox").value() === "1") {
                if (that.dataSelection.data("kendoComboBox").dataItem) {
                    that.openFtEditor(that.dataSelection.data("kendoComboBox").value());
                }
            }
            else {
                if (that.dataSelection.data("kendoComboBox").dataItem && that.dataSelection.data("kendoComboBox").value()) {
                    that.openListEditor(that.dataSelection.data("kendoComboBox").value());
                }
            }
        });
        that.typeSelection.kendoComboBox({
            dataTextField: "text",
            dataValueField: "value",
            noDataTemplate: kendo.htmlEncode(Utilities_1.synUtil.Strings.getValue("dynpnomatchingitemfound")),
            dataSource: [
                { text: Utilities_1.synUtil.Strings.getValue("clcollecioncolembeddedlabelproperty"), value: "0" },
                { text: Utilities_1.synUtil.Strings.getValue("clcollecioncolforeigntablelabelproperty"), value: "1" },
            ],
            change: (e, callback) => {
                that.typeSelection.parent().find("input.k-input").removeAttr("placeholder");
                let val = e.sender.value();
                if (val && e.sender.dataItem()) {
                    // Reset other properties
                    $("#" + that.controlId + "_editbutton").prop("disabled", true);
                    $("#" + that.controlId + "_newbutton").prop("disabled", true);
                    that.enableComboBox(that.dataSelection, true);
                    that.setDataNameDataSource();
                    that.dataSelection.data("kendoComboBox").value("");
                    that.enableComboBox(that.columnSelection, false);
                    that.columnSelection.data("kendoComboBox").setDataSource(new kendo.data.DataSource());
                    that.columnSelection.data("kendoComboBox").value("");
                    that.multilangSelection.prop("checked", false);
                    that.multilangSelection.attr("disabled", "disabled");
                    that.hasPidColumn = false;
                    that.selfrefSelection.prop("checked", false);
                    that.selrefSelectionChanged();
                    //that.dependentFieldSelection.data("kendoComboBox").value("");
                    that.setSelfRefOrDependentVisibility();
                    that.embeddedSelection.prop("checked", false);
                    that.embeddedSelection.attr("disabled", "disabled");
                    that.sortColumnSelection.data("kendoComboBox").setDataSource(new kendo.data.DataSource());
                    that.sortColumnSelection.data("kendoComboBox").value("");
                    if (val === "0") {
                        that.embeddedSelection.prop("checked", true);
                        $("#" + that.controlId + "_newbutton").prop("disabled", false);
                    }
                }
                else {
                    that.enableComboBox(that.dataSelection, false);
                    that.columnSelection.data("kendoComboBox").value("");
                }
                that.notifyChange();
            },
        });
        that.dataSelection.kendoComboBox({
            autoBind: false,
            filter: "contains",
            dataTextField: "id",
            dataValueField: "id",
            noDataTemplate: kendo.htmlEncode(Utilities_1.synUtil.Strings.getValue("dynpnomatchingitemfound")),
            change: (e) => {
                let val = e.sender.value();
                that.dataSelection.parent().find("input.k-input").removeAttr("placeholder");
                let checkSpecialColumns = function (columns) {
                    let langidColumns = $.grep(columns, (value) => {
                        return value === "langid";
                    });
                    let pidColumns = $.grep(columns, (value) => {
                        return value === "pid";
                    });
                    if (langidColumns.length > 0) {
                        that.isMultiLang = true;
                        that.multilangSelection.prop("checked", true);
                    }
                    else {
                        that.isMultiLang = false;
                        that.multilangSelection.prop("checked", false);
                    }
                    that.hasPidColumn = pidColumns.length > 0;
                    that.setSelfRefOrDependentVisibility();
                    that.notifyChange();
                };
                if (val && e.sender.dataItem()) {
                    that.selfrefSelection.prop("checked", false);
                    that.selrefSelectionChanged();
                    that.enableComboBox(that.columnSelection, true);
                    that.setColumnNameDataSource();
                    that.columnSelection.data("kendoComboBox").value("");
                    that.sortColumnSelection.data("kendoComboBox").setDataSource(new kendo.data.DataSource());
                    that.sortColumnSelection.data("kendoComboBox").value("");
                    if (that.typeSelection.data("kendoComboBox").value() !== "1")
                        $("#" + that.controlId + "_editbutton").prop("disabled", false);
                }
                else {
                    that.enableComboBox(that.columnSelection, false);
                    that.columnSelection.data("kendoComboBox").value("");
                }
                that.notifyChange();
            },
        });
        that.setDataNameDataSource();
        that.enableComboBox(that.dataSelection, false);
        that.columnSelection.kendoComboBox({
            autoBind: false,
            filter: "contains",
            dataTextField: "id",
            dataValueField: "id",
            noDataTemplate: kendo.htmlEncode(Utilities_1.synUtil.Strings.getValue("dynpnomatchingitemfound")),
            change: (e) => {
                let val = e.sender.value();
                let newColumn = e.sender.value();
                let dataName = this.dataSelection.data("kendoComboBox").value();
                that.columnSelection.parent().find("input.k-input").removeAttr("placeholder");
                that.embeddedSelection.prop("indeterminate", false);
                let oldDataName = that.item["dataname"];
                let oldDataField = that.item["datafield"];
                // set values
                that.enableComboBox(that.sortColumnSelection, true);
                that.enableRadioButtons(true);
                let callBack = function () {
                    that.sortColumnSelection.data("kendoComboBox").setDataSource(new kendo.data.DataSource());
                    let collectionChanged = false;
                    let columnChanged = false;
                    that.item["dataname"] = dataName;
                    that.item["datafield"] = val;
                    $.each(that.selectedItems, (idx, item) => {
                        item["dataname"] = dataName;
                        item["datafield"] = val;
                    });
                    if (oldDataName !== that.item["dataname"]) {
                        that.item["value"] = undefined;
                        collectionChanged = true;
                    }
                    if (oldDataField !== that.item["datafield"]) {
                        columnChanged = true;
                    }
                    if (collectionChanged) {
                        that.sortColumnSelection.data("kendoComboBox").value(newColumn);
                        $("input[name=" + that.controlId + "_sortdirection][value=1]").prop("checked", "checked");
                        let preventSortChanged = false;
                        if (!oldDataName || !oldDataField)
                            preventSortChanged = true;
                        that.setFtSort(preventSortChanged);
                    }
                    $.each(that.selectedItems, (idx, tmpItem) => {
                        if (oldDataName !== tmpItem["dataname"])
                            tmpItem["value"] = undefined;
                        if (collectionChanged || columnChanged) {
                            let updateItemCallback = function (item) {
                                let control = that.designer.clControlFactory.getFieldControl(item["id"]);
                                let innerCallback = function (datapresentedinfo) {
                                    let test;
                                    item["datapresentedinfo"] = {};
                                    if (datapresentedinfo)
                                        test = $.each(datapresentedinfo, (key, value) => {
                                            item["datapresentedinfo"][key] = value;
                                        });
                                    let newControl;
                                    switch (item["controltype"]) {
                                        case "Radiobutton":
                                            newControl = new ChecklistControls_1.ClMVCheckBoxRadio(item.id, item, that.designer.clControlFactory, 0, item["controltype"]);
                                            break;
                                        case "Checkbox":
                                            newControl = new ChecklistControls_1.ClMVCheckBoxRadio(item.id, item, that.designer.clControlFactory, 0, item["controltype"]);
                                            break;
                                        case "Combobox":
                                            if (item["isselfrefft"])
                                                newControl = new ChecklistControls_1.ClSRComboboxContainer(item.id, item, that.designer.clControlFactory, 0);
                                            else
                                                newControl = new ChecklistControls_1.ClCombobox(item.id, item, that.designer.clControlFactory, 0);
                                            break;
                                        case "MultipleChoice":
                                            newControl = new ChecklistControls_1.ClMultipleChoice(item.id, item, that.designer.clControlFactory, 0);
                                            break;
                                    }
                                    if (newControl != undefined) {
                                        newControl.setPageId = control.getPageId();
                                        let jQueryParent = control.controljQueryElem.closest('.previewControl');
                                        jQueryParent.children('.checklistrow').remove();
                                        newControl.init(jQueryParent);
                                        control = newControl;
                                    }
                                    that.designer.clControlFactory.updateControl(item.id, control);
                                    that.designer.clControlFactory.setRelationBetweenFields();
                                };
                                if (item["controltype"] === "Combobox") {
                                    if (!collectionChanged) {
                                        that.designer.clControlFactory.getComboboxInfo(item, item.value, innerCallback);
                                    }
                                    else
                                        innerCallback(undefined);
                                }
                                else {
                                    if (!collectionChanged) {
                                        control.resetData(undefined);
                                    }
                                    else
                                        innerCallback(undefined);
                                }
                            };
                            updateItemCallback(tmpItem);
                            if (collectionChanged) {
                                let localCollection;
                                $.each(that.designer.clControlFactory.instance.collections, (idx, value) => {
                                    if (value.id === dataName)
                                        localCollection = value;
                                });
                                let selectedType = that.typeSelection.data("kendoComboBox").value();
                                let embbeded = localCollection && localCollection.embedded && localCollection.data && localCollection.data.length > 0;
                                let linkedFields = that.designer.clControlFactory.GetNotSelectedLinkedFields(item["linkedfield"], that.selectedItems);
                                $.each(linkedFields, (idx, linkedField) => {
                                    if (oldDataName !== that.item["dataname"])
                                        that.item["value"] = undefined;
                                    linkedField["dataname"] = dataName;
                                    let linkedFieldCallback = function () {
                                        updateItemCallback(linkedField);
                                    };
                                    that.designer.updateLocalCollectionColumnsForLinkedField(dataName, linkedField["datafield"], linkedFieldCallback);
                                });
                            }
                        }
                        that.setSortColumnsDataSource();
                    });
                    that.setSelfRefOrDependentVisibility();
                    that.notifyChange();
                };
                if (val && e.sender.dataItem()) {
                    $("#" + that.controlId + "_editbutton").prop("disabled", false);
                    that.item["dataname"] = dataName;
                    that.item["datafield"] = val;
                    $.each(that.selectedItems, (idx, item) => {
                        item["dataname"] = dataName;
                        item["datafield"] = val;
                    });
                    that.setSelfRefOrDependentVisibility();
                    that.setDependentFieldDataSource();
                    // updateData
                    // get collection
                    if (that.typeSelection.data("kendoComboBox").value() === "1") {
                        // live ft
                        if (!that.linkedFieldSelected || that.parentLinkedFieldSelected)
                            that.embeddedSelection.removeAttr("disabled");
                        let listName = $("#" + that.controlId + "_datacmb").data("kendoComboBox").value();
                        let localCollection;
                        $.each(that.designer.clControlFactory.instance.collections, (idx, value) => {
                            if (value.id === listName)
                                localCollection = value;
                        });
                        if (!localCollection) {
                            localCollection = new ChecklistControls_1.ClCollection();
                            localCollection.id = $("#" + that.controlId + "_datacmb").data("kendoComboBox").value();
                            if (val !== "id")
                                localCollection.columns = ["id", val];
                            else
                                localCollection.columns = ["id"];
                            if (that.isMultiLang) {
                                if (localCollection.columns.findIndex(col => col === "langid") === -1)
                                    localCollection.columns.push("langid");
                            }
                            if (that.hasPidColumn) {
                                if (localCollection.columns.findIndex(col => col === "pid") === -1)
                                    localCollection.columns.push("pid");
                            }
                            localCollection["embedded"] = false;
                            localCollection["ismultilangft"] = that.isMultiLang;
                            localCollection["isft"] = true;
                            localCollection["issorted"] = localCollection.columns.findIndex(col => col === "sort") >= 0;
                            that.item["dataname"] = localCollection.id;
                            $.each(that.selectedItems, (idx, item) => {
                                item["dataname"] = localCollection.id;
                            });
                            that.designer.clControlFactory.instance.collections.push(localCollection);
                            that.embeddedSelection.prop("checked", localCollection["embedded"]);
                            callBack();
                        }
                        else {
                            // check if columns have changed
                            let columnsHaveChanged = false;
                            if (localCollection.columns.findIndex(name => name === newColumn) === -1) {
                                columnsHaveChanged = true;
                                localCollection.columns.push(newColumn);
                            }
                            if (oldDataField) {
                                let result = that.designer.clControlFactory.getUsedColumns(dataName);
                                if (result["columns"].indexOf(oldDataField) === -1) {
                                    let idx = localCollection.columns.indexOf(oldDataField);
                                    if (idx !== -1) {
                                        localCollection.columns.splice(idx, 1);
                                    }
                                }
                            }
                            that.embeddedSelection.prop("checked", localCollection["embedded"]);
                            callBack();
                        }
                    }
                    else
                        callBack();
                }
                that.notifyChange();
            },
        });
        that.setColumnNameDataSource();
        that.selfrefSelection.on("change", function () {
            that.selrefSelectionChanged();
            that.selfrefSelection.prop("indeterminate", false);
            if (that.item["controltype"] === "Combobox") {
                that.designer.updateProperties(that.selectedItems, true);
            }
        });
        that.embeddedSelection.change(function () {
            that.embeddedSelection.prop("indeterminate", false);
            let listName = that.dataSelection.data("kendoComboBox").value();
            let embedded = that.embeddedSelection.prop("checked");
            let collection = that.designer.clControlFactory.getCollectionFromInstance(listName);
            if (collection) {
                collection.embedded = embedded;
                if (!embedded && collection.data)
                    collection.data.splice(0, collection.data.length);
            }
            let cachedCollection = that.designer.clControlFactory.getCachedCollection(listName);
            if (cachedCollection) {
                cachedCollection.embedded = embedded;
            }
            that.setDataNameDataSource();
            that.notifyChange();
        });
        that.enableComboBox(that.columnSelection, false);
        that.sortColumnSelection.kendoComboBox({
            autoBind: false,
            filter: "contains",
            dataTextField: "id",
            dataValueField: "id",
            noDataTemplate: kendo.htmlEncode(Utilities_1.synUtil.Strings.getValue("dynpnomatchingitemfound")),
            change: (e) => {
                that.sortColumnSelection.parent().find("input.k-input").removeAttr("placeholder");
                that.setFtSort();
            }
        });
        that.setSortColumnsDataSource();
        that.enableComboBox(that.sortColumnSelection, false);
        that.enableRadioButtons(false);
        that.sortDirectionASCSelection.change(() => {
            that.sortDirectionChanged();
        });
        that.sortDirectionDESCSelection.change(() => {
            that.sortDirectionChanged();
        });
        that.dependentFieldSelection.kendoComboBox({
            dataTextField: "name",
            dataValueField: "id",
            filter: "contains",
            change(e) {
                let newValue = e.sender.value();
                if (e.sender.dataItem() || !newValue) {
                    let oldValue = that.item["dependentfield"];
                    let parentField;
                    e.sender.input.removeAttr("placeholder");
                    if (that.item["dependentfield"] !== newValue) {
                        if (e.sender.dataItem()) {
                            that.item["dependentfield"] = newValue;
                            that.dependentFieldSelected = true;
                            parentField = that.designer.clControlFactory.getFieldById(newValue, that.designer.clControlFactory.instance.layout);
                            if (newValue) {
                                that.item["isselfrefft"] = false;
                            }
                        }
                        else {
                            that.item["dependentfield"] = undefined;
                            that.dependentFieldSelected = false;
                        }
                        $.each(that.selectedItems, (idx, item) => {
                            item["dependentfield"] = newValue;
                            if (e.sender.dataItem()) {
                                item["isselfrefft"] = false;
                            }
                            that.designer.updateControl(item, "dependentfield", oldValue);
                        });
                        if (that.linkedFieldSelected) {
                            $.each(that.selectedItems, (idx, item) => {
                                if (item["linkedfield"]) {
                                    let linkedFields = that.designer.clControlFactory.GetLinkedFields(item["linkedfield"]);
                                    $.each(linkedFields, (idx, value) => {
                                        if (value["id"] !== item["id"]) {
                                            value["dependentfield"] = newValue;
                                            that.designer.updateControl(value, "dependentfield", oldValue);
                                        }
                                    });
                                }
                            });
                        }
                        that.notifyChange();
                        that.designer.updateProperties(that.selectedItems, true);
                    }
                }
            },
        });
        that.enableComboBox(that.dependentFieldSelection, false);
        this.setVisibility(false);
    }
    selrefSelectionChanged() {
        let that = this;
        that.selfrefSelection.prop("indeterminate", false);
        if (that.item["controltype"] === "Combobox") {
            let listName = that.dataSelection.data("kendoComboBox").value();
            that.item["isselfrefft"] = that.selfrefSelection.prop("checked");
            if (that.selfrefSelection.prop("checked"))
                that.item["dependentfield"] = undefined;
            let collection = that.designer.clControlFactory.getCollectionFromInstance(listName);
            $.each(that.selectedItems, (idx, tmpItem) => {
                let updateItemCallback = function (item) {
                    item["isselfrefft"] = that.selfrefSelection.prop("checked");
                    if (that.selfrefSelection.prop("checked"))
                        item["dependentfield"] = undefined;
                    let updateControlCallBack = function () {
                        item["value"] = undefined;
                        item["datapresentedinfo"] = {};
                        let control = that.designer.clControlFactory.getFieldControl(item["id"]);
                        if (item["isselfrefft"])
                            control = new ChecklistControls_1.ClSRComboboxContainer(item["id"], item, that.designer.clControlFactory, control.getPageId(), control.levelcount);
                        else
                            control = new ChecklistControls_1.ClCombobox(item["id"], item, that.designer.clControlFactory, control.getPageId(), control.levelcount);
                        let oldControl = $("#" + control.id + "_item");
                        let parent = oldControl.parent();
                        oldControl.remove();
                        control.init(parent);
                        that.designer.clControlFactory.updateControl(item.id, control);
                        that.designer.clControlFactory.setRelationBetweenFields();
                        that.notifyChange();
                    };
                    // if (collection && collection.columns.findIndex(colName => colName === "pid") === -1)
                    //     collection.columns.push("pid");
                    updateControlCallBack();
                };
                updateItemCallback(tmpItem);
                if (tmpItem["linkedfield"]) {
                    let linkedFields = that.designer.clControlFactory.GetNotSelectedLinkedFields(tmpItem["linkedfield"], that.selectedItems);
                    $.each(linkedFields, (idx, linkedField) => {
                        updateItemCallback(linkedField);
                    });
                }
            });
        }
    }
    setDataNameDataSource() {
        let that = this;
        this.dataSelection.data("kendoComboBox").setDataSource(new kendo.data.DataSource({
            serverFiltering: true,
            requestStart: function requestStart(e) {
            },
            requestEnd: function requestEnd(e) {
            },
            transport: {
                read: function read(options) {
                    let callback = function (data) {
                        options.success(data);
                    };
                    let selectedType = that.typeSelection.data("kendoComboBox").value();
                    if (selectedType === "1") {
                        let withPidColumn = that.dependentFieldSelected ? "y" : "n";
                        Utilities_1.synUtil.getAJAXData({
                            url: Utilities_1.synUtil.getWSUrl("ChecklistGetAllForeignTableNames") + "?withpidcolumn=" + withPidColumn,
                            done(ftNames) {
                                let data = [];
                                $.each(ftNames, (idx, ft) => {
                                    data.push({ id: ft });
                                });
                                options.success(data);
                            },
                        });
                    }
                    else {
                        that.embeddedSelection.prop("checked", true);
                        that.enableComboBox(that.dataSelection, true);
                        $("#" + that.controlId + "_newbutton").prop("disabled", false);
                        // Get all embedded collections
                        let dataNames = [];
                        $.each(that.designer.clControlFactory.instance.collections, (idx, value) => {
                            if (!value.isft) {
                                if (!that.dependentFieldSelected || value.columns.indexOf("pid") !== -1)
                                    dataNames.push({ id: value.id });
                            }
                        });
                        options.success(dataNames);
                    }
                },
            }
        }));
    }
    setSelfRefOrDependentVisibility() {
        let that = this;
        let hasPidColumn = false;
        if (that.item["dataname"]) {
            let collection;
            $.each(that.designer.clControlFactory.instance.collections, (idx, value) => {
                if (value.id === that.item["dataname"])
                    collection = value;
            });
            if (collection && collection.columns.indexOf("pid") !== -1)
                hasPidColumn = true;
        }
        if (that.hasPidColumn || hasPidColumn) {
            if (that.item["isselfrefft"]) {
                that.selfrefSelection.removeAttr("disabled");
                that.enableComboBox(that.dependentFieldSelection, false);
            }
            else if (that.item["dependentfield"]) {
                that.selfrefSelection.attr("disabled", "disabled");
                that.enableComboBox(that.dependentFieldSelection, true);
            }
            else {
                if (that.checkIfSelfrefIsAllowedForLinkedFields())
                    that.selfrefSelection.removeAttr("disabled");
                else
                    that.selfrefSelection.attr("disabled", "disabled");
                that.enableComboBox(that.dependentFieldSelection, true);
            }
        }
        else {
            that.selfrefSelection.attr("disabled", "disabled");
            that.enableComboBox(that.dependentFieldSelection, false);
        }
    }
    setDependentFieldDataSource() {
        let that = this;
        let data = [];
        let fields = that.designer.clControlFactory.Fields();
        $.each(fields, (idx, value) => {
            let isSelectedField = false;
            $.each(that.selectedItems, (idx, selItem) => {
                if (selItem.id === value["id"])
                    isSelectedField = true;
            });
            if (!isSelectedField && value["datatype"] === "List" && !value["isselfrefft"]) {
                // Check for recursive selection
                let allParents = that.designer.clControlFactory.getAllParentFields(fields, value);
                let found = false;
                let isLinkedField = false;
                $.each(that.selectedItems, (idx, selItem) => {
                    if (allParents.find(p => p["id"] === selItem.id))
                        found = true;
                    if (selItem["linkedfield"] && value["linkedfield"] && selItem["linkedfield"] === value["linkedfield"])
                        isLinkedField = true;
                });
                if (!found && !isLinkedField) {
                    let entry = { "id": value["id"], "name": that.designer.clControlFactory.getLabelText(value["labels"], that.designer.clControlFactory.userUILangId, that.designer.clControlFactory.instance.langid) + " (" + value["externalid"] + ")" };
                    data.push(entry);
                }
            }
        });
        that.dependentFieldSelection.data("kendoComboBox").setDataSource(new kendo.data.DataSource({ data }));
    }
    checkIfSelfrefIsAllowedForLinkedFields() {
        let that = this;
        let bReturn = true;
        if (that.linkedFieldSelected) {
            if (that.parentLinkedFieldSelected) {
                $.each(that.selectedItems, (idx, field) => {
                    if (field["linkedfield"]) {
                        $.each(that.designer.clControlFactory.GetLinkedFields(field["linkedfield"]), (idx, lf) => {
                            if (lf.controltype !== "Combobox")
                                bReturn = false;
                        });
                    }
                });
            }
            else
                bReturn = false;
        }
        return bReturn;
    }
    setColumnNameDataSource() {
        let that = this;
        this.columnSelection.data("kendoComboBox").setDataSource(new kendo.data.DataSource({
            serverFiltering: true,
            requestStart: function requestStart(e) {
            },
            requestEnd: function requestEnd(e) {
            },
            transport: {
                read: function read(options) {
                    let callback = function (data) {
                        options.success(data);
                    };
                    let checkSpecialColumns = function (columns) {
                        let langidColumns = $.grep(columns, (value) => {
                            return value === "langid";
                        });
                        let pidColumns = $.grep(columns, (value) => {
                            return value === "pid";
                        });
                        if (langidColumns.length > 0) {
                            that.isMultiLang = true;
                            that.multilangSelection.prop("checked", true);
                        }
                        else {
                            that.isMultiLang = false;
                            that.multilangSelection.prop("checked", false);
                        }
                        that.multilangSelection.prop("indeterminate", false);
                        that.hasPidColumn = pidColumns.length > 0;
                        that.setSelfRefOrDependentVisibility();
                        that.selfrefSelection.prop("indeterminate", false);
                        that.notifyChange();
                    };
                    let dataName = that.dataSelection.data("kendoComboBox").value();
                    let selectedType = that.typeSelection.data("kendoComboBox").value();
                    let collection;
                    $.each(that.designer.clControlFactory.instance.collections, (idx, value) => {
                        if (value.id === that.dataSelection.data("kendoComboBox").value()) {
                            collection = value;
                        }
                    });
                    let embbeded = collection && collection.embedded && collection.data && collection.data.length > 0;
                    if (selectedType === "1" && !embbeded) {
                        Utilities_1.synUtil.getAJAXData({
                            url: Utilities_1.synUtil.getWSUrl("ChecklistGetForeignTableColumns") + dataName,
                            done(ftColumns) {
                                let columns = [];
                                $.each(ftColumns, (idx, ft) => {
                                    columns.push({ id: ft });
                                });
                                options.success(columns);
                                checkSpecialColumns(ftColumns);
                            }
                        });
                    }
                    else {
                        let columns = [];
                        $.each(collection.columns, (idx, value) => {
                            columns.push({ id: value });
                        });
                        options.success(columns);
                        checkSpecialColumns(columns);
                    }
                }
            }
        }));
    }
    setSortColumnsDataSource() {
        let that = this;
        $("#" + that.controlId + "_sortcolumn").data("kendoComboBox").setDataSource(new kendo.data.DataSource({
            serverFiltering: true,
            requestStart: function requestStart(e) {
            },
            requestEnd: function requestEnd(e) {
            },
            transport: {
                read: function read(options) {
                    let dataName = that.dataSelection.data("kendoComboBox").value();
                    let collection = that.designer.clControlFactory.instance.collections.find(c => c.id === dataName);
                    let data = [];
                    if (collection) {
                        $.each(collection.columns, (idx, column) => {
                            data.push({ "id": column });
                        });
                    }
                    options.success(data);
                }
            }
        }));
    }
    sortDirectionChanged() {
        $("input[name=" + this.controlId + "_sortdirection]").prop("indeterminate", false);
        this.setFtSort();
    }
    setFtSort(preventSortChanged = false) {
        let that = this;
        let ftsort;
        let direction = $("input[name=" + this.controlId + "_sortdirection]:checked").val();
        let sortColumn = this.sortColumnSelection.data("kendoComboBox").value();
        if (sortColumn && direction) {
            ftsort = sortColumn + "." + direction;
            that.item["ftsort"] = ftsort;
            $.each(that.selectedItems, (idx, item) => {
                let oldftsort = item["ftsort"];
                item["ftsort"] = ftsort;
                if (oldftsort !== ftsort && !preventSortChanged) {
                    let control = that.designer.clControlFactory.getFieldControl(item["id"]);
                    control.dataSortChanged();
                }
            });
            that.notifyChange();
        }
    }
    setVisibility(visible) {
        if (visible)
            $("#" + this.controlId + "_container").show();
        else
            $("#" + this.controlId + "_container").hide();
    }
    highlightMandatory() {
        if (this.mandatory && this.columnSelection && this.columnSelection.data("kendoComboBox") && !this.columnSelection.data("kendoComboBox").value())
            $("#" + this.controlId + "_container").addClass("clMandatoryProperty");
        else
            $("#" + this.controlId + "_container").removeClass("clMandatoryProperty");
        this.designer.updateItemsInfo(this.selectedItems);
    }
    addChangedListForUpdate(listName) {
        if (this.changedListNames.findIndex(name => name === listName) === -1)
            this.changedListNames.push(listName);
    }
    enableMultiSelect(multiselect, enable) {
        if (multiselect) {
            if (multiselect.data("kendoMultiSelect")) {
                let target = multiselect.data("kendoMultiSelect").input.closest(".k-input");
                multiselect.data("kendoMultiSelect").enable(enable);
                if (enable) {
                    target.removeClass("clReadOnly");
                    multiselect.removeClass("clReadOnly");
                }
                else {
                    target.addClass("clReadOnly");
                    multiselect.addClass("clReadOnly");
                }
            }
            else if (multiselect.data("kendoDropDownList")) {
                let target = multiselect.data("kendoDropDownList").span;
                multiselect.data("kendoDropDownList").enable(enable);
                if (enable) {
                    target.removeClass("clReadOnly");
                    multiselect.removeClass("clReadOnly");
                }
                else {
                    target.addClass("clReadOnly");
                    multiselect.addClass("clReadOnly");
                }
            }
        }
    }
    enableComboBox(comboBox, enable) {
        if (comboBox) {
            if (comboBox.data("kendoComboBox")) {
                let target = comboBox.data("kendoComboBox").input.closest(".k-input");
                comboBox.data("kendoComboBox").enable(enable);
                if (enable) {
                    target.removeClass("clReadOnly");
                    comboBox.removeClass("clReadOnly");
                }
                else {
                    target.addClass("clReadOnly");
                    comboBox.addClass("clReadOnly");
                }
            }
            else if (comboBox.data("kendoDropDownList")) {
                let target = comboBox.data("kendoDropDownList").span;
                comboBox.data("kendoDropDownList").enable(enable);
                if (enable) {
                    target.removeClass("clReadOnly");
                    comboBox.removeClass("clReadOnly");
                }
                else {
                    target.addClass("clReadOnly");
                    comboBox.addClass("clReadOnly");
                }
            }
        }
    }
    enableRadioButtons(enable) {
        if (enable)
            $("input[name = " + this.controlId + "_sortdirection]").removeAttr("disabled");
        else
            $("input[name = " + this.controlId + "_sortdirection]").attr("disabled", "disabled");
    }
    setValue() {
    }
    getValue() {
    }
    confirmDialogIfLocalChanged() {
        let result = true;
        if ($("#syncl_listeditor_grid").data("kendoGrid").dataSource.hasChanges())
            result = window.confirm("Wollen Sie die lokalen Änderungen verwerfen?");
        return result;
    }
    openFtEditor(listName) {
        let that = this;
        let windowData = Utilities_1.synUtil.popupWindow({
            title: Utilities_1.synUtil.Strings.getValue("clcollecionlisteditortitleproperty"),
            actions: ["Maximize", "Close"],
            width: 400,
            height: 300,
            minwidth: 400,
            minheight: 300,
            resizable: true,
            modal: true,
            synDesktopAware: true
        });
        let container = $("<div style='height:100%;width:100%'/>").appendTo(windowData.contentDiv);
        let controlsContainer = $("<div />").appendTo(container);
        let buttonContainer = $("<div style='width: 100%; box-sizing: border-box; text-align: left; margin-top:5px;' class='buttonPane' ></div>").appendTo(container);
        let implicitColumnsLabel = $("<label />").appendTo(controlsContainer);
        let implicitColumnsMS = $("<select id='implicitcolsms' multiple='multiple' class='clInput' style='width:100%; margin-top:5px; margin-bottom:10px'>").appendTo(controlsContainer);
        let explicitColumnsLabel = $("<label />").appendTo(controlsContainer);
        let explicitColumnsMS = $("<select id='explicitcolsms' class='clInput' style='width:100%; margin-top:5px;'>").appendTo(controlsContainer);
        let okButton = $("<button type='button' class='btn btn-primary' >" + Utilities_1.synUtil.Strings.getValue("menuok") + "</button>").appendTo(buttonContainer);
        explicitColumnsLabel.text(Utilities_1.synUtil.Strings.getValue("clexplicitcolfields"));
        let implicitColumns = [];
        let explicitColumns = [];
        if (listName) {
            let collection = that.designer.clControlFactory.instance.collections.find(coll => coll.id === listName);
            let allColumns = collection.columns;
            let result = that.designer.clControlFactory.getUsedColumns(listName);
            implicitColumns = result["columns"];
            implicitColumnsLabel.text(Utilities_1.synUtil.Strings.getValue("climplicitcolfields") + result["fields"].join(", "));
            $.each(allColumns, (idx, col) => {
                if (implicitColumns.indexOf(col) === -1)
                    explicitColumns.push(col);
            });
        }
        $.each(implicitColumns, (idx, column) => {
            $("<option selected>" + column + "</option>").appendTo(implicitColumnsMS);
        });
        $.each(explicitColumns, (idx, column) => {
            $("<option selected>" + column + "</option>").appendTo(explicitColumnsMS);
        });
        implicitColumnsMS.kendoMultiSelect({
            enable: false,
            noDataTemplate: kendo.htmlEncode(Utilities_1.synUtil.Strings.getValue("dynpnomatchingitemfound")),
        });
        explicitColumnsMS.kendoMultiSelect({
            filter: "contains",
            dataTextField: "id",
            dataValueField: "id",
            noDataTemplate: kendo.htmlEncode(Utilities_1.synUtil.Strings.getValue("dynpnomatchingitemfound")),
            dataSource: {
                serverFiltering: true,
                requestStart: function requestStart(e) {
                },
                requestEnd: function requestEnd(e) {
                },
                transport: {
                    read: function read(options) {
                        Utilities_1.synUtil.getAJAXData({
                            url: Utilities_1.synUtil.getWSUrl("ChecklistGetForeignTableColumns") + listName,
                            done(ftColumns) {
                                let columns = [];
                                $.each(ftColumns, (idx, ft) => {
                                    if (implicitColumns.indexOf(ft) === -1)
                                        columns.push({ id: ft });
                                });
                                options.success(columns.sort());
                            }
                        });
                    }
                }
            },
            select: (e) => {
                if (listName) {
                    let collection = that.designer.clControlFactory.instance.collections.find(coll => coll.id === listName);
                    if (collection) {
                        if (collection.columns.findIndex(c => c === e.dataItem.id) === -1)
                            collection.columns.push(e.dataItem.id);
                    }
                }
            },
            deselect: (e) => {
                let dataItem = e.dataItem;
                let collection = that.designer.clControlFactory.instance.collections.find(coll => coll.id === listName);
                if (collection) {
                    let idx = collection.columns.findIndex(c => c === e.dataItem.id);
                    if (idx !== -1)
                        collection.columns.splice(idx, 1);
                }
            }
        });
        $("#" + windowData.windowID).data("kendoWindow").bind("close", function (e) {
            that.setSortColumnsDataSource();
            $("#" + windowData.windowID).data("kendoWindow").destroy();
        });
        okButton.on("click", function (e) {
            that.setSortColumnsDataSource();
            $("#" + windowData.windowID).data("kendoWindow").close();
        });
    }
    openListEditor(listName) {
        let that = this;
        let windowData = Utilities_1.synUtil.popupWindow({
            title: Utilities_1.synUtil.Strings.getValue("clcollecionlisteditortitleproperty"),
            actions: ["Maximize", "Close"],
            width: 1024,
            height: 768,
            minwidth: 400,
            minheight: 300,
            resizable: true,
            modal: true,
            synDesktopAware: true
        });
        let listEditorControlContainer = $("<div style='height: 100px; width:100%; box-sizing:border-box; padding-top:10px; padding-bottom:10px;' />").appendTo(windowData.contentDiv);
        let listEditorControlTopContainer = $("<div style='height: 50%; width:100%; box-sizing:border-box; display:inline-block;' />").appendTo(listEditorControlContainer);
        let listEditorControlBottomContainer = $("<div style='height: 50%; width:100%; box-sizing:border-box; display:inline-block;' />").appendTo(listEditorControlContainer);
        let listSelContainer = $("<div style='width: 50%; display:inline-block; box-sizing: border-box; ' ></div>").appendTo(listEditorControlTopContainer);
        let buttonContainer = $("<div style='width: 50%; display:inline-block; box-sizing: border-box; text-align: right;' class='buttonPane' ></div>").appendTo(listEditorControlTopContainer);
        let dataSelection = $("<input id='dataeditcmb' style='width:50%;  box-sizing: border-box; margin-right: 5px;'/>").appendTo(listSelContainer);
        let newListButton = $("<button type='button' class='btn btn-primary' style='min-width:80px;' >" + Utilities_1.synUtil.Strings.getValue("cllisteditornewlistlabel") + "</button>").appendTo(listSelContainer);
        let saveButton = $("<button type='button' class='btn btn-primary' >" + Utilities_1.synUtil.Strings.getValue("menusave") + "</button>").appendTo(buttonContainer);
        let okButton = $("<button type='button' class='btn btn-primary' >" + Utilities_1.synUtil.Strings.getValue("menusaveandclose") + "</button>").appendTo(buttonContainer);
        let cancelButton = $("<button type='button' class='btn' >" + Utilities_1.synUtil.Strings.getValue("menucancel") + "</button>").appendTo(buttonContainer);
        let dataNames = [];
        let sortColumnAddedList = [];
        let sortColumnRemovedList = [];
        $.each(that.designer.clControlFactory.instance.collections, (idx, value) => {
            if (!value["isft"]) {
                if (!that.dependentFieldSelected || value.columns.indexOf("pid") !== -1)
                    dataNames.push(value.id);
            }
        });
        let listCmbBox = dataSelection.kendoComboBox({
            dataSource: dataNames,
            noDataTemplate: kendo.htmlEncode(Utilities_1.synUtil.Strings.getValue("dynpnomatchingitemfound")),
            select(e) {
                // Check if grid is local changed
                if ($("#syncl_listeditor_grid").data("kendoGrid").dataSource.hasChanges()) {
                    let res = window.confirm(Utilities_1.synUtil.Strings.getValue("cllisteditordiscardmessage"));
                    if (!res)
                        e.preventDefault();
                }
            },
            change(e) {
                let val = e.sender.value();
                if (e.sender.dataItem() && val) {
                    $("#syncl_listeditor_grid").attr("cl_designer_listname", val);
                    that.setGridData(val);
                }
            },
        }).data("kendoComboBox");
        listCmbBox.value(listName);
        $("<button type='button' id='cl_designer_listeditor_newrow' class='btn btn-primary'  style=' margin-right: 5px; min-width:80px'>" + Utilities_1.synUtil.Strings.getValue("cllisteditornewrowlabel") + "</button>").appendTo(listEditorControlBottomContainer);
        $("<button type='button' id='cl_designer_listeditor_newcol' class='btn btn-primary' style=' margin-right: 5px; min-width:80px'>" + Utilities_1.synUtil.Strings.getValue("cllisteditornewcollabel") + "</button>").appendTo(listEditorControlBottomContainer);
        // Multilang
        $("<div style='display: inline-block;  vertical-align:middle;   margin-right: 5px;'><label>" + Utilities_1.synUtil.Strings.getValue("cllisteditormultilanglabel") + "</label><input id='cl_designer_listeditor_multilang_cb' type='checkbox' name='multilang' value='multilang' style='vertical-align:middle; width:1.5em;height:1.5em'></input></div>").appendTo(listEditorControlBottomContainer);
        $("#cl_designer_listeditor_multilang_cb").change((e) => {
            let grid = $("#syncl_listeditor_grid").data("kendoGrid");
            let callBack = function () {
                let dataName = dataSelection.data("kendoComboBox").value();
                if ($(e.target).prop("checked")) {
                    $.each(that.designer.clControlFactory.instance.collections, (idx, list) => {
                        if (list.id === dataName) {
                            $.each(list.data, (entryIdx, entry) => {
                                entry["langid"] = "0";
                            });
                            if (list.columns.indexOf("langid") === -1)
                                list.columns.push("langid");
                        }
                    });
                }
                else {
                    $.each(that.designer.clControlFactory.instance.collections, (idx, list) => {
                        if (list.id === dataName) {
                            $.each(list.data, (entryIdx, entry) => {
                                if (entry["langid"] != undefined && entry["langid"] != undefined)
                                    delete entry["langid"];
                            });
                            let idx = list.columns.indexOf("langid");
                            if (idx !== -1)
                                list.columns.splice(idx, 1);
                        }
                    });
                }
                that.setGridData(dataName);
                Utilities_1.synUtil.Notifications.success(Utilities_1.synUtil.Strings.getValue("savedchanges"));
            };
            if (grid.dataSource.hasChanges()) {
                if (window.confirm(Utilities_1.synUtil.Strings.getValue("cllisteditorlocalchangedmessage").replace("{0}", "langid"))) {
                    grid.dataSource.sync().done(function () { callBack(); }).fail(function () {
                        $(e.target).prop("checked", !$(e.target).prop("checked"));
                        return;
                    });
                }
                else {
                    $(e.target).prop("checked", !$(e.target).prop("checked"));
                    return;
                }
            }
            else
                callBack();
        });
        // Pid
        $("<div style='display: inline-block;  margin-right: 5px; vertical-align:middle;'><label>" + Utilities_1.synUtil.Strings.getValue("cllisteditorpidcolumnlabel") + "</label><input id='cl_designer_listeditor_pid_cb' type='checkbox' style='vertical-align:middle; width:1.5em;height:1.5em'></input></div>").appendTo(listEditorControlBottomContainer);
        $("#cl_designer_listeditor_pid_cb").change((e) => {
            let grid = $("#syncl_listeditor_grid").data("kendoGrid");
            let callBack = function () {
                let dataName = dataSelection.data("kendoComboBox").value();
                if ($(e.target).prop("checked")) {
                    $.each(that.designer.clControlFactory.instance.collections, (idx, list) => {
                        if (list.id === dataName) {
                            $.each(list.data, (entryIdx, entry) => {
                                entry["pid"] = "";
                            });
                            if (list.columns.indexOf("pid") === -1)
                                list.columns.push("pid");
                        }
                    });
                }
                else {
                    $.each(that.designer.clControlFactory.instance.collections, (idx, list) => {
                        if (list.id === dataName) {
                            $.each(list.data, (entryIdx, entry) => {
                                if (entry["pid"] != undefined && entry["pid"] != undefined)
                                    delete entry["pid"];
                            });
                            let idx = list.columns.indexOf("pid");
                            if (idx !== -1)
                                list.columns.splice(idx, 1);
                        }
                    });
                }
                that.setGridData(dataName);
                Utilities_1.synUtil.Notifications.success(Utilities_1.synUtil.Strings.getValue("savedchanges"));
            };
            if (grid.dataSource.hasChanges()) {
                if (window.confirm(Utilities_1.synUtil.Strings.getValue("cllisteditorlocalchangedmessage").replace("{0}", "pid"))) {
                    grid.dataSource.sync().done(function () { callBack(); }).fail(function () {
                        $(e.target).prop("checked", !$(e.target).prop("checked"));
                        return;
                    });
                }
                else {
                    $(e.target).prop("checked", !$(e.target).prop("checked"));
                    return;
                }
            }
            else
                callBack();
        });
        // Sortable
        $("<div style='display: inline-block; vertical-align:middle;  margin-right: 5px;'><label>" + Utilities_1.synUtil.Strings.getValue("cllisteditorsortablelabel") + "</label><input id='cl_designer_listeditor_sort_cb' type='checkbox' style='vertical-align:middle; width:1.5em;height:1.5em'></input></div>").appendTo(listEditorControlBottomContainer);
        $("#cl_designer_listeditor_sort_cb").change((e) => {
            let grid = $("#syncl_listeditor_grid").data("kendoGrid");
            let callBack = function () {
                let dataName = dataSelection.data("kendoComboBox").value();
                if ($(e.target).prop("checked")) {
                    $.each(that.designer.clControlFactory.instance.collections, (idx, list) => {
                        if (list.id === dataName) {
                            $.each(list.data, (entryIdx, entry) => {
                                entry["sort"] = entryIdx.toString();
                            });
                            if (list.columns.indexOf("sort") === -1)
                                list.columns.push("sort");
                        }
                    });
                }
                else {
                    $.each(that.designer.clControlFactory.instance.collections, (idx, list) => {
                        if (list.id === dataName) {
                            $.each(list.data, (entryIdx, entry) => {
                                if (entry["sort"] != undefined && entry["sort"] != undefined)
                                    delete entry["sort"];
                            });
                            let idx = list.columns.indexOf("sort");
                            if (idx !== -1)
                                list.columns.splice(idx, 1);
                        }
                    });
                }
                that.setGridData(dataName);
                Utilities_1.synUtil.Notifications.success(Utilities_1.synUtil.Strings.getValue("savedchanges"));
            };
            if (grid.dataSource.hasChanges()) {
                if (window.confirm(Utilities_1.synUtil.Strings.getValue("cllisteditorlocalchangedmessage").replace("{0}", "sort"))) {
                    grid.dataSource.sync().done(function () { callBack(); }).fail(function () {
                        $(e.target).prop("checked", !$(e.target).prop("checked"));
                        return;
                    });
                }
                else {
                    $(e.target).prop("checked", !$(e.target).prop("checked"));
                    return;
                }
            }
            else
                callBack();
        });
        // Abstract
        $("<div style='display: inline-block; vertical-align:middle;  margin-right: 5px;'><label>" + Utilities_1.synUtil.Strings.getValue("cllisteditorabstractlabel") + "</label><input id='cl_designer_listeditor_abstract_cb' type='checkbox' style='vertical-align:middle; width:1.5em;height:1.5em'></input></div>").appendTo(listEditorControlBottomContainer);
        $("#cl_designer_listeditor_abstract_cb").change((e) => {
            let grid = $("#syncl_listeditor_grid").data("kendoGrid");
            let callBack = function () {
                let dataName = dataSelection.data("kendoComboBox").value();
                if ($(e.target).prop("checked")) {
                    $.each(that.designer.clControlFactory.instance.collections, (idx, list) => {
                        if (list.id === dataName) {
                            $.each(list.data, (entryIdx, entry) => {
                                entry["abstract"] = "N";
                            });
                            if (list.columns.indexOf("abstract") === -1)
                                list.columns.push("abstract");
                        }
                    });
                }
                else {
                    // remove abstract
                    $.each(that.designer.clControlFactory.instance.collections, (idx, list) => {
                        if (list.id === dataName) {
                            $.each(list.data, (entryIdx, entry) => {
                                if (entry["abstract"] != undefined && entry["abstract"] != undefined)
                                    delete entry["abstract"];
                            });
                            let idx = list.columns.indexOf("abstract");
                            if (idx !== -1)
                                list.columns.splice(idx, 1);
                        }
                    });
                }
                that.setGridData(dataName);
                Utilities_1.synUtil.Notifications.success(Utilities_1.synUtil.Strings.getValue("savedchanges"));
            };
            if (grid.dataSource.hasChanges()) {
                if (window.confirm(Utilities_1.synUtil.Strings.getValue("cllisteditorlocalchangedmessage").replace("{0}", "abstract"))) {
                    grid.dataSource.sync().done(function () { callBack(); }).fail(function () {
                        $(e.target).prop("checked", !$(e.target).prop("checked"));
                        return;
                    });
                }
                else {
                    $(e.target).prop("checked", !$(e.target).prop("checked"));
                    return;
                }
            }
            else
                callBack();
        });
        // Deleted
        $("<div style='display: inline-block; vertical-align:middle;  margin-right: 5px;'><label>" + Utilities_1.synUtil.Strings.getValue("cllisteditordeletedlabel") + "</label><input id='cl_designer_listeditor_deleted_cb' type='checkbox' style='vertical-align:middle; width:1.5em;height:1.5em'></input></div>").appendTo(listEditorControlBottomContainer);
        $("#cl_designer_listeditor_deleted_cb").change((e) => {
            let grid = $("#syncl_listeditor_grid").data("kendoGrid");
            let callBack = function () {
                let dataName = dataSelection.data("kendoComboBox").value();
                if ($(e.target).prop("checked")) {
                    $.each(that.designer.clControlFactory.instance.collections, (idx, list) => {
                        if (list.id === dataName) {
                            $.each(list.data, (entryIdx, entry) => {
                                entry["deleted"] = "N";
                            });
                            if (list.columns.indexOf("deleted") === -1)
                                list.columns.push("deleted");
                        }
                    });
                }
                else {
                    // remove deleted
                    $.each(that.designer.clControlFactory.instance.collections, (idx, list) => {
                        if (list.id === dataName) {
                            $.each(list.data, (entryIdx, entry) => {
                                if (entry["deleted"] != undefined && entry["deleted"] != undefined)
                                    delete entry["deleted"];
                            });
                            let idx = list.columns.indexOf("deleted");
                            if (idx !== -1)
                                list.columns.splice(idx, 1);
                        }
                    });
                }
                that.setGridData(dataName);
                Utilities_1.synUtil.Notifications.success(Utilities_1.synUtil.Strings.getValue("savedchanges"));
            };
            if (grid.dataSource.hasChanges()) {
                if (window.confirm(Utilities_1.synUtil.Strings.getValue("cllisteditorlocalchangedmessage").replace("{0}", "deleted"))) {
                    grid.dataSource.sync().done(function () { callBack(); }).fail(function () {
                        $(e.target).prop("checked", !$(e.target).prop("checked"));
                        return;
                    });
                }
                else {
                    $(e.target).prop("checked", !$(e.target).prop("checked"));
                    return;
                }
            }
            else
                callBack();
        });
        // DeltedWarning
        $("<div style='display: inline-block; vertical-align:middle;  margin-right: 5px;'><label>" + Utilities_1.synUtil.Strings.getValue("cllisteditordeletedwarninglabel") + "</label><input id='cl_designer_listeditor_deletedwarning_cb' type='checkbox' style='vertical-align:middle; width:1.5em;height:1.5em'></input></div>").appendTo(listEditorControlBottomContainer);
        $("#cl_designer_listeditor_deletedwarning_cb").change((e) => {
            let grid = $("#syncl_listeditor_grid").data("kendoGrid");
            let callBack = function () {
                let dataName = dataSelection.data("kendoComboBox").value();
                if ($(e.target).prop("checked")) {
                    $.each(that.designer.clControlFactory.instance.collections, (idx, list) => {
                        if (list.id === dataName) {
                            $.each(list.data, (entryIdx, entry) => {
                                entry["deletedwarning"] = "Y";
                            });
                            if (list.columns.indexOf("deletedwarning") === -1)
                                list.columns.push("deletedwarning");
                        }
                    });
                }
                else {
                    // remove deletedwarning
                    $.each(that.designer.clControlFactory.instance.collections, (idx, list) => {
                        if (list.id === dataName) {
                            $.each(list.data, (entryIdx, entry) => {
                                if (entry["deletedwarning"] != undefined && entry["deletedwarning"] != undefined)
                                    delete entry["deletedwarning"];
                            });
                            let idx = list.columns.indexOf("deletedwarning");
                            if (idx !== -1)
                                list.columns.splice(idx, 1);
                        }
                    });
                }
                that.setGridData(dataName);
                Utilities_1.synUtil.Notifications.success(Utilities_1.synUtil.Strings.getValue("savedchanges"));
            };
            if (grid.dataSource.hasChanges()) {
                if (window.confirm(Utilities_1.synUtil.Strings.getValue("cllisteditorlocalchangedmessage").replace("{0}", "deletedwarning"))) {
                    grid.dataSource.sync().done(function () { callBack(); }).fail(function () {
                        $(e.target).prop("checked", !$(e.target).prop("checked"));
                        return;
                    });
                }
                else {
                    $(e.target).prop("checked", !$(e.target).prop("checked"));
                    return;
                }
            }
            else
                callBack();
        });
        newListButton.on("click", function () {
            if (that.confirmDialogIfLocalChanged()) {
                let callback = function (listName) {
                    if (listCmbBox) {
                        let dataNames = [];
                        $.each(that.designer.clControlFactory.instance.collections, (idx, value) => {
                            if (!value["isft"]) {
                                dataNames.push(value.id);
                            }
                        });
                        listCmbBox.setDataSource(new kendo.data.DataSource({ data: dataNames }));
                        listCmbBox.value(listName);
                        $("#syncl_listeditor_grid").attr("cl_designer_listname", listName);
                        that.setGridData(listName);
                    }
                };
                that.addNewList(callback);
            }
        });
        $("#cl_designer_listeditor_newrow").on("click", function () {
            $("#syncl_listeditor_grid").data("kendoGrid").addRow();
        });
        $("#cl_designer_listeditor_newcol").on("click", function () {
            let windowData = Utilities_1.synUtil.popupWindow({
                title: Utilities_1.synUtil.Strings.getValue("clcollecionnewcolumntitleproperty"),
                actions: ["Maximize", "Close"],
                width: 400,
                height: 300,
                resizable: true,
                modal: true,
                synDesktopAware: true
            });
            let windowId = "popup_" + windowData.guid;
            let listNameControl = $("<input type='text' style='width:100%;' class='clInput k-textbox' maxlength='100' autofocus/>").appendTo(windowData.contentDiv);
            let buttonPane = $("<div class='buttonPane' style='padding-top: 5px; padding-bottom: 5px; '>").appendTo(windowData.contentDiv);
            let okButton = $("<button id='listname_dlg_ok_button' type='button' class='btn btn-primary' readonly>" + Utilities_1.synUtil.Strings.getValue("menuok") + "</button>").appendTo(buttonPane);
            let cancelButton = $("<button id='listname_dlg_cancel_button' type='button' class='btn' >" + Utilities_1.synUtil.Strings.getValue("menucancel") + "</button>").appendTo(buttonPane);
            okButton.attr("disabled", "disabled");
            listNameControl.on("input", function (e) {
                if (e) {
                    let value = $(this).val().toString();
                    if (value.match(/[^a-zA-Z0-9]/g)) {
                        value = value.replace(/[^a-zA-Z0-9]/g, "");
                        $(this).val(value);
                    }
                    if (value)
                        okButton.removeAttr("disabled");
                    else
                        okButton.attr("disabled", "disabled");
                }
            });
            listNameControl.on("keydown", function (e) {
                if (e.keyCode === 13) {
                    let value = $(this).val().toString();
                    if (value.match(/[^a-zA-Z0-9]/g)) {
                        value = value.replace(/[^a-zA-Z0-9]/g, "");
                        $(this).val(value);
                    }
                    if (value) {
                        if (that.addNewColumn(value))
                            $("#" + windowId).data("kendoWindow").close();
                    }
                }
            });
            okButton.on("click", function (e) {
                let newColumn = listNameControl.val().toString();
                if (that.addNewColumn(newColumn))
                    $("#" + windowId).data("kendoWindow").close();
            });
            cancelButton.on("click", function (e) {
                that.designer.updateProperties(that.selectedItems, true);
                $("#" + windowId).data("kendoWindow").close();
            });
        });
        let collectionGrid = $("<div id='syncl_listeditor_grid' style='height: calc(100% - 100px);' />").appendTo(windowData.contentDiv);
        collectionGrid.attr("cl_designer_listname", listName);
        $("#" + windowData.windowID).data("kendoWindow").bind("close", function (e) {
            if (that.confirmDialogIfLocalChanged()) {
                that.updateItemsBeforeClosingListEditor(sortColumnAddedList, sortColumnRemovedList);
                $("#" + windowData.windowID).data("kendoWindow").destroy();
            }
            else
                e.preventDefault();
        });
        cancelButton.on("click", function (e) {
            if (that.confirmDialogIfLocalChanged()) {
                that.updateItemsBeforeClosingListEditor(sortColumnAddedList, sortColumnRemovedList);
                $("#" + windowData.windowID).data("kendoWindow").close();
            }
        });
        saveButton.on("click", function (e) {
            $("#syncl_listeditor_grid").data("kendoGrid").dataSource.sync().done(function () {
                Utilities_1.synUtil.Notifications.success(Utilities_1.synUtil.Strings.getValue("savedchanges"));
            });
        });
        okButton.on("click", function (e) {
            // Check if list is local changed
            let saveCallback = function () {
                if (!$("#syncl_listeditor_grid").data("kendoGrid").dataSource.hasChanges()) {
                    that.updateItemsBeforeClosingListEditor(sortColumnAddedList, sortColumnRemovedList);
                    $("#" + windowData.windowID).data("kendoWindow").close();
                }
            };
            if ($("#syncl_listeditor_grid").data("kendoGrid").dataSource.hasChanges()) {
                let grid = $("#syncl_listeditor_grid").data("kendoGrid");
                kendo.ui.progress($("#syncl_listeditor_grid"), true);
                $("#syncl_listeditor_grid").data("kendoGrid").dataSource.sync().then(function () {
                    Utilities_1.synUtil.Notifications.success(Utilities_1.synUtil.Strings.getValue("savedchanges"));
                    saveCallback();
                }).always(function () {
                    kendo.ui.progress($("#syncl_listeditor_grid"), false);
                });
                $("#syncl_listeditor_grid").data("kendoGrid").trigger("saveChanges");
            }
            else
                saveCallback();
        });
        that.setGridData(listName);
    }
    updateItemsBeforeClosingListEditor(sortColumnAddedList, sortColumnRemovedList) {
        let that = this;
        // get cached collection
        let collection;
        let currentlistName = $("#syncl_listeditor_grid").attr("cl_designer_listname");
        $.each(that.designer.clControlFactory.instance.collections, (idx, value) => {
            if (!value.isft) {
                $.each(value.data, (idx2, entry) => {
                    if (entry["clid"] != undefined && entry["clid"] != undefined)
                        delete entry["clid"];
                    if (entry["cldataid"] != undefined && entry["cldataid"] != undefined)
                        delete entry["cldataid"];
                    if (entry["clorgid"] != undefined && entry["clorgid"] != undefined)
                        delete entry["clorgid"];
                    if (entry["_defaultId"] != undefined && entry["_defaultId"] != undefined)
                        delete entry["_defaultId"];
                    if (typeof entry["id"] === "number")
                        entry["id"] = entry["id"].toString();
                    if (entry["deleted"] != undefined && entry["deleted"] != undefined && typeof entry["deleted"] === "boolean") {
                        entry["deleted"] = entry["deleted"] ? "Y" : "N";
                    }
                    if (entry["deletedwarning"] != undefined && entry["deletedwarning"] != undefined && typeof entry["deletedwarning"] === "boolean") {
                        entry["deletedwarning"] = entry["deletedwarning"] ? "Y" : "N";
                    }
                    if (entry["abstract"] != undefined && entry["abstract"] != undefined && typeof entry["abstract"] === "boolean") {
                        entry["abstract"] = entry["abstract"] ? "Y" : "N";
                    }
                    if (entry["langid"] != undefined && entry["langid"] != undefined && typeof entry["langid"] === "number") {
                        entry["langid"] = entry["langid"].toString();
                    }
                    if (entry["sort"] != undefined && entry["sort"] != undefined && typeof entry["sort"] === "number") {
                        entry["sort"] = entry["sort"].toString();
                    }
                });
            }
        });
        // Update selected field
        if (that.item["dataname"] !== currentlistName) {
            that.item["datapresentedinfo"] = {};
            that.item["value"] = undefined;
            that.item["dataname"] = currentlistName;
            let currentCollection;
            $.each(that.designer.clControlFactory.dataCollection.allControls, (idx, value) => {
                if (value.id === currentlistName)
                    currentCollection = value;
            });
            let oldDataField = that.item["datafield"];
            if (currentCollection) {
                if (currentCollection.columns.findIndex(colName => colName === oldDataField) === -1) {
                    let idx = currentCollection.columns.findIndex(colName => colName !== "id");
                    if (idx === -1) {
                        that.item["datafield"] = "";
                        that.item["ftsort"] = "";
                    }
                    else {
                        that.item["datafield"] = currentCollection.columns[idx];
                        that.item["ftsort"] = currentCollection.columns[idx] + ".1";
                    }
                }
            }
        }
        if (sortColumnRemovedList.indexOf(currentlistName) !== -1 && that.item["ftsort"] === "sort.1")
            that.item["ftsort"] = undefined;
        if (sortColumnAddedList.indexOf(currentlistName) !== -1)
            that.item["ftsort"] = "sort.1";
        $.each(that.selectedItems, (idx, item) => {
            if (item["dataname"] !== currentlistName) {
                item["value"] = undefined;
                item["dataname"] = currentlistName;
                item["datapresentedinfo"] = {};
                let control = that.designer.clControlFactory.getFieldControl(item.id);
                control["keepIds"] = [];
                let currentCollection;
                $.each(that.designer.clControlFactory.dataCollection.allControls, (idx, value) => {
                    if (value.id === currentlistName)
                        currentCollection = value;
                });
                let oldDataField = item["datafield"];
                if (currentCollection) {
                    if (currentCollection.columns.findIndex(colName => colName === oldDataField) === -1) {
                        let index = currentCollection.columns.findIndex(colName => colName !== "id");
                        if (index === -1) {
                            item["datafield"] = "";
                            item["ftsort"] = "";
                        }
                        else {
                            item["datafield"] = currentCollection.columns[index];
                            item["ftsort"] = currentCollection.columns[index] + ".1";
                        }
                    }
                }
                that.updateField(control, item);
            }
            if (sortColumnRemovedList.indexOf(currentlistName) !== -1 && item["ftsort"] === "sort.1")
                item["ftsort"] = undefined;
            if (sortColumnAddedList.indexOf(currentlistName) !== -1)
                item["ftsort"] = "sort.1";
        });
        $.each(that.changedListNames, (idx, listName) => {
            $.each(that.designer.clControlFactory.dataCollection.allControls, (idx, value) => {
                if (value.id === listName)
                    collection = value;
            });
            let collectionCached = true;
            if (!collection) {
                collectionCached = false;
                // cache new collection
                let localCollection;
                collection = new ChecklistControls_1.ClCollection();
                collection.id = localCollection.id;
                $.each(localCollection.data, (idx, entry) => {
                    if (entry["clid"] != undefined && entry["clid"] != undefined)
                        delete entry["clid"];
                    if (entry["cldataid"] != undefined && entry["cldataid"] != undefined)
                        delete entry["cldataid"];
                    if (entry["clorgid"] != undefined && entry["clorgid"] != undefined)
                        delete entry["clorgid"];
                    if (entry["_defaultId"] != undefined && entry["_defaultId"] != undefined)
                        delete entry["_defaultId"];
                    if (typeof entry["id"] === "number")
                        entry["id"] = entry["id"].toString();
                    if (entry["deleted"] != undefined && entry["deleted"] != undefined && typeof entry["deleted"] === "boolean") {
                        entry["deleted"] = entry["deleted"] ? "Y" : "N";
                    }
                    if (entry["deletedwarning"] != undefined && entry["deletedwarning"] != undefined && typeof entry["deletedwarning"] === "boolean") {
                        entry["deletedwarning"] = entry["deletedwarning"] ? "Y" : "N";
                    }
                    if (entry["abstract"] != undefined && entry["abstract"] != undefined && typeof entry["abstract"] === "boolean") {
                        entry["abstract"] = entry["abstract"] ? "Y" : "N";
                    }
                    if (entry["langid"] != undefined && entry["langid"] != undefined && typeof entry["langid"] === "number") {
                        entry["langid"] = entry["langid"].toString();
                    }
                    if (entry["sort"] != undefined && entry["sort"] != undefined && typeof entry["sort"] === "number") {
                        entry["sort"] = entry["sort"].toString();
                    }
                });
                collection.data = localCollection.data;
                collection.columns = localCollection.columns;
                collection.ismultilangft = localCollection.ismultilangft;
                collection.isft = false;
                collection.issorted = localCollection.columns.indexOf("sort") >= 0;
                collection["embedded"] = true;
                that.designer.clControlFactory.dataCollection.pushControl(collection);
            }
            that.updateFields(listName, collection);
        });
        that.designer.updateProperties(that.selectedItems, true);
        that.notifyChange();
    }
    updateField(control, field) {
        let that = this;
        if (control instanceof ChecklistControls_1.ClCombobox || control instanceof ChecklistControls_1.ClSRComboboxContainer || control instanceof ChecklistControls_1.ClMVCheckBoxRadio || control instanceof ChecklistControls_1.ClMultipleChoice) {
            let innerCallback = function (datapresentedinfo) {
                if (datapresentedinfo) {
                    if (!control.field["datapresentedinfo"])
                        control.field["datapresentedinfo"] = {};
                    let test = $.each(datapresentedinfo, (key, value) => {
                        control.field["datapresentedinfo"][key] = value;
                    });
                }
                let newControl;
                that.item["value"] = undefined;
                switch (control.field["controltype"]) {
                    case "Radiobutton":
                        newControl = new ChecklistControls_1.ClMVCheckBoxRadio(control.field.id, control.field, that.designer.clControlFactory, 0, control.field["controltype"]);
                        break;
                    case "Checkbox":
                        newControl = new ChecklistControls_1.ClMVCheckBoxRadio(control.field.id, control.field, that.designer.clControlFactory, 0, control.field["controltype"]);
                        break;
                    case "Combobox":
                        if (control.field["isselfrefft"])
                            newControl = new ChecklistControls_1.ClSRComboboxContainer(control.field.id, control.field, that.designer.clControlFactory, 0);
                        else
                            newControl = new ChecklistControls_1.ClCombobox(control.field.id, control.field, that.designer.clControlFactory, 0);
                        break;
                    case "MultipleChoice":
                        newControl = new ChecklistControls_1.ClMultipleChoice(control.field.id, control.field, that.designer.clControlFactory, 0);
                        break;
                }
                if (newControl != undefined) {
                    newControl.setPageId = control.getPageId();
                    let jQueryParent = control.controljQueryElem.closest('.previewControl');
                    jQueryParent.children('.checklistrow').remove();
                    newControl.init(jQueryParent);
                    control = newControl;
                }
                that.designer.clControlFactory.updateControl(control.field.id, control);
                that.designer.clControlFactory.setRelationBetweenFields();
            };
            if (control.field["controltype"] === "Combobox") {
                that.designer.clControlFactory.getComboboxInfo(control.field, control.field.value, innerCallback);
            }
            else {
                if (control instanceof ChecklistControls_1.ClMVCheckBoxRadio || control instanceof ChecklistControls_1.ClMultipleChoice) {
                    let resetDataCallBack = function (datapresentedinfo) {
                        if (datapresentedinfo) {
                            if (!control.field["datapresentedinfo"])
                                control.field["datapresentedinfo"] = {};
                            let test = $.each(datapresentedinfo, (key, value) => {
                                control.field["datapresentedinfo"][key] = value;
                            });
                        }
                        else
                            control.field["datapresentedinfo"] = {};
                        control.resetData(undefined);
                    };
                    that.designer.clControlFactory.getComboboxInfo(control.field, control.field.value, resetDataCallBack);
                }
            }
            that.designer.clControlFactory.updateControl(field.id, control);
        }
    }
    updateFields(listName, collection) {
        let that = this;
        let fields = that.designer.clControlFactory.Fields();
        $.each(fields, (idx, field) => {
            // update all field controls where dataname === listname
            let tmpField = that.designer.clControlFactory.getFieldById(field.id, that.designer.clControlFactory.instance.layout);
            let control = that.designer.clControlFactory.getFieldControl(tmpField.id);
            if (control.field["dataname"] && control.field["dataname"] === listName) {
                that.updateField(control, field);
            }
        });
    }
    addNewColumn(colName) {
        let that = this;
        let grid = $("#syncl_listeditor_grid").data("kendoGrid");
        let gridOptions = grid.getOptions();
        let gridDataSource = grid.dataSource;
        let dataName = $("#dataeditcmb").data("kendoComboBox").value();
        let reservedColumnNames = ["id", "deleted", "deletedwarning", "langid", "lasttranslatedate", "lastchangedate", "pid", "abstract", "hyperlink", "systemuseronly", "cldataid", "clorgid"];
        let columNameIsReserved = false;
        $.each(reservedColumnNames, (idx, value) => {
            if (value === colName.toLocaleLowerCase())
                columNameIsReserved = true;
        });
        if (columNameIsReserved) {
            Utilities_1.synUtil.Notifications.error(Utilities_1.synUtil.Strings.getValue("cllisteditorreservedcolnameerror").replace("{0}", colName));
            return false;
        }
        else {
            let columnAlreadyExists = false;
            $.each(gridOptions.columns, (idx, value) => {
                if (value.field && value.field === colName)
                    columnAlreadyExists = true;
            });
            if (!columnAlreadyExists) {
                let callBack = function () {
                    $.each(that.designer.clControlFactory.instance.collections, (idx, list) => {
                        if (list.id === dataName) {
                            $.each(list.data, (entryIdx, entry) => {
                                entry[colName] = "";
                            });
                            if (list.columns.indexOf(colName) === -1)
                                list.columns.push(colName);
                        }
                    });
                    that.setGridData(dataName);
                    Utilities_1.synUtil.Notifications.success(Utilities_1.synUtil.Strings.getValue("savedchanges"));
                };
                if (grid.dataSource.hasChanges()) {
                    if (window.confirm(Utilities_1.synUtil.Strings.getValue("cllisteditorlocalchangedmessage").replace("{0}", colName))) {
                        grid.dataSource.sync().done(function () { callBack(); }).fail(function () {
                            return;
                        });
                    }
                    else
                        return;
                }
                else
                    callBack();
            }
        }
        return true;
    }
    addNewLangRow(e) {
        let that = this;
        e.preventDefault();
        let dataItem = $("#syncl_listeditor_grid").data("kendoGrid").dataItem($(e.currentTarget).closest("tr"));
        let currentId = dataItem["cldataid"];
        let currentClId = dataItem["clid"];
        let grid = $("#syncl_listeditor_grid").data("kendoGrid");
        let lastid = -1;
        $.each(grid.dataSource.data(), (idx, value) => {
            if (value["clid"] > lastid)
                lastid = value["clid"];
        });
        lastid = lastid + 1;
        let newEntry = {
            cldataid: currentId,
            clid: lastid,
            dirty: true,
        };
        if ($("#syncl_listeditor_grid").data("kendoGrid").columns.findIndex(column => column.field === "sort") !== -1) {
            newEntry["sort"] = lastid.toString();
        }
        grid.dataSource.add(newEntry);
    }
    deleteRowClick(e) {
        e.preventDefault();
    }
    upClick(e) {
        e.preventDefault();
        let dataSource = $("#syncl_listeditor_grid").data("kendoGrid").dataSource;
        let dataItem = $("#syncl_listeditor_grid").data("kendoGrid").dataItem($(e.currentTarget).closest("tr"));
        if (dataItem["sort"] > 0) {
            // set order
            let currentClId = dataItem["clid"];
            let oldSortId = dataItem["sort"];
            let newSortId = dataItem["sort"] - 1;
            let entry = $.grep(dataSource.data(), function (elem) {
                return elem["sort"] === newSortId;
            })[0];
            entry["sort"] = oldSortId;
            entry["dirty"] = true;
            dataItem["sort"] = newSortId;
            dataItem["dirty"] = true;
            $("#syncl_listeditor_grid").data("kendoGrid").setDataSource(dataSource);
        }
    }
    downClick(e) {
        e.preventDefault();
        let dataSource = $("#syncl_listeditor_grid").data("kendoGrid").dataSource;
        let dataItem = $("#syncl_listeditor_grid").data("kendoGrid").dataItem($(e.currentTarget).closest("tr"));
        if (dataItem["sort"] < dataSource.data().length - 1) {
            // set order
            let currentClId = dataItem["clid"];
            let oldSortId = dataItem["sort"];
            let newSortId = dataItem["sort"] + 1;
            let entry = $.grep(dataSource.data(), function (elem) {
                return elem["sort"] === newSortId;
            })[0];
            entry["sort"] = oldSortId;
            entry["dirty"] = true;
            dataItem["sort"] = newSortId;
            dataItem["dirty"] = true;
            $("#syncl_listeditor_grid").data("kendoGrid").setDataSource(dataSource);
        }
    }
    setGridData(listName) {
        let that = this;
        let collection;
        $.each(that.designer.clControlFactory.instance.collections, (idx, list) => {
            if (list.id === listName) {
                $.each(list.data, (entryIdx, entry) => {
                    entry["clid"] = entryIdx;
                    entry["cldataid"] = parseInt(entry["id"]);
                    entry["clorgid"] = parseInt(entry["id"]);
                    entry["_defaultId"] = -1;
                    if (entry["deleted"] && typeof entry["deleted"] === "string") {
                        entry["deleted"] = entry["deleted"].toLowerCase() === "y";
                    }
                    if (entry["deletedwarning"] && typeof entry["deletedwarning"] === "string") {
                        entry["deletedwarning"] = entry["deletedwarning"].toLowerCase() === "y";
                    }
                    if (entry["abstract"] && typeof entry["abstract"] === "string") {
                        entry["abstract"] = entry["abstract"].toLowerCase() === "y";
                    }
                });
                collection = $.extend(true, {}, list);
            }
        });
        let defModel = {
            id: "clid",
            fields: {
                cldataid: { type: "number", editable: true },
                clid: { type: "number", nullable: false, editable: true, validation: { required: true } },
                clorgid: { type: "number", nullable: false, editable: true, validation: { required: true } },
            }
        };
        let defColumns = [
            { field: "clid", title: "clid" },
            { field: "cldataid", title: "id" },
            { field: "clorgid", title: "clorgid" },
        ];
        let fields = {};
        let columns = [];
        let usedColumns = that.designer.clControlFactory.getUsedColumns(listName)["columns"];
        if (collection.columns) {
            $.each(collection.columns, (idx, value) => {
                if (value !== "id") {
                    if (value === "langid" || value === "pid" || value === "sort") {
                        defColumns.push({
                            field: value,
                            title: value,
                            filterable: false,
                            sortable: false,
                        });
                    }
                    else {
                        let headerTemplate = "<div style='width:calc(100% - 1.5em); display:inline-block;'><label>" + value + "</label></div>";
                        if (usedColumns.indexOf(value) === -1 && value !== "deleted" && value !== "deletedwarning" && value !== "abstract") {
                            headerTemplate = headerTemplate + "<i class='columnbutton fa fa-times overlay ' aria-hidden='true' style='background-color:rgba(255,255,255,0.5) width:1.5em' column_name='" + value + "'/>";
                        }
                        if (value === "deleted" || value === "deletedwarning" || value === "abstract")
                            defModel.fields[value] = { type: "boolean" };
                        else {
                            defModel.fields[value] = { type: "string" };
                        }
                        defColumns.push({
                            field: value,
                            title: value,
                            headerTemplate,
                            filterable: false,
                            sortable: false,
                        });
                    }
                }
            });
        }
        defColumns.push({
            template: "<span class='grid_delrow fa fa-times'  style='font-size: 1.5em;'/>",
            title: "&nbsp;",
            width: 24,
        });
        $("#syncl_listeditor_grid").off("click").on("click", ".grid_delrow", function (e) {
            let row = $(this).closest("tr");
            let grid = $("#syncl_listeditor_grid").data("kendoGrid");
            let entry = grid.dataItem(grid.select());
            if (that.checkIfEntryCanBeDeleted(entry["clorgid"]))
                $("#syncl_listeditor_grid").data("kendoGrid").removeRow(row);
            else
                Utilities_1.synUtil.Notifications.error(Utilities_1.synUtil.Strings.getValue("clidisused", "The id {0} is used and cannot be deleted or changed").replace("{0}", entry["cldataid"]));
            e.preventDefault();
        });
        let grid = $("#syncl_listeditor_grid").data("kendoGrid");
        if (grid)
            grid.destroy();
        $("#syncl_listeditor_grid").empty();
        // Check multivalue, pid, sort
        if (collection.columns.findIndex(colName => colName === "langid") !== -1) {
            // is multilang
            $("#cl_designer_listeditor_multilang_cb").prop("checked", true);
            defColumns.push({
                command: { name: "addlangrow", text: Utilities_1.synUtil.Strings.getValue("cllisteditoraddnewlangrowbuttonlabel"), click: that.addNewLangRow },
                title: "&nbsp;",
            });
            defModel.fields["langid"] = { type: "number" };
        }
        else
            $("#cl_designer_listeditor_multilang_cb").prop("checked", false);
        if (collection.columns.findIndex(colName => colName === "pid") !== -1) {
            // is selfref
            $("#cl_designer_listeditor_pid_cb").prop("checked", true);
            defModel.fields["pid"] = { type: "string" };
            if (usedColumns.indexOf("pid") !== -1) {
                $("#cl_designer_listeditor_pid_cb").attr("disabled", "disabled");
            }
        }
        else
            $("#cl_designer_listeditor_pid_cb").prop("checked", false);
        if (collection.columns.findIndex(colName => colName === "sort") !== -1) {
            $("#cl_designer_listeditor_sort_cb").prop("checked", true);
            defColumns.push({
                command: [
                    {
                        name: "up",
                        iconClass: "k-icon k-i-arrow-n",
                        text: "",
                        click: that.upClick
                    },
                    {
                        name: "down",
                        text: "",
                        iconClass: "k-icon k-i-arrow-s",
                        click: that.downClick
                    }
                ],
                title: "&nbsp;",
            });
            defModel.fields["sort"] = { type: "number" };
        }
        else
            $("#cl_designer_listeditor_sort_cb").prop("checked", false);
        $("#cl_designer_listeditor_deleted_cb").prop("checked", collection.columns.indexOf("deleted") !== -1);
        $("#cl_designer_listeditor_deletedwarning_cb").prop("checked", collection.columns.indexOf("deletedwarning") !== -1);
        $("#cl_designer_listeditor_abstract_cb").prop("checked", collection.columns.indexOf("abstract") !== -1);
        that.createGrid(collection.data, defColumns, defModel);
    }
    checkIfEntryCanBeDeleted(id) {
        let canBeDeleted = true;
        let that = this;
        let listName = that.dataSelection.val();
        let fields = that.designer.clControlFactory.Fields();
        $.each(fields, (idx, field) => {
            if (field["dataname"] && field["dataname"] === listName) {
                if (field["multivalue"] && field.value && field.value instanceof Array) {
                    $.each(field.value, (idx, value) => {
                        if (value && parseInt(value) === id)
                            canBeDeleted = false;
                    });
                }
                else {
                    if (field.value && parseInt(field.value) === id)
                        canBeDeleted = false;
                }
            }
        });
        return canBeDeleted;
    }
    CheckCollection() {
        let that = this;
        let text = "";
        let bReturn = true;
        let data = $("#syncl_listeditor_grid").data("kendoGrid").dataSource.data();
        let hasPidColum = true;
        let hasLangIdColumn = true;
        $.each(data, (index, entry) => {
            if (!entry.hasOwnProperty("pid"))
                hasPidColum = false;
            if (!entry.hasOwnProperty("langid"))
                hasLangIdColumn = false;
        });
        let selfref = $("#cl_designer_listeditor_pid_cb").prop("checked") && hasPidColum;
        let multilang = $("#cl_designer_listeditor_multilang_cb").prop("checked") && hasLangIdColumn;
        if (!that.checkIfEntriesAreUnique()) {
            return { check: false, text: Utilities_1.synUtil.Strings.getValue("cllisteditoridsnotunique", "Ids must be unique") };
        }
        if (multilang && data && data.length > 0) {
            $.each(data, (idx, entry) => {
                if (that.isEmpty(entry["langid"])) {
                    bReturn = false;
                    text = Utilities_1.synUtil.Strings.getValue("cllisteditorlangidnull", "langid entries must not be empty");
                }
            });
        }
        // if(selfref && data && data.length > 0){
        //     $.each(data, (idx, entry) => {
        //         if(!entry["pid"]){
        //             bReturn = false;
        //             text = synUtil.Strings.getValue("cllisteditorpidnull", "pid entries must not be empty");
        //         }
        //     });
        //     if(bReturn){
        //         let rootEntries = data.filter(elem => elem["cldataid"] && elem["pid"] && elem["cldataid"] === elem["pid"].toString());
        //         if(rootEntries.length === 0)
        //             return {check: false, text: synUtil.Strings.getValue("cllisteditornorootnode", "A root entry must exist (id === pid)")};
        //         for(let idx = 0; idx < data.length; ++idx){
        //             if(!data[idx]["cldataid"] || !data[idx]["pid"]){
        //                 return data[idx]["cldataid"];
        //             }
        //             let res = that.CheckSelfRefParent(data[idx]["pid"], data[idx]["cldataid"], data, []);
        //             if(!res["check"]){
        //                 bReturn = false;
        //                 text = synUtil.Strings.getValue("clsrentriesarenotvalid", "The entry {0} is not a valid self referencing entry").replace("{0}", res.id);
        //             }
        //         }
        //     }
        // }
        return { check: bReturn, text };
    }
    isEmpty(value) {
        return value == undefined || value == undefined || value === "";
    }
    CheckSelfRefParent(id, parentid, data, usedids) {
        let elem = data.find(elem => elem["cldataid"] === id);
        if (!elem)
            return { check: false, id: parentid };
        if (usedids.indexOf(elem["cldataid"]) !== -1)
            return { check: false, id: parentid };
        else
            usedids.push(elem["cldataid"]);
        if (elem["pid"] === elem["cldataid"])
            return { check: true, id: undefined };
        else
            return this.CheckSelfRefParent(elem["pid"], elem["cldataid"], data, usedids);
    }
    GetInvaldSRId() {
        let that = this;
        if ($("#cl_designer_listeditor_pid_cb").prop("checked")) {
            let data = $("#syncl_listeditor_grid").data("kendoGrid").dataSource.data();
            if (data && data.length > 0) {
                let rootEntries = data.filter(elem => !that.isEmpty(elem["cldataid"]) && !that.isEmpty(elem["pid"]) && elem["cldataid"] === elem["pid"].toString());
                for (let idx = 0; idx < data.length; ++idx) {
                    if (that.isEmpty(data[idx]["cldataid"]) || that.isEmpty(data[idx]["pid"])) {
                        return data[idx]["cldataid"];
                    }
                    if (data[idx]["cldataid"] !== data[idx]["pid"]) {
                        // search for parent
                        let elem = data.find(elem => elem["cldataid"] === data[idx]["pid"]);
                        if (!elem)
                            return data[idx]["cldataid"];
                        if (elem["pid"] === data[idx]["cldataid"])
                            return data[idx]["cldataid"];
                    }
                }
            }
        }
        return undefined;
    }
    checkIfEntriesAreUnique() {
        let areUnique = true;
        // Check if multilang
        let isMultiLang = false;
        $.each($("#syncl_listeditor_grid").data("kendoGrid").columns, (idx, column) => {
            if (column["field"] === "langid")
                isMultiLang = true;
        });
        let gridData = $("#syncl_listeditor_grid").data("kendoGrid").dataSource.data();
        // Check unique id + langid
        $.each(gridData, (idxToCompare1, entryToCompare1) => {
            let entries = $.grep(gridData, function (elem) {
                if (elem["cldataid"] === entryToCompare1["cldataid"]) {
                    if (isMultiLang && (elem["langid"] !== entryToCompare1["langid"]))
                        return false;
                    return true;
                }
                return false;
            });
            if (entries.length > 1) {
                areUnique = false;
            }
        });
        return areUnique;
    }
    createGrid(data, columns, model, sort = false) {
        let that = this;
        $("#syncl_listeditor_grid").kendoGrid({
            dataSource: {
                schema: {
                    model,
                },
                batch: true,
                error(e) {
                    Utilities_1.synUtil.Notifications.error(e.errorThrown);
                }
            },
            navigatable: true,
            resizable: true,
            columns,
            editable: {
                "createAt": "bottom",
            },
            save(e) {
            },
            cancel(e) {
            },
            beforeEdit(e) {
                if (e) {
                }
            },
            edit(e) {
                if (e) {
                    if (e.model.isNew() && !e.model["clid"]) {
                        // set next id
                        let lastid = -1;
                        $.each(e.sender.dataSource.data(), (idx, value) => {
                            if (value["cldataid"] > lastid)
                                lastid = value["cldataid"];
                        });
                        let lastclid = -1;
                        $.each(e.sender.dataSource.data(), (idx, value) => {
                            if (value["clid"] > lastclid)
                                lastclid = value["clid"];
                        });
                        lastid = lastid + 1;
                        lastclid = lastclid + 1;
                        e.model.set("clid", lastclid);
                        e.model.set("cldataid", lastid);
                        e.model.set("_defaultId", -1);
                        e.model.set("clorgid", lastid);
                        if (e.sender.columns.findIndex(column => column.field === "sort") !== -1)
                            e.model.set("sort", lastclid);
                        if (e.sender.columns.findIndex(column => column.field === "abstract") !== -1)
                            e.model.set("abstract", false);
                        if (e.sender.columns.findIndex(column => column.field === "deleted") !== -1)
                            e.model.set("deleted", false);
                        if (e.sender.columns.findIndex(column => column.field === "deletedwarning") !== -1)
                            e.model.set("deletedwarning", true);
                    }
                }
            },
            change(e) {
                if (e) {
                }
            },
            selectable: true,
        });
        if (sort)
            $("#syncl_listeditor_grid").data("kendoGrid").dataSource.sort({ field: "sort", dir: "asc" });
        else
            $("#syncl_listeditor_grid").data("kendoGrid").dataSource.sort({});
        $("#syncl_listeditor_grid").data("kendoGrid").hideColumn("clid");
        $("#syncl_listeditor_grid").data("kendoGrid").hideColumn("clorgid");
        $("#syncl_listeditor_grid").data("kendoGrid").hideColumn("sort");
        let grid = $("#syncl_listeditor_grid").data("kendoGrid");
        let options = grid.getOptions();
        let gridDataSource = grid.dataSource;
        gridDataSource["transport"] = {
            read(options) {
                options.success(data);
            },
            update(options) {
                let res = that.CheckCollection();
                if (!res["check"]) {
                    options.error("", "", res["text"]);
                    return;
                }
                let idCanNotBeDeleted = false;
                let tmpId;
                let tmpStr;
                $.each(options.data.models, (idx, entry) => {
                    if (!that.isEmpty(entry["clorgid"]) && entry["cldataid"] !== entry["clorgid"] && !that.checkIfEntryCanBeDeleted(entry["clorgid"])) {
                        idCanNotBeDeleted = true;
                        tmpId = entry["clorgid"];
                        tmpStr = entry["cldataid"];
                    }
                });
                if (idCanNotBeDeleted) {
                    options.error("", "", Utilities_1.synUtil.Strings.getValue("clidisused", "The is {0} is used and cannot be deleted or changed").replace("{0}", tmpId) + " (" + tmpStr + ")");
                    return;
                }
                let isError = false;
                let collection;
                let listName = $("#syncl_listeditor_grid").attr("cl_designer_listname");
                if (listName) {
                    $.each(that.designer.clControlFactory.instance.collections, (idx, value) => {
                        if (value.id === listName) {
                            // Update entries
                            $.each(options.data.models, (idx1, value1) => {
                                let idToUpdate = value1["clid"];
                                let langIdToUpdate = value1["langid"];
                                let entryUpdated = false;
                                $.each(value.data, (idx2, value2) => {
                                    if (value2["clid"] === idToUpdate) {
                                        entryUpdated = true;
                                        let origId = value.data[idx2]["id"];
                                        value.data[idx2] = {};
                                        value.data[idx2]["id"] = origId;
                                        $.each(value1, (listKey, listValue) => {
                                            if (listKey !== "id" && listKey !== "clorgid" && listKey !== "cldataid") {
                                                value.data[idx2][listKey] = listValue;
                                            }
                                            else if (listKey === "cldataid") {
                                                value.data[idx2]["id"] = listValue;
                                            }
                                        });
                                    }
                                });
                                if (!entryUpdated) {
                                    let newEntry = {};
                                    // Check if multilang
                                    let idxToDelete = -1;
                                    $.each(value1, (newkey, newvalue) => {
                                        if (newkey === "cldataid")
                                            newEntry["id"] = newvalue;
                                        else if (newkey !== "id" && newkey !== "clorgid") {
                                            newEntry[newkey] = newvalue;
                                        }
                                    });
                                    value.data.push(newEntry);
                                }
                            });
                            // Update columns
                            let columns = ["id"];
                            $.each($("#syncl_listeditor_grid").data("kendoGrid").dataSource.options.schema.model.fields, (fieldName, fieldDefinition) => {
                                if (fieldName !== "id" && fieldName !== "clid" && fieldName !== "cldataid" && fieldName !== "clorgid") {
                                    columns.push(fieldName.toString());
                                }
                            });
                            value["columns"] = columns;
                            if (columns.findIndex(colName => colName === "langid") === -1)
                                value["ismultilangft"] = false;
                            else
                                value["ismultilangft"] = true;
                            if (columns.findIndex(colName => colName === "sort") === -1)
                                value["issorted"] = false;
                            else
                                value["issorted"] = true;
                        }
                    });
                }
                that.designer.clControlFactory.updateCollection(listName);
                that.addChangedListForUpdate(listName);
                options.success();
            },
            destroy(options) {
                if (options) {
                    let collection;
                    let listName = $("#syncl_listeditor_grid").attr("cl_designer_listname");
                    if (listName) {
                        $.each(that.designer.clControlFactory.instance.collections, (idx, value) => {
                            if (value.id === listName) {
                                $.each(options.data.models, (idx1, value1) => {
                                    let idToDelete = value1["cldataid"];
                                    // Check if multilang
                                    let idxToDelete = -1;
                                    $.each(value.data, (idx2, value2) => {
                                        if (parseInt(value2["id"]) === idToDelete)
                                            idxToDelete = idx2;
                                    });
                                    if (idxToDelete !== -1)
                                        value.data.splice(idxToDelete, 1);
                                });
                            }
                        });
                        that.designer.clControlFactory.updateCollection(listName);
                        that.addChangedListForUpdate(listName);
                        options.success();
                    }
                    else
                        options.error();
                }
            },
            create(options) {
                let res = that.CheckCollection();
                if (!res["check"]) {
                    options.error("", "", res["text"]);
                    return;
                }
                let collection;
                let listName = $("#syncl_listeditor_grid").attr("cl_designer_listname");
                if (listName) {
                    $.each(that.designer.clControlFactory.instance.collections, (idx, value) => {
                        if (value.id === listName) {
                            $.each(options.data.models, (idx1, value1) => {
                                let idToCreate = value1["cldataid"];
                                let newEntry = {};
                                // Check if multilang
                                let idxToDelete = -1;
                                $.each(value1, (newkey, newvalue) => {
                                    if (newkey === "cldataid")
                                        newEntry["id"] = newvalue;
                                    else if (newkey !== "id" && newkey !== "clorgid") {
                                        newEntry[newkey] = newvalue;
                                    }
                                });
                                value.data.push(newEntry);
                            });
                        }
                    });
                }
                that.designer.clControlFactory.updateCollection(listName);
                that.addChangedListForUpdate(listName);
                options.success();
            },
        };
        gridDataSource.sort({ field: "sort", dir: "asc" });
        grid.setDataSource(gridDataSource);
        $("#syncl_listeditor_grid").on('click', '.columnbutton', function (e) {
            let grid = $("#syncl_listeditor_grid").data("kendoGrid");
            let columnname = $(this).attr("column_name");
            let listName = $("#syncl_listeditor_grid").attr("cl_designer_listname");
            let result = that.designer.clControlFactory.getUsedColumns(listName);
            if (result["columns"].indexOf(columnname) !== -1) {
                Utilities_1.synUtil.Notifications.error("This column can not be deleted");
            }
            else {
                let gridOptions = grid.getOptions();
                let delColIdx = -1;
                $.each(gridOptions.columns, (idx, value) => {
                    if (value.field === columnname)
                        delColIdx = idx;
                });
                if (delColIdx !== -1) {
                    gridOptions.columns.splice(delColIdx, 1);
                    let gridDataSource = grid.dataSource;
                    $.each(gridDataSource.data(), (idx, value) => {
                        delete value[columnname];
                        value["dirty"] = true;
                    });
                    delete gridDataSource.options.schema.model.fields[columnname];
                    let oldData = gridDataSource.data();
                    let model = gridDataSource.options.schema.model;
                    let columns = gridOptions.columns;
                    grid.destroy();
                    $("#syncl_listeditor_grid").empty();
                    that.createGrid(oldData, columns, model);
                }
            }
            e.preventDefault();
        });
    }
}
class PropertyLabelContainer extends PropertyBaseItem {
    constructor(propertyId, propertyName, mandatory, designer, staticText) {
        super(designer, propertyId, propertyName, undefined, mandatory);
        this.labelItems = [];
        this.staticText = staticText;
        if (propertyId === "label" || propertyId === "staticlabel") {
            this.propName = "labels";
            this.isLabel = true;
        }
        else if (propertyId === "helplabel") {
            this.propName = "helplabels";
            this.isLabel = false;
        }
    }
    init(jQueryElem) {
        super.init(jQueryElem);
        let that = this;
        that.defLangTextArea = $("<textarea  id='" + this.controlId + "_deflanginput' style='width:calc(100% - 1.5em);box-sizing:border-box;' class='cltextarea k-textbox' maxlength='10000' rows='3'/>").appendTo(this.controlcontainer);
        this.addLangButton = $("<i id='" + this.controlId + "_addlangbutton' class='clbuttoncontainer fa fa-plus' aria-hidden='true' style='box-sizing:border-box;width:1em'></i>").appendTo(this.controlcontainer);
        let additionalLabelsContainer = $("<div id='" + this.controlId + "_additionallangcontainer' style='width:100%;' />").appendTo(this.controlcontainer);
        this.addLangButton.on("click", (e) => {
            let newLabelItem = new PropertyLabelItem(that.selectedItems, undefined, undefined, that.getAvailableLangIds(), that, that.propName);
            newLabelItem.init($("#" + that.controlId + "_additionallangcontainer"));
            that.labelItems.push(newLabelItem);
            that.checkButtonVisibilty();
            that.updateLabelItemsDataSource();
        });
        this.addLangButton.hide();
        that.defLangTextArea.on("input", function (e) {
            let text = that.defLangTextArea.val();
            if (text != undefined)
                text = text.replace(new RegExp('\r?\n', 'g'), '  \n');
            that.inputChanged(text);
        });
        this.setVisibility(false);
    }
    inputChanged(value) {
        let that = this;
        if (!(!value && that.diffValue)) { // Hack for IE, change event is triggered when placeholder is set
            this.defLangTextArea.removeAttr("placeholder");
            let defLangId = $("#cl_designer_deflangdropdown").data("kendoDropDownList").value();
            let defLangIdSet = false;
            if (!that.item[that.propName])
                that.item[that.propName] = [];
            let deflanglabels = $.grep(that.item[that.propName], function (label) {
                return label["langid"] === defLangId;
            });
            if (deflanglabels && deflanglabels.length > 0) {
                $.each(deflanglabels, (idx, label) => {
                    label["text"] = value;
                });
            }
            else {
                that.item[that.propName].push({ langid: defLangId, text: value });
            }
            $.each(that.selectedItems, (idx, item) => {
                if (!item[that.propName])
                    item[that.propName] = [];
                let deflanglabels = $.grep(item[that.propName], function (label) {
                    return label["langid"] === defLangId;
                });
                if (deflanglabels && deflanglabels.length > 0) {
                    $.each(deflanglabels, (idx, label) => {
                        label["text"] = value;
                    });
                }
                else {
                    item[that.propName].push({ langid: defLangId, text: value });
                }
                let control = that.designer.clControlFactory.getFieldControl(item["id"]);
                if (control instanceof ChecklistControls_1.ClPage || control instanceof ChecklistControls_1.ClGroup || control instanceof ChecklistControls_1.ClFieldControl) {
                    let callback = function () {
                        if (!that.isLabel)
                            that.designer.setHelpToolbarItem();
                        that.notifyChange();
                    };
                    if (!that.isLabel) {
                        control.resetHelpLabel(callback);
                    }
                    else
                        control.resetLabel(callback);
                    that.designer.clControlFactory.updateControl(item.id, control);
                }
            });
        }
    }
    highlightMandatory() {
        let highLight = false;
        if (this.mandatory && (this.item["type"] === "field" || this.item["type"] === "page")) {
            if (!this.defLangTextArea.val() && this.isLabel)
                highLight = true;
        }
        if (highLight)
            $("#" + this.controlId + "_container").addClass("clMandatoryProperty");
        else
            $("#" + this.controlId + "_container").removeClass("clMandatoryProperty");
    }
    setVisibility(visible) {
        if (visible)
            $("#" + this.controlId + "_container").show();
        else
            $("#" + this.controlId + "_container").hide();
    }
    updateLabelItemsDataSource() {
        let availableLangIds = this.getAvailableLangIds();
        $.each(this.labelItems, (idx, value) => {
            if (!value.langid) {
                value.updateLangIdList(availableLangIds);
            }
            else {
                if (availableLangIds.length === 0) {
                    let index = this.designer.allLangIds.findIndex(item => item["id"] === value.langid);
                    if (index !== -1) {
                        let langIds = [];
                        langIds.push(this.designer.allLangIds[index]);
                        value.updateLangIdList(langIds);
                    }
                }
                else {
                    let index = this.designer.allLangIds.findIndex(item => item["id"] === value.langid);
                    if (index !== -1) {
                        availableLangIds.splice(0, 0, this.designer.allLangIds[index]);
                        value.updateLangIdList(availableLangIds);
                    }
                }
            }
        });
    }
    setItem(item, selectedItems, diffValue, diffProperties) {
        super.setItem(item, selectedItems, diffValue, diffProperties);
        this.defLangTextArea.val("");
        this.defLangTextArea.show();
        $.each(this.labelItems, (idx, value) => {
            $("#" + value.containerId).remove();
        });
        this.labelItems.splice(0, this.labelItems.length);
        this.setLabels();
        if (diffValue) {
            this.defLangTextArea.attr("placeholder", Utilities_1.synUtil.Strings.getValue("cldiffpropertylabel"));
        }
        else {
            this.defLangTextArea.removeAttr("placeholder");
        }
        this.checkButtonVisibilty();
        this.highlightMandatory();
        this.updatePropertyColor();
    }
    notifyChange() {
        super.notifyChange();
        this.checkButtonVisibilty();
    }
    deleteLabelItem(labelItem) {
        let that = this;
        if (labelItem.langid) {
            let labelIdx = -1;
            labelIdx = this.item[that.propName].findIndex(label => label["langid"] === labelItem.langid);
            if (labelIdx !== -1)
                this.item[that.propName].splice(labelIdx, 1);
            $.each(this.selectedItems, (idx, item) => {
                let labelIdx = -1;
                labelIdx = item[that.propName].findIndex(label => label["langid"] === labelItem.langid);
                if (labelIdx !== -1)
                    item[that.propName].splice(labelIdx, 1);
            });
        }
        let indexToDel = this.labelItems.findIndex((elem) => { return elem === labelItem; });
        if (indexToDel !== -1) {
            $.each(this.labelItems.splice(indexToDel, 1), (idx, value) => {
                $("#" + value.containerId).remove();
            });
            this.checkButtonVisibilty();
        }
        this.updateLabelItemsDataSource();
    }
    getAvailableLangIds() {
        let availableLangid = [];
        let defLangId = $("#cl_designer_deflangdropdown").data("kendoDropDownList").value();
        $.each(this.designer.allLangIds, (idx, value) => {
            if (value["id"] !== defLangId) {
                let langIdIsUsed = false;
                $.each(this.labelItems, (idx1, value1) => {
                    if (value["id"] === value1["langid"])
                        langIdIsUsed = true;
                });
                if (!langIdIsUsed)
                    availableLangid.push(value);
            }
        });
        return availableLangid;
    }
    checkButtonVisibilty() {
        let availableLangids = this.getAvailableLangIds();
        let unsetLabels = $.grep(this.labelItems, function (item) {
            if (item.langid)
                return false;
            else
                return true;
        });
        if (availableLangids.length > 0 && availableLangids.length > unsetLabels.length)
            this.addLangButton.show();
        else
            this.addLangButton.hide();
    }
    setLabels() {
        let that = this;
        let defLangId = $("#cl_designer_deflangdropdown").data("kendoDropDownList").value();
        // get deflangid
        if (that.item[that.propName] != undefined && that.item[that.propName].length > 0) {
            let defLabel;
            $.each(that.item[that.propName], (idx, value) => {
                if (value.langid === defLangId)
                    defLabel = value.text;
            });
            let text = defLabel;
            that.defLangTextArea.val(text);
            $.each(that.item[that.propName], (idx, value) => {
                let availableLangIds = [];
                $.each(that.designer.allLangIds, (idx, language) => {
                    if (language["id"] !== defLangId) {
                        if (!that.item[that.propName] || that.item[that.propName].findIndex(label => label.langid === language["id"]) === -1)
                            availableLangIds.push(language);
                    }
                });
                if (value.langid !== defLangId) {
                    // add additonallanguage
                    if (availableLangIds.findIndex(label => label.langid === value.langid) === -1)
                        availableLangIds.push($.grep(that.designer.allLangIds, (entry) => entry["id"] === value.langid)[0]);
                    let newLabelItem = new PropertyLabelItem(that.selectedItems, value.langid, value.text, availableLangIds, that, that.propName);
                    newLabelItem.init($("#" + that.controlId + "_additionallangcontainer"));
                    that.labelItems.push(newLabelItem);
                    that.checkButtonVisibilty();
                }
            });
        }
    }
}
class PropertyLabelItem {
    constructor(items, langid, label, alllangIds, parent, propName) {
        this.items = items;
        this.langid = langid;
        this.label = label;
        this.allLangIds = alllangIds;
        this.parent = parent;
        this.containerId = "cl_designer_property_" + Utilities_1.synUtil.getGUID();
        this.propName = propName;
    }
    init(jQueryElem) {
        let that = this;
        let labelContainer = $("<div id='" + this.containerId + "' style='width:100%;'/>").appendTo(jQueryElem);
        that.langidCmbBx = $("<input style='width:40%; box-sizing:border-box;'/>").appendTo(labelContainer);
        if (that.parent.staticText)
            that.labelInput = $("<textarea style='width:calc(60% - 1.5em);  box-sizing:border-box;' class='cltextarea k-textbox' maxlength='10000' rows='3'/>").appendTo(labelContainer);
        else
            that.labelInput = $("<input type='text' style='width:calc(60% - 1.5em);  box-sizing:border-box;' class='clInput k-textbox' maxlength='10000'/>").appendTo(labelContainer);
        let delButton = $("<i class='clbuttoncontainer fa fa-times' aria-hidden='true' style='box-sizing:border-box;width:1em;'></i>").appendTo(labelContainer);
        let onDropDownChanged = function () {
            let dropDown = that.langidCmbBx.data("kendoDropDownList");
            if (dropDown.dataItem() !== -1) {
                that.langid = dropDown.value();
                that.parent.updateLabelItemsDataSource();
            }
        };
        that.langidCmbBx.kendoDropDownList({
            dataTextField: "name",
            dataValueField: "id",
            noDataTemplate: kendo.htmlEncode(Utilities_1.synUtil.Strings.getValue("dynpnomatchingitemfound")),
            dataSource: this.allLangIds,
            change: onDropDownChanged,
            select: onDropDownChanged,
        });
        that.labelInput.on("input", function () {
            $.each(that.items, (idx, item) => {
                if (!item[that.propName])
                    item[that.propName] = [];
                let langlabels = $.grep(item[that.propName], function (label) {
                    return label["langid"] === that.langid;
                });
                if (langlabels && langlabels.length > 0) {
                    $.each(langlabels, (idx, label) => {
                        label["text"] = that.labelInput.val();
                    });
                }
                else {
                    item[that.propName].push({ langid: that.langid, text: that.labelInput.val() });
                }
            });
        });
        if (this.langid) {
            that.langidCmbBx.data("kendoDropDownList").value(this.langid);
        }
        if (this.label)
            that.labelInput.val(this.label);
        delButton.on("click", function (e) {
            that.parent.deleteLabelItem(that);
        });
        if (!this.langid && that.allLangIds.length > 0) {
            that.langidCmbBx.data("kendoDropDownList").value(this.allLangIds[0].id);
            that.langid = this.allLangIds[0].id;
        }
    }
    updateLangIdList(newLangIds) {
        this.langidCmbBx.data("kendoDropDownList").setDataSource(new kendo.data.DataSource({ data: newLangIds }));
    }
}
class PropertyItem extends PropertyBaseItem {
    constructor(designer, propertyId, propertyName, mandatory, controlType, dataType, listValuesI, methodToExecute, minvalue, maxvalue, buttonLabel) {
        super(designer, propertyId, propertyName, controlType, mandatory);
        this.dataType = dataType;
        this.listValues = listValuesI;
        this.method = methodToExecute;
        this.maxValue = 2147483647, this.minValue = -2147483648;
        if (dataType === "Foat") {
            this.maxValue = 3.40282e+038;
            this.minValue = -3.40282e+038;
        }
        if (minvalue != undefined && minvalue != undefined)
            this.minValue = minvalue;
        if (maxvalue != undefined && maxvalue != undefined)
            this.maxValue = maxvalue;
        this.buttonLabel = buttonLabel;
    }
    init(jQueryElem) {
        super.init(jQueryElem);
        let that = this;
        if (this.controlType === "Input") {
            let control = $("<input id='" + this.controlId + "' type='" + this.dataType + "' style='box-sizing:border-box;' maxlength='10000' />").appendTo(that.controlcontainer);
            if (this.dataType === "number") {
                control.addClass("clInput");
                control.kendoNumericTextBox({
                    decimals: 0,
                    format: "n0",
                    culture: this.designer.clControlFactory.userCulture,
                    downArrowText: "",
                    upArrowText: "",
                    spin(e) {
                        e.sender.element.parent().children("input.k-input").removeAttr("placeholder");
                        let oldValue = that.item[that.propertyId];
                        that.item[that.propertyId] = $("#" + that.controlId).data("kendoNumericTextBox").value();
                        $.each(that.selectedItems, (idx, item) => {
                            item[that.propertyId] = $("#" + that.controlId).data("kendoNumericTextBox").value();
                            that.designer.updateControl(item, that.propertyId, oldValue);
                        });
                        that.notifyChange();
                    },
                    change: (e) => {
                        e.sender.element.parent().children("input.k-input").removeAttr("placeholder");
                        let oldValue = that.item[that.propertyId];
                        e.sender.element.parent().children("input.k-input").removeAttr("title");
                        that.item[that.propertyId] = $("#" + that.controlId).data("kendoNumericTextBox").value();
                        $.each(that.selectedItems, (idx, item) => {
                            item[that.propertyId] = $("#" + that.controlId).data("kendoNumericTextBox").value();
                            that.designer.updateControl(item, that.propertyId, oldValue);
                        });
                        that.notifyChange();
                    },
                    min: this.minValue,
                    max: this.maxValue,
                }).data("kendoNumericTextBox");
                control.removeAttr("title");
                control.parent().children("input.k-input").removeAttr("title");
            }
            else if (this.dataType === "color") {
                control.kendoColorPicker({
                    buttons: false,
                    opacity: true,
                    change: (e) => {
                        let oldValue = that.item[that.propertyId];
                        that.item[that.propertyId] = $("#" + that.controlId).data("kendoColorPicker").value();
                        $.each(that.selectedItems, (idx, item) => {
                            item[that.propertyId] = $("#" + that.controlId).data("kendoColorPicker").value();
                            that.designer.updateControl(item, that.propertyId, oldValue);
                        });
                        that.notifyChange();
                    },
                });
            }
            else {
                if (this.dataType === "text") {
                    control.addClass("clInput k-textbox");
                    control.on("input", function (e) {
                        control.removeAttr("placeholder");
                        let updateValue = true;
                        if (that.propertyId === "externalid") {
                            let value = control.val().toString();
                            if (value.match(/[^a-zA-Z0-9$]/g))
                                control.val(value.replace(/[^a-zA-Z0-9$]/g, ""));
                            updateValue = that.designer.clControlFactory.checkIfExternalIdIsUnique($("#" + that.controlId).val(), that.item["id"]);
                        }
                        let oldValue = that.item[that.propertyId];
                        that.item[that.propertyId] = $("#" + that.controlId).val();
                        $.each(that.selectedItems, (idx, item) => {
                            item[that.propertyId] = $("#" + that.controlId).val();
                            if (updateValue) {
                                control.removeClass("clInvalid");
                                that.designer.updateControl(item, that.propertyId, oldValue);
                            }
                            else {
                                // rot markieren
                                control.addClass("clInvalid");
                            }
                        });
                        that.notifyChange();
                    });
                    control.on("focusout", function (e) {
                        if (that.propertyId === "externalid") {
                            if (that.controlId && that.item) {
                                if (!that.designer.clControlFactory.checkIfExternalIdIsUnique($("#" + that.controlId).val(), that.item["id"])) {
                                    $.each(that.selectedItems, (idx, item) => {
                                        item[that.propertyId] = Utilities_1.synUtil.getGUID(true);
                                        that.setValue(item[that.propertyId], false);
                                        $("#" + that.controlId).removeClass("clInvalid");
                                    });
                                }
                            }
                        }
                    });
                }
                else if (this.dataType === "number") {
                    control.change((event) => {
                        if (that.item) {
                            control.removeAttr("placeholder");
                            let oldValue = that.item[that.propertyId];
                            that.item[that.propertyId] = $("#" + that.controlId).prop("checked");
                            $.each(that.selectedItems, (idx, item) => {
                                item[that.propertyId] = $("#" + that.controlId).val();
                                that.designer.updateControl(item, that.propertyId, oldValue);
                            });
                        }
                        that.notifyChange();
                    });
                }
                else if (this.dataType === "checkbox") {
                    control.on("click", function () {
                        if (that.item) {
                            control.removeAttr("placeholder");
                            let oldValue = that.item[that.propertyId];
                            let newValue = $("#" + that.controlId).prop("checked");
                            that.item[that.propertyId] = newValue;
                            $.each(that.selectedItems, (idx, item) => {
                                item[that.propertyId] = newValue;
                                that.designer.updateControl(item, that.propertyId, oldValue);
                            });
                            if (that.propertyId === "multivalue") {
                                if (that.linkedFieldSelected) {
                                    $.each(that.selectedItems, (idx, item) => {
                                        if (item["linkedfield"]) {
                                            let linkedFields = that.designer.clControlFactory.GetLinkedFields(item["linkedfield"]);
                                            $.each(linkedFields, (idx, value) => {
                                                if (value["id"] !== item["id"]) {
                                                    value[that.propertyId] = newValue;
                                                    that.designer.updateControl(value, that.propertyId, oldValue);
                                                }
                                            });
                                        }
                                    });
                                }
                                that.designer.updateProperties(that.selectedItems, true);
                            }
                        }
                        that.notifyChange();
                    });
                }
            }
        }
        else if (this.controlType === "Combobox") {
            let control = $("<input id='" + this.controlId + "' style='width:100%;' class='clInput'/>").appendTo(that.controlcontainer);
            control.kendoComboBox({
                dataTextField: "name",
                dataValueField: "id",
                dataSource: { data: that.listValues },
                filter: "contains",
                noDataTemplate: kendo.htmlEncode(Utilities_1.synUtil.Strings.getValue("dynpnomatchingitemfound")),
                change(e) {
                    if (e.sender.dataItem()) {
                        let oldValue = that.item[that.propertyId];
                        let newValue = e.sender.value();
                        e.sender.input.removeAttr("placeholder");
                        that.item[that.propertyId] = newValue;
                        if (that.propertyId === "typedefinition") {
                            let parts = newValue.split("|");
                            that.item["type"] = parts[0];
                            that.item["datatype"] = parts[1];
                            that.item["controltype"] = parts[2];
                            if (that.item["controltype"] === "List") {
                                if (that.item["multivalue"])
                                    that.item["controltype"] = "Checkbox";
                                else
                                    that.item["controltype"] = "Radiobutton";
                            }
                        }
                        $.each(that.selectedItems, (idx, item) => {
                            item[that.propertyId] = newValue;
                            if (that.propertyId === "typedefinition") {
                                let parts = newValue.split("|");
                                item["type"] = parts[0];
                                item["datatype"] = parts[1];
                                item["controltype"] = parts[2];
                                if (item["controltype"] === "List") {
                                    if (item["multivalue"])
                                        item["controltype"] = "Checkbox";
                                    else
                                        item["controltype"] = "Radiobutton";
                                }
                            }
                            that.designer.updateControl(item, that.propertyId, oldValue);
                        });
                        that.notifyChange();
                        if (that.propertyId === "typedefinition")
                            that.designer.updateProperties(that.selectedItems, true, true);
                    }
                },
            });
        }
        else if (this.controlType === "Checkbox") {
            let checkBoxContainer = $("<div id='" + this.controlId + "_container' class='checkboxcontainer'/>").appendTo(that.controlcontainer);
            for (let index = 0; index < that.listValues.length; ++index) {
                let guid = Utilities_1.synUtil.getGUID(true);
                let container = $("<div style='overflow-wrap: break-word;vertical-align:middle;' />").appendTo(checkBoxContainer);
                let checkBox = $("<input id='" + this.controlId + "_" + guid + "' type='checkbox' name='" + this.controlId + "' value='" + that.listValues[index].id + "' class='clListItem' >").appendTo(container);
                let label = $("<label id='" + this.controlId + "_" + guid + "_label' style='overflow-wrap: break-word;display:inline-block;vertical-align:middle;'></label>").appendTo(container);
                label.text(that.listValues[index].name);
                label.css("width", "calc(100% - 2em )");
                checkBox.change(() => {
                    let value = 0;
                    let oldValue = that.item[that.propertyId];
                    $("input[name='" + this.controlId + "']:checked").each(function () {
                        value += parseInt($(this).val().toString());
                    });
                    $.each(that.selectedItems, (idx, item) => {
                        item[that.propertyId] = value;
                        that.designer.updateControl(item, that.propertyId, oldValue);
                    });
                    that.notifyChange();
                });
            }
        }
        else if (this.controlType === "Button") {
            let button = $("<button id='" + this.controlId + "' class='btn btn-primary' style='min-width: 80px;'>" + this.buttonLabel + "</button>").appendTo(that.controlcontainer);
            button.on("click", function () {
                if (that.method) {
                    $.each(that.selectedItems, (idx, item) => {
                        that.method(that.designer.clControlFactory, item);
                    });
                    that.notifyChange();
                }
            });
        }
        this.setVisibility(false);
    }
    setValue(value, diffValue) {
        if (this.controlType === "Input") {
            if (this.dataType === "checkbox") {
                let checkbox = $("#" + this.controlId);
                if (value === true) {
                    checkbox.attr("data-hasvalue", "true").prop("checked", true);
                }
                else if (value === false) {
                    checkbox.prop("checked", false);
                }
                else {
                    checkbox.removeAttr("data-hasvalue").removeAttr("checked");
                }
            }
            else if (this.dataType === "number") {
                $("#" + this.controlId).data("kendoNumericTextBox").value(value);
                $("#" + this.controlId).parent().children("input.k-input").removeAttr("title");
                if (diffValue)
                    $("#" + this.controlId).data("kendoNumericTextBox").element.parent().children("input.k-input").attr("placeholder", Utilities_1.synUtil.Strings.getValue("cldiffpropertylabel"));
                else
                    $("#" + this.controlId).data("kendoNumericTextBox").element.parent().children("input.k-input").removeAttr("placeholder");
            }
            else if (this.dataType === "color") {
                if (!value)
                    value = "rgba(255, 255, 255, 1)";
                $("#" + this.controlId).data("kendoColorPicker").value(value);
            }
            else {
                if (diffValue)
                    $("#" + this.controlId).attr("placeholder", Utilities_1.synUtil.Strings.getValue("cldiffpropertylabel"));
                else
                    $("#" + this.controlId).removeAttr("placeholder");
                $("#" + this.controlId).val(value);
            }
        }
        else if (this.controlType === "Combobox") {
            if (value && typeof value === 'string' || value instanceof String)
                $("#" + this.controlId).data("kendoComboBox").value(value.toString());
            else
                $("#" + this.controlId).data("kendoComboBox").value("");
            if (diffValue)
                $("#" + this.controlId).data("kendoComboBox").input.attr("placeholder", Utilities_1.synUtil.Strings.getValue("cldiffpropertylabel"));
            else
                $("#" + this.controlId).data("kendoComboBox").input.removeAttr("placeholder");
        }
        else if (this.controlType === "Checkbox") {
            $("input[name=" + this.controlId + "]").removeProp("checked");
            for (let i = 0; i < this.listValues.length; i++) {
                let tmpId = this.listValues[i].id;
                if ((value & tmpId) === tmpId)
                    $("input[name=" + this.controlId + "][value=" + tmpId.toString() + "]").prop("checked", "checked");
            }
        }
    }
    getValue() {
        let elem = $("#" + this.controlId);
        if (this.controlType === "Input") {
            if (this.dataType === "checkbox") {
                if (elem.attr("data-hasvalue") === "true") {
                    let res = elem.prop("checked");
                    return res;
                }
            }
            else if (this.dataType === "number") {
                let value = $("#" + this.controlId).data("kendoNumericTextBox").value();
                if (value)
                    return value;
            }
            else {
                if (elem.val())
                    return elem.val();
            }
        }
        else if (this.controlType === "Combobox") {
            if (elem.data("kendoComboBox").value())
                return elem.data("kendoComboBox").value();
        }
        else if (this.controlType === "Checkbox") {
            let value = 0;
            $("input[name='" + this.controlId + "']:checked").each(function () {
                value += parseInt($(this).val().toString());
            });
            return value;
        }
        return undefined;
    }
    setItem(item, selectedItems, diffValue, diffProperties) {
        super.setItem(item, selectedItems, diffValue, diffProperties);
        let that = this;
        // update old value if invalid
        if (this.item && this.propertyId === "externalid") {
            if (!this.designer.clControlFactory.checkIfExternalIdIsUnique(this.item[this.propertyId], this.item["id"]))
                this.item[this.propertyId] = Utilities_1.synUtil.getGUID(true);
        }
        this.selectedItems = selectedItems;
        this.item = item;
        if (this.controlType === "Input" || this.controlType === "Combobox" || this.controlType === "Checkbox") {
            $("#" + this.controlId).prop("indeterminate", false);
            if (this.dataType === "number") {
                $("#" + this.controlId).parent().children("input.k-input").removeAttr("title");
                if (this.propertyId === "min" || this.propertyId === "max") {
                    $("#" + this.controlId).data("kendoNumericTextBox").setOptions({
                        decimals: this.item["steps"],
                        format: "n" + this.item["steps"].toString(),
                    });
                }
            }
            this.setValue(this.item[this.propertyId], diffValue);
            if (this.propertyId === "externalid") {
                if (this.designer.clControlFactory.checkIfExternalIdIsUnique(this.item[this.propertyId], this.item["id"]))
                    $("#" + this.controlId).removeClass("clInvalid");
                else
                    $("#" + this.controlId).addClass("clInvalid");
            }
            else if (this.propertyId === "typedefinition") {
                //
                let controlTypes = this.designer.getAvailableControlTypes(this.item, this.selectedItems);
                let controlTypesData = [];
                if (controlTypes.length === 0) {
                    if (that.item["typedefinition"]) {
                        let entry = { "id": that.item["typedefinition"], "name": that.designer.getTypeDefinitionLabel(that.item["typedefinition"]) };
                        controlTypesData.push(entry);
                    }
                    $("#" + this.controlId).data("kendoComboBox").input.closest(".k-input").addClass("clReadOnly");
                    $("#" + this.controlId).data("kendoComboBox").enable(false);
                }
                else {
                    $.each(controlTypes, (idx, controlType) => {
                        let entry = { "id": controlType, "name": that.designer.getTypeDefinitionLabel(controlType) };
                        controlTypesData.push(entry);
                    });
                    //Enable
                    $("#" + this.controlId).data("kendoComboBox").enable(true);
                    $("#" + this.controlId).data("kendoComboBox").input.closest(".k-input").removeClass("clReadOnly");
                }
                $("#" + this.controlId).data("kendoComboBox").setDataSource(new kendo.data.DataSource({ data: controlTypesData }));
            }
            if (diffValue) {
                $("#" + this.controlId).prop("indeterminate", true);
            }
        }
        this.highlightMandatory();
        this.updatePropertyColor();
    }
    setVisibility(visible, enabled = true, readonly = false) {
        if (visible)
            $("#" + this.controlId + "_container").show();
        else
            $("#" + this.controlId + "_container").hide();
        if (this.controlType === "Button") {
            $("#" + this.controlId).prop("disabled", readonly);
        }
        else {
            if (this.dataType === "checkbox") {
                if (readonly || !enabled)
                    $("#" + this.controlId).attr("disabled", "disabled");
                else
                    $("#" + this.controlId).removeAttr("disabled");
            }
            else {
                if (readonly || !enabled) {
                    $("#" + this.controlId).addClass("clReadOnly");
                    $("#" + this.controlId).attr("readonly", "readonly");
                    if (this.controlType === "Combobox") {
                        if (!enabled)
                            $("#" + this.controlId).data("kendoComboBox").enable(false);
                        $("#" + this.controlId).data("kendoComboBox").input.closest(".k-input.clInput").attr("readonly", "readonly");
                        $("#" + this.controlId).data("kendoComboBox").input.closest(".k-input").addClass("clReadOnly");
                    }
                }
                else {
                    $("#" + this.controlId).removeClass("clReadOnly");
                    $("#" + this.controlId).removeAttr("readonly");
                    if (this.controlType === "Combobox") {
                        $("#" + this.controlId).data("kendoComboBox").enable(true);
                        $("#" + this.controlId).data("kendoComboBox").input.closest(".k-input.clInput").removeAttr("readonly");
                        $("#" + this.controlId).data("kendoComboBox").input.closest(".k-input").removeClass("clReadOnly");
                    }
                }
            }
        }
        if (this.linkedFieldSelected && !this.parentLinkedFieldSelected) {
            if (this.propertyId === "multivalue" || this.propertyId === "mandatory") {
                $("#" + this.controlId).attr("disabled", "disabled");
            }
        }
    }
    highlightMandatory() {
        if (this.mandatory && this.getValue() == undefined)
            $("#" + this.controlId + "_container").addClass("clMandatoryProperty");
        else
            $("#" + this.controlId + "_container").removeClass("clMandatoryProperty");
    }
}
class PropertyLinkedFieldItem extends PropertyBaseItem {
    constructor(designer, propertyId, propertyName, mandatory) {
        super(designer, propertyId, propertyName, undefined, mandatory);
    }
    init(jQueryElem) {
        super.init(jQueryElem);
        let that = this;
        let control = $("<input id='" + this.controlId + "' style='width:100%;' class='clInput'/>").appendTo(that.controlcontainer);
        control.kendoComboBox({
            dataTextField: "name",
            dataValueField: "id",
            filter: "contains",
            noDataTemplate: kendo.htmlEncode(Utilities_1.synUtil.Strings.getValue("dynpnomatchingitemfound")),
            change(e) {
                let newValue = e.sender.value();
                if (e.sender.dataItem() || !newValue) {
                    let oldValue = that.item[that.propertyId];
                    let parentField;
                    e.sender.input.removeAttr("placeholder");
                    if (that.item[that.propertyId] !== newValue) {
                        if (e.sender.dataItem()) {
                            that.item[that.propertyId] = newValue;
                            parentField = that.designer.clControlFactory.getFieldById(newValue, that.designer.clControlFactory.instance.layout);
                        }
                        else
                            that.item[that.propertyId] = undefined;
                        if (parentField) {
                            that.item["multivalue"] = parentField["multivalue"];
                            that.item["dataname"] = parentField["dataname"];
                            that.item["isselfrefft"] = parentField["isselfrefft"];
                            that.item["ftsort"] = parentField["ftsort"];
                            that.item["dependentfield"] = parentField["dependentfield"];
                            if (!parentField["linkedfield"])
                                parentField["linkedfield"] = parentField["id"];
                        }
                        let updateCallback = function () {
                            if (!parentField) {
                                // check if linkedfields exist
                                let linkedFields = that.designer.clControlFactory.GetLinkedFields(oldValue);
                                if (linkedFields && linkedFields.length === 1 && linkedFields[0]["id"] === oldValue) {
                                    linkedFields[0]["linkedfield"] = undefined;
                                }
                            }
                            that.designer.clControlFactory.setRelationBetweenFields();
                            that.notifyChange();
                            that.designer.updateProperties(that.selectedItems, true);
                        };
                        if (that.selectedItems.length > 0) {
                            $.each(that.selectedItems, (idx, item) => {
                                if (item[that.propertyId] !== newValue) {
                                    if (e.sender.dataItem())
                                        item[that.propertyId] = newValue;
                                    else
                                        item[that.propertyId] = undefined;
                                    let callback = function () {
                                        if (item["controltype"] === "List" || item["controltype"] === "Checkbox" || item["controltype"] === "Radiobutton") {
                                            if (item["multivalue"])
                                                item["controltype"] = "Checkbox";
                                            else
                                                item["controltype"] = "Radiobutton";
                                        }
                                        that.designer.updateControl(item, that.propertyId, oldValue);
                                        if (idx === that.selectedItems.length - 1)
                                            updateCallback();
                                    };
                                    if (parentField) {
                                        item["multivalue"] = parentField["multivalue"];
                                        item["isselfrefft"] = parentField["isselfrefft"];
                                        item["dataname"] = parentField["dataname"];
                                        item["ftsort"] = parentField["ftsort"];
                                        item["value"] = parentField["value"];
                                        item["dependentfield"] = parentField["dependentfield"];
                                        item["mandatory"] = false;
                                        that.designer.updateLocalCollectionColumnsForLinkedField(item["dataname"], item["datafield"], callback);
                                    }
                                    else
                                        callback();
                                }
                                else {
                                    if (idx === that.selectedItems.length - 1)
                                        updateCallback();
                                }
                            });
                        }
                        else
                            updateCallback();
                    }
                }
            },
        });
        this.setVisibility(false);
    }
    setValue(value, diffValue) {
        if (value && typeof value === 'string' || value instanceof String)
            $("#" + this.controlId).data("kendoComboBox").value(value.toString());
        else
            $("#" + this.controlId).data("kendoComboBox").value("");
        if (diffValue)
            $("#" + this.controlId).data("kendoComboBox").input.attr("placeholder", Utilities_1.synUtil.Strings.getValue("cldiffpropertylabel"));
        else
            $("#" + this.controlId).data("kendoComboBox").input.removeAttr("placeholder");
    }
    getValue() {
    }
    setItem(item, selectedItems, diffValue, diffProperties) {
        super.setItem(item, selectedItems, diffValue, diffProperties);
        let that = this;
        $("#" + this.controlId).prop("indeterminate", false);
        // Check if one of the selected fields is already parentfield. If it is disable property
        let parentSelected = false;
        $.each(selectedItems, (idx, selItem) => {
            if (selItem["linkedfield"] && (selItem["linkedfield"] === selItem["id"]))
                parentSelected = true;
        });
        if (parentSelected) {
            $("#" + this.controlId).data("kendoComboBox").enable(false);
            $("#" + this.controlId).data("kendoComboBox").input.closest(".k-input").addClass("clReadOnly");
            this.setValue(undefined, diffValue);
        }
        else {
            $("#" + this.controlId).data("kendoComboBox").enable(true);
            $("#" + this.controlId).data("kendoComboBox").input.closest(".k-input").removeClass("clReadOnly");
            this.setValue(this.item[this.propertyId], diffValue);
            // get possibleparentfields
            let data = [];
            let allRelatedFields = [];
            $.each(selectedItems, (idx, selItem) => {
                allRelatedFields = allRelatedFields.concat(that.designer.clControlFactory.GetCompleteRelatedFields(selItem.id));
            });
            $.each(that.designer.clControlFactory.Fields(), (idx, value) => {
                let isSelectedField = false;
                $.each(selectedItems, (idx, selItem) => {
                    if (selItem.id === value["id"])
                        isSelectedField = true;
                });
                let isLinkedField = false;
                if (allRelatedFields.findIndex(field => field.id === value.id) !== -1)
                    isLinkedField = true;
                if (!isSelectedField && value["datatype"] === "List" && !isLinkedField) {
                    if ((!value["linkedfield"] || (value["linkedfield"] === value["id"])) && value["dataname"]) {
                        // check selfref
                        if (!(value["isselfrefft"] && that.item["controltype"] !== "Combobox")) {
                            let entry = { "id": value["id"], "name": that.designer.clControlFactory.getLabelText(value["labels"], that.designer.clControlFactory.userUILangId, that.designer.clControlFactory.instance.langid) + " (" + value["externalid"] + ")" };
                            data.push(entry);
                        }
                    }
                }
            });
            $("#" + this.controlId).data("kendoComboBox").setDataSource(new kendo.data.DataSource({ data }));
        }
        this.highlightMandatory();
        this.updatePropertyColor();
    }
}
class PropertyBarcodeItem extends PropertyBaseItem {
    constructor(designer, propertyId, propertyName, mandatory) {
        super(designer, propertyId, propertyName, undefined, mandatory);
    }
    init(jQueryElem) {
        super.init(jQueryElem);
        let that = this;
        let useBarcodeLabel = $("<label style='overflow-wrap: break-word;display:inline-block;vertical-align:middle;width:50%;' > " + Utilities_1.synUtil.Strings.getValue("clusebarcodeproperty") + "</label>").appendTo(that.controlcontainer);
        that.useBarcodeInput = $("<input id='" + this.controlId + "_usebarcodeinput' type='checkbox' class='clListItem'/>").appendTo(that.controlcontainer);
        that.useBarcodeInput.change(() => {
            let oldValue = that.item[that.propertyId];
            let value = that.useBarcodeInput.prop("checked");
            that.item["usebarcode"] = value;
            if (!value) {
                that.item["barcoderegex"] = undefined;
                that.item["barcodecolumn"] = undefined;
                that.item["barcodetypes"] = [];
            }
            else
                that.item["barcodetypes"] = ["2048"];
            that.EnableProperties();
            $.each(that.selectedItems, (idx, item) => {
                item["usebarcode"] = value;
                if (!value) {
                    item["barcoderegex"] = undefined;
                    item["barcodecolumn"] = undefined;
                    item["barcodetypes"] = [];
                }
                else
                    item["barcodetypes"] = ["2048"];
                that.designer.updateControl(item, that.propertyId, oldValue);
            });
            that.notifyChange();
            that.designer.updateProperties(that.selectedItems, true);
        });
        $("<label style='overflow-wrap: break-word;display:block;vertical-align:middle;' > " + Utilities_1.synUtil.Strings.getValue("clbarcodetypeslabel") + "</label>").appendTo(that.controlcontainer);
        that.barcodeFormatMultiSelect = $("<select id='" + this.controlId + "_barcodetypeselect' class='clInput' style='overflow-wrap: break-word;display:block;vertical-align:middle;'>").appendTo(that.controlcontainer);
        let data = [
            { text: "AZTEC", value: "1" },
            { text: "CODABAR", value: "2" },
            { text: "CODE_39", value: "4" },
            { text: "CODE_93", value: "8" },
            { text: "CODE_128", value: "16" },
            { text: "DATA_MATRIX", value: "32" },
            { text: "EAN_8", value: "64" },
            { text: "EAN_13", value: "128" },
            { text: "ITF", value: "256" },
            { text: "MAXICODE", value: "512" },
            { text: "PDF_417", value: "1024" },
            { text: "QR_CODE", value: "2048" },
            { text: "RSS_14", value: "4096" },
            { text: "RSS_EXPANDED", value: "8192" },
            { text: "UPC_A", value: "16384" },
            { text: "UPC_E", value: "32768" },
            { text: "All_1D", value: "61918" },
            { text: "UPC_EAN_EXTENSION", value: "65536" },
            { text: "MSI", value: "131072" },
            { text: "PLESSEY", value: "262144" },
            { text: "IMB", value: "524288" },
        ];
        that.barcodeFormatMultiSelect.kendoMultiSelect({
            dataTextField: "text",
            dataValueField: "value",
            noDataTemplate: kendo.htmlEncode(Utilities_1.synUtil.Strings.getValue("dynpnomatchingitemfound")),
            dataSource: data,
            change(e) {
                let oldValue = that.item["barcodetypes"];
                that.barcodeFormatMultiSelect.parent().find(".k-multiselect").removeAttr("placeholder");
                let value = that.barcodeFormatMultiSelect.data("kendoMultiSelect").value();
                that.item["barcodetypes"] = value;
                $.each(that.selectedItems, (idx, item) => {
                    item["barcodetypes"] = value;
                    that.designer.updateControl(item, that.propertyId, oldValue);
                });
                that.notifyChange();
            },
        });
        $("<label style='overflow-wrap: break-word;display:block;vertical-align:middle;' > " + Utilities_1.synUtil.Strings.getValue("clbarcoderegexlabel") + "</label>").appendTo(that.controlcontainer);
        that.barcodeRegEx = $("<input id='" + this.controlId + "_regex' style='width:100%;' class='clInput k-textbox'/>").appendTo(that.controlcontainer);
        that.barcodeRegEx.on("input", function (e) {
            that.barcodeRegEx.removeAttr("placeholder");
            let oldValue = that.item["barcoderegex"];
            let value = that.barcodeRegEx.val();
            that.item["barcoderegex"] = value;
            $.each(that.selectedItems, (idx, item) => {
                item["barcoderegex"] = value;
                that.designer.updateControl(item, that.propertyId, oldValue);
            });
            that.notifyChange();
        });
        that.barcodeColumnLabel = $("<label style='overflow-wrap: break-word;display:inline-block;vertical-align:middle;' > " + Utilities_1.synUtil.Strings.getValue("clbarcodecolumnlabel") + "</label>").appendTo(that.controlcontainer);
        that.barcodeColumn = $("<input id='" + this.controlId + "_barcodecolumn' style='width:100%;' class='clInput'/>").appendTo(that.controlcontainer);
        that.barcodeColumn.kendoComboBox({
            dataTextField: "id",
            dataValueField: "id",
            filter: "contains",
            noDataTemplate: kendo.htmlEncode(Utilities_1.synUtil.Strings.getValue("dynpnomatchingitemfound")),
            change(e) {
                let oldValue = that.item["barcodecolumn"];
                that.barcodeColumn.parent().find("input.k-input").removeAttr("placeholder");
                let value = that.barcodeColumn.data("kendoComboBox").value();
                that.item["barcodecolumn"] = value;
                $.each(that.selectedItems, (idx, item) => {
                    item["barcodecolumn"] = value;
                    that.designer.updateControl(item, that.propertyId, oldValue);
                });
                that.designer.updateLocalCollectionColumns(that.item["dataname"], value, undefined);
                that.notifyChange();
            },
        });
        this.setVisibility(false);
    }
    setValue(value, diffValue) {
    }
    getValue() {
    }
    setItem(item, selectedItems, diffValue, diffProperties) {
        super.setItem(item, selectedItems, diffValue, diffProperties);
        let that = this;
        this.useBarcodeInput.prop("indeterminate", false);
        if (this.item["usebarcode"] == undefined || this.item["usebarcode"] == undefined)
            this.useBarcodeInput.prop("checked", false);
        else
            this.useBarcodeInput.prop("checked", this.item["usebarcode"]);
        that.EnableProperties();
        that.barcodeColumn.data("kendoComboBox").setDataSource(new kendo.data.DataSource({
            serverFiltering: true,
            requestStart: function requestStart(e) {
            },
            requestEnd: function requestEnd(e) {
            },
            transport: {
                read: function read(options) {
                    let collection;
                    $.each(that.designer.clControlFactory.instance.collections, (idx, value) => {
                        if (value.id === that.item["dataname"]) {
                            collection = value;
                        }
                    });
                    if (collection) {
                        if (!collection.isft) {
                            let columns = [];
                            $.each(collection.columns, (idx, value) => {
                                columns.push({ id: value });
                            });
                            options.success(columns);
                        }
                        else {
                            Utilities_1.synUtil.getAJAXData({
                                url: Utilities_1.synUtil.getWSUrl("ChecklistGetForeignTableColumns") + that.item["dataname"],
                                done(ftColumns) {
                                    let columns = [];
                                    $.each(ftColumns, (idx, ft) => {
                                        columns.push({ id: ft });
                                    });
                                    options.success(columns);
                                }
                            });
                        }
                    }
                    else
                        options.success([]);
                },
            }
        }));
        that.barcodeRegEx.removeAttr("placeholder");
        that.barcodeRegEx.val(this.item["barcoderegex"]);
        that.barcodeColumn.parent().find("input.k-input").removeAttr("placeholder");
        that.barcodeFormatMultiSelect.data("kendoMultiSelect").options.placeholder = undefined;
        if (diffProperties) {
            $.each(diffProperties, (idx, property) => {
                switch (property) {
                    case "usebarcode":
                        that.useBarcodeInput.prop("indeterminate", true);
                        break;
                    case "barcodecolumn":
                        that.barcodeColumn.parent().find("input.k-input").attr("placeholder", Utilities_1.synUtil.Strings.getValue("cldiffpropertylabel"));
                        break;
                    case "barcoderegex":
                        that.barcodeRegEx.attr("placeholder", Utilities_1.synUtil.Strings.getValue("cldiffpropertylabel"));
                        break;
                    case "barcodetypes":
                        that.barcodeFormatMultiSelect.data("kendoMultiSelect").options.placeholder = Utilities_1.synUtil.Strings.getValue("cldiffpropertylabel");
                        break;
                }
            });
        }
        if (this.item["barcodetypes"] == undefined || this.item["barcodetypes"] == undefined)
            this.barcodeFormatMultiSelect.data("kendoMultiSelect").value("");
        else
            this.barcodeFormatMultiSelect.data("kendoMultiSelect").value(this.item["barcodetypes"]);
        if (this.item["barcodecolumn"] == undefined || this.item["barcodecolumn"] == undefined)
            this.barcodeColumn.data("kendoComboBox").value("");
        else
            that.barcodeColumn.data("kendoComboBox").value(this.item["barcodecolumn"]);
        this.highlightMandatory();
        this.updatePropertyColor();
    }
    EnableProperties() {
        if (this.item["usebarcode"]) {
            this.barcodeRegEx.removeAttr("readonly");
            this.barcodeRegEx.removeClass("clReadOnly");
            this.barcodeFormatMultiSelect.data("kendoMultiSelect").enable(true);
            this.barcodeFormatMultiSelect.data("kendoMultiSelect").input.closest(".k-multiselect").removeAttr("readonly");
            this.barcodeFormatMultiSelect.data("kendoMultiSelect").input.closest(".k-multiselect-wrap").removeClass("clReadOnly");
        }
        else {
            this.barcodeRegEx.attr("readonly", "readonly");
            this.barcodeRegEx.addClass("clReadOnly");
            this.barcodeFormatMultiSelect.data("kendoMultiSelect").enable(false);
            this.barcodeFormatMultiSelect.data("kendoMultiSelect").input.closest(".k-multiselect").attr("readonly", "readonly");
            this.barcodeFormatMultiSelect.data("kendoMultiSelect").input.closest(".k-multiselect-wrap").addClass("clReadOnly");
        }
        if (this.item["controltype"] === "Combobox" && this.item["usebarcode"]) {
            this.barcodeColumnLabel.show();
            this.barcodeColumn.data("kendoComboBox").wrapper.show();
            this.barcodeColumn.data("kendoComboBox").enable(true);
            this.barcodeColumn.data("kendoComboBox").input.closest(".k-input").removeClass("clReadOnly");
        }
        else {
            this.barcodeColumnLabel.hide();
            this.barcodeColumn.data("kendoComboBox").wrapper.hide();
            this.barcodeColumn.data("kendoComboBox").enable(false);
            this.barcodeColumn.data("kendoComboBox").input.closest(".k-input").addClass("clReadOnly");
        }
    }
    highlightMandatory() {
        let columnSet = this.item["barcodecolumn"] ? true : false;
        let typeSet = this.item["barcodetypes"] && this.item["barcodetypes"].length > 0 ? true : false;
        let highlightMandatory = !typeSet || (this.item["datatype"] === "List" && !columnSet);
        if (this.item["usebarcode"] && highlightMandatory)
            $("#" + this.controlId + "_container").addClass("clMandatoryProperty");
        else
            $("#" + this.controlId + "_container").removeClass("clMandatoryProperty");
        this.designer.updateItemsInfo(this.selectedItems);
    }
}
class PropertyVariableItem extends PropertyBaseItem {
    constructor(designer, propertyId, propertyName, mandatory) {
        super(designer, propertyId, propertyName, undefined, mandatory);
    }
    init(jQueryElem) {
        super.init(jQueryElem);
        let that = this;
        that.currentUserIdContainer = $("<div style='width:100%;display:block' />").appendTo(that.controlcontainer);
        that.currentTimeContainer = $("<div style='width:100%;display:block' />").appendTo(that.controlcontainer);
        that.currentDateContainer = $("<div style='width:100%;display:block' />").appendTo(that.controlcontainer);
        that.currentDateTimeContainer = $("<div style='width:100%;display:block' />").appendTo(that.controlcontainer);
        // CurrentUserId
        $("<label style='overflow-wrap: break-word;display:inline-block;vertical-align:middle;width:50%;' > " + Utilities_1.synUtil.Strings.getValue("clcurrentuseridvariableproperty") + "</label>").appendTo(that.currentUserIdContainer);
        that.currentUserIdInput = $("<input id='" + this.controlId + "_currentuseridinput' type='checkbox' class='clListItem'/>").appendTo(that.currentUserIdContainer);
        that.currentUserIdInput.change(() => {
            let value = that.currentUserIdInput.prop("checked");
            if (value) {
                if (!that.item["variables"])
                    that.item["variables"] = [];
                if (that.item["variables"].indexOf("CurrentUserId") === -1)
                    that.item["variables"].push("CurrentUserId");
            }
            else {
                let idx = that.item["variables"].indexOf("CurrentUserId");
                that.item["variables"].splice(idx, 1);
            }
            $.each(that.selectedItems, (idx, item) => {
                if (value) {
                    if (!item["variables"])
                        item["variables"] = [];
                    if (item["variables"].indexOf("CurrentUserId") === -1)
                        item["variables"].push("CurrentUserId");
                }
                else {
                    let idxToDelete = item["variables"].indexOf("CurrentUserId");
                    item["variables"].splice(idxToDelete, 1);
                }
            });
            that.notifyChange();
        });
        // CurrentTime
        $("<label style='overflow-wrap: break-word;display:inline-block;vertical-align:middle;width:50%;' > " + Utilities_1.synUtil.Strings.getValue("clcurrenttimevariableproperty") + "</label>").appendTo(that.currentTimeContainer);
        that.currentTimeInput = $("<input id='" + this.controlId + "_currenttimeinput' type='checkbox' class='clListItem'/>").appendTo(that.currentTimeContainer);
        that.currentTimeInput.change(() => {
            let value = that.currentTimeInput.prop("checked");
            if (value) {
                if (!that.item["variables"])
                    that.item["variables"] = [];
                if (that.item["variables"].indexOf("CurrentTime") === -1)
                    that.item["variables"].push("CurrentTime");
            }
            else {
                let idx = that.item["variables"].indexOf("CurrentTime");
                that.item["variables"].splice(idx, 1);
            }
            $.each(that.selectedItems, (idx, item) => {
                if (value) {
                    if (!item["variables"])
                        item["variables"] = [];
                    if (item["variables"].indexOf("CurrentTime") === -1)
                        item["variables"].push("CurrentTime");
                }
                else {
                    let idxToDelete = item["variables"].indexOf("CurrentTime");
                    item["variables"].splice(idxToDelete, 1);
                }
            });
            that.notifyChange();
        });
        // CurrentDate
        $("<label style='overflow-wrap: break-word;display:inline-block;vertical-align:middle;width:50%;' > " + Utilities_1.synUtil.Strings.getValue("clcurrentdatevariableproperty") + "</label>").appendTo(that.currentDateContainer);
        that.currentDateInput = $("<input id='" + this.controlId + "_currentdateinput' type='checkbox' class='clListItem'/>").appendTo(that.currentDateContainer);
        that.currentDateInput.change(() => {
            let value = that.currentDateInput.prop("checked");
            if (value) {
                if (!that.item["variables"])
                    that.item["variables"] = [];
                if (that.item["variables"].indexOf("CurrentDate") === -1)
                    that.item["variables"].push("CurrentDate");
            }
            else {
                let idx = that.item["variables"].indexOf("CurrentDate");
                that.item["variables"].splice(idx, 1);
            }
            $.each(that.selectedItems, (idx, item) => {
                if (value) {
                    if (!item["variables"])
                        item["variables"] = [];
                    if (item["variables"].indexOf("CurrentDate") === -1)
                        item["variables"].push("CurrentDate");
                }
                else {
                    let idxToDelete = item["variables"].indexOf("CurrentDate");
                    item["variables"].splice(idxToDelete, 1);
                }
            });
            that.notifyChange();
        });
        // CurrentDateTime
        $("<label style='overflow-wrap: break-word;display:inline-block;vertical-align:middle;width:50%;' > " + Utilities_1.synUtil.Strings.getValue("clcurrentdatetimevariableproperty") + "</label>").appendTo(that.currentDateTimeContainer);
        that.currentDateTimeInput = $("<input id='" + this.controlId + "_currentdatetimeinput' type='checkbox' class='clListItem'/>").appendTo(that.currentDateTimeContainer);
        that.currentDateTimeInput.change(() => {
            let value = that.currentDateTimeInput.prop("checked");
            if (value) {
                if (!that.item["variables"])
                    that.item["variables"] = [];
                if (that.item["variables"].indexOf("CurrentDateTime") === -1)
                    that.item["variables"].push("CurrentDateTime");
            }
            else {
                let idx = that.item["variables"].indexOf("CurrentDateTime");
                that.item["variables"].splice(idx, 1);
            }
            $.each(that.selectedItems, (idx, item) => {
                if (value) {
                    if (!item["variables"])
                        item["variables"] = [];
                    if (item["variables"].indexOf("CurrentDateTime") === -1)
                        item["variables"].push("CurrentDateTime");
                }
                else {
                    let idxToDelete = item["variables"].indexOf("CurrentDateTime");
                    item["variables"].splice(idxToDelete, 1);
                }
            });
            that.notifyChange();
        });
        this.setVisibility(false);
    }
    setValue(value, diffValue) {
    }
    getValue() {
    }
    setItem(item, selectedItems, diffValue, diffProperties) {
        super.setItem(item, selectedItems, diffValue, diffProperties);
        let that = this;
        that.currentUserIdInput.prop("checked", false);
        that.currentUserIdInput.prop("indeterminate", false);
        that.currentUserIdContainer.hide();
        that.currentDateTimeInput.prop("checked", false);
        that.currentDateTimeInput.prop("indeterminate", false);
        that.currentDateTimeContainer.hide();
        that.currentDateInput.prop("checked", false);
        that.currentDateInput.prop("indeterminate", false);
        that.currentDateContainer.hide();
        that.currentTimeInput.prop("checked", false);
        that.currentTimeInput.prop("indeterminate", false);
        that.currentTimeContainer.hide();
        if (this.item["controltype"] === "Input") {
            switch (this.item["datatype"]) {
                case "Integer":
                    that.currentUserIdContainer.show();
                    break;
                case "Date":
                    that.currentDateContainer.show();
                    break;
                case "Time":
                    that.currentTimeContainer.show();
                    break;
                case "Datetime":
                    that.currentDateTimeContainer.show();
                    break;
            }
        }
        else if (this.item["controltype"] === "Combobox") {
            that.currentUserIdContainer.show();
        }
        if (that.item["variables"]) {
            $.each(that.item["variables"], (idx, variable) => {
                switch (variable) {
                    case "CurrentUserId":
                        that.currentUserIdInput.prop("checked", true);
                        break;
                    case "CurrentTime":
                        that.currentTimeInput.prop("checked", true);
                        break;
                    case "CurrentDate":
                        that.currentDateInput.prop("checked", true);
                        break;
                    case "CurrentDateTime":
                        that.currentDateTimeInput.prop("checked", true);
                        break;
                }
            });
        }
        if (diffProperties) {
            $.each(diffProperties, (idx, property) => {
                switch (property) {
                    case "CurrentUserId":
                        that.currentUserIdInput.prop("indeterminate", true);
                        break;
                    case "CurrentTime":
                        that.currentTimeInput.prop("indeterminate", true);
                        break;
                    case "CurrentDate":
                        that.currentDateInput.prop("indeterminate", true);
                        break;
                    case "CurrentDateTime":
                        that.currentDateTimeInput.prop("indeterminate", true);
                        break;
                }
            });
        }
        this.highlightMandatory();
        this.updatePropertyColor();
    }
}
class ProopertyTelephoneItem extends PropertyBaseItem {
    constructor(designer, propertyId, propertyName, mandatory) {
        super(designer, propertyId, propertyName, undefined, mandatory);
    }
    init(jQueryElem) {
        super.init(jQueryElem);
        let that = this;
        $("<label style='overflow-wrap: break-word;display:inline-block;vertical-align:middle;width:50%;' > " + Utilities_1.synUtil.Strings.getValue("clistelnrproperty") + "</label>").appendTo(that.controlcontainer);
        that.isTelNrInput = $("<input id='" + this.controlId + "_istelnrinput' type='checkbox' class='clListItem'/>").appendTo(that.controlcontainer);
        that.isTelNrInput.change(() => {
            let oldValue = that.item[that.propertyId];
            let value = that.isTelNrInput.prop("checked");
            that.item["istelnr"] = value;
            that.EnableProperties();
            $.each(that.selectedItems, (idx, item) => {
                item["istelnr"] = value;
                that.designer.updateControl(item, that.propertyId, oldValue);
            });
            that.notifyChange();
            that.designer.updateProperties(that.selectedItems, true);
        });
        that.telNrColumnLabel = $("<label style='overflow-wrap: break-word;display:inline-block;vertical-align:middle;' > " + Utilities_1.synUtil.Strings.getValue("cltelnrcolumnlabel") + "</label>").appendTo(that.controlcontainer);
        that.telNrColumnInput = $("<input id='" + this.controlId + "_telnrcolumn' style='width:100%;' class='clInput'/>").appendTo(that.controlcontainer);
        that.telNrColumnInput.kendoComboBox({
            dataTextField: "id",
            dataValueField: "id",
            filter: "contains",
            noDataTemplate: kendo.htmlEncode(Utilities_1.synUtil.Strings.getValue("dynpnomatchingitemfound")),
            change(e) {
                let oldValue = that.item["telnrcolumn"];
                that.telNrColumnInput.parent().find("input.k-input").removeAttr("placeholder");
                let value = that.telNrColumnInput.data("kendoComboBox").value();
                that.item["telnrcolumn"] = value;
                $.each(that.selectedItems, (idx, item) => {
                    item["telnrcolumn"] = value;
                    that.designer.updateControl(item, that.propertyId, oldValue);
                });
                that.designer.updateLocalCollectionColumns(that.item["dataname"], value, undefined);
                that.notifyChange();
            },
        });
        this.setVisibility(false);
    }
    setValue(value, diffValue) {
    }
    getValue() {
    }
    setItem(item, selectedItems, diffValue, diffProperties) {
        super.setItem(item, selectedItems, diffValue, diffProperties);
        let that = this;
        that.isTelNrInput.prop("indeterminate", false);
        if (that.item["istelnr"] == undefined || that.item["istelnr"] == undefined)
            that.isTelNrInput.prop("checked", false);
        else
            that.isTelNrInput.prop("checked", that.item["istelnr"]);
        that.EnableProperties();
        that.telNrColumnInput.data("kendoComboBox").setDataSource(new kendo.data.DataSource({
            serverFiltering: true,
            requestStart: function requestStart(e) {
            },
            requestEnd: function requestEnd(e) {
            },
            transport: {
                read: function read(options) {
                    let collection;
                    $.each(that.designer.clControlFactory.instance.collections, (idx, value) => {
                        if (value.id === that.item["dataname"]) {
                            collection = value;
                        }
                    });
                    if (collection) {
                        if (!collection.isft) {
                            let columns = [];
                            $.each(collection.columns, (idx, value) => {
                                columns.push({ id: value });
                            });
                            options.success(columns);
                        }
                        else {
                            Utilities_1.synUtil.getAJAXData({
                                url: Utilities_1.synUtil.getWSUrl("ChecklistGetForeignTableColumns") + that.item["dataname"],
                                done(ftColumns) {
                                    let columns = [];
                                    $.each(ftColumns, (idx, ft) => {
                                        columns.push({ id: ft });
                                    });
                                    options.success(columns);
                                }
                            });
                        }
                    }
                    else
                        options.success([]);
                },
            }
        }));
        if (diffProperties) {
            $.each(diffProperties, (idx, property) => {
                switch (property) {
                    case "istelnr":
                        that.isTelNrInput.prop("indeterminate", true);
                        break;
                    case "telnrcolumn":
                        that.telNrColumnInput.parent().find("input.k-input").attr("placeholder", Utilities_1.synUtil.Strings.getValue("cldiffpropertylabel"));
                        break;
                }
            });
        }
        if (that.item["telnrcolumn"] == undefined || that.item["telnrcolumn"] == undefined)
            that.telNrColumnInput.data("kendoComboBox").value("");
        else
            that.telNrColumnInput.data("kendoComboBox").value(that.item["telnrcolumn"]);
        that.highlightMandatory();
        that.updatePropertyColor();
    }
    EnableProperties() {
        if (this.item["istelnr"] && this.item["controltype"] === "Combobox") {
            this.telNrColumnLabel.show();
            this.telNrColumnInput.data("kendoComboBox").wrapper.show();
            this.telNrColumnInput.data("kendoComboBox").enable(true);
            this.telNrColumnInput.data("kendoComboBox").input.closest(".k-input").removeClass("clReadOnly");
        }
        else {
            this.telNrColumnLabel.hide();
            this.telNrColumnInput.data("kendoComboBox").wrapper.hide();
            this.telNrColumnInput.data("kendoComboBox").enable(false);
            this.telNrColumnInput.data("kendoComboBox").input.closest(".k-input").addClass("clReadOnly");
        }
    }
    highlightMandatory() {
        if (this.item["istelnr"] && this.item["controltype"] === "Combobox" && !this.item["telnrcolumn"])
            $("#" + this.controlId + "_container").addClass("clMandatoryProperty");
        else
            $("#" + this.controlId + "_container").removeClass("clMandatoryProperty");
        this.designer.updateItemsInfo(this.selectedItems);
    }
}
